import { saveTheSaleFromDataAEM } from '../action/buildProduct';
import couponInfo from '../components/couponInfo';
import { replaceSpecialOffers } from '../containers/midnight/services/dataFormatter';
import { BuildProduct, DOFlow, Service, FlowRoute } from './../constants/actionType'
import { InHomeUtils } from './../util/inhomeUtils'
const initialState = {
    internet: {
        mm3Qualified: false,
        vzEmployee: false,
        disconnected: false,
        orderSumFlag: false,
        miniCartOrderSumFlag: false,
        fccLearnData: {},
        enableOrderSumThrottle: false,
        enableAuotpayThrottle:false,
        isMM2PlansAvailable: false,
        isMM3PlansAvailable: false,
        isMM3PageVersion: false,
        isDataOnProfile: false,
        mnhSignupIndicator : "",
        strikePrice : '',
        typeofDiscount: '',
        typeOfDiscountScenario: '',
        mm3internetsubprod : null,
        m2mPlans: [],
        twoYearPlans: [],
        selectedProduct: null,
        isAccordionOpen: false,
        isAddPerksOSI:false,
        isSubAccordionOpen: false,
        accordionStatus: '',
        subAccordionStatus: '',
        contract: 'MTM',
        speedCode: '',
        isocInfo:'',
        allSpeedCodes: [],
        selfInstallMesssage: '',
        isShowMorePlans: false,
        expandOnPageLoad: true,
        selectCtaSpeed: false,
        showPlanDetails: false,
        visitflag: false,
        nflActiveOnProfile: false,
        isInstallFeeWaivedAllPrd: false,
        mobileViewInternetTileExpander:{'947':false,'941': false,'940': false,'939': false},
        //gigTileMessage: {}
        isLeadListAddress:false,
        isFeeWaivedForAll : false,
        legSTBLeadLstCust: false,
        hnm_status_code: '',
        containerOption: '',
        containerManagementNeeded: false,
        choiceOfferName: '',
        choiceOffersCount: 0
    },
    tv: {
        m2mPlans: [],
        twoYearPlans: [],
        masterpackageview: [],
        basicdiffPlans: [],
        customTV: {
            plans: [],
            selectedProduct: null,
            isAccordionOpen: false,
            accordionStatus: 'required',
            changePackage: false
        },
        spanishTV:false,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen: false,
        accordionStatus: '',
        subAccordionStatus: '',
        contract: 'MTM',
        localChannelMsg: false,
        isUltimateTestDriveEligible: false,
        ultimateTvUsoc: '',
        testdriveOptOut: false,
        utdNewRecommMsg: '',
        fiosTvOneEligible: false,
        vms1100Eligible:false,
        vms41001100Eligible:false,
        streamTvEligible: false,
        AndriodUpgradeEligible: false,
        fiosTvOneUpgradeOptions: [],
        FiosTvOneSelected: false ,
        VMSProductSelected: false,
        StreamTVProductSelected: false,
        fiosFiveBasicChannels: [],
        fiosFiveBasicChannelIsocs: {},
        fiosFiveRecommendedChannels: [],
        fiosFiveRecommendedChannelIsocs: [],
        fiosFiveSelectedChannels: [],
        fiosFiveSelectedChannelsProfile: [],
        fiosFiveSearchVhoParams: {
            regionId: undefined,
            lfa: undefined,
            lfaName: undefined,
            vhoName: undefined
        },
        fiosFiveSearchSuggestions: undefined,
        fiosFiveSearchMatchedChannels: undefined,
        isNewChannelSet: true,
        moreOption: {
            selectedProduct: false,
            isMoreOptAccordionOpen: false
        },
        fiosFive: {
            fiosFiveModal: 'intro',
            selectedChannels: []
        },
        vcpestbQty: '',
        fiosFiveDetailedChannel: {},
        disconnected: false,
        isTvOnProfile: false,
        allowMutliGigTVEnable: false,
        premiumQualified: false
    },
    voice: {
        plans: null,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen: false,
        accordionStatus: '',
        subAccordionStatus: '',
        disconnected: false,
        isRefNoChange: false,
        isVoiceOnProfile: false,
        isAccordionDisabled: false,
        isSkipFDVWithNGPON2:false
    },
    perks: {
        plans: null,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen:false,
        accordionStatus: 'optional',
        disconnected: false,
        isPerksOnProfile: false,
        isAccordionDisabled: false,
        removedProduct: null,
        mvaECPerks: {},
        netMaxOfferToggle : false
    },
    mvaPerks: {},
    scResumeProductsPlansMatchInfo:{
        isTvPlanMatchSet: "N",
        isDataPlanMatchSet: "N"
    },
    contract: {
        isAccordionOpen: false,
        isAccordionDisabled: true,
        isAccordionOpenRequired: false,
        contractType: "MTM",
        isContractSwitched: false
    },
    router: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required',
        moreOption: {
            isMoreOptAccordionOpen: false
        },
        upgradeRouter: null
    },
    accessPoint: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        buySelectedProduct: null,
    },
    rentAccessPoint: {
        rentSelectedProduct: null,
    },
    techsure: {
        techsureProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        vasChildList: null,
        enableVasChildList: false,
        isVzProtectHomeOpen:false,
        disconnected:false,
        disconnectedProducts:null,
        isHomeSecurityProductAdded:false,
        isHomeSecurityPlusProductAdded:false,
        isHomeSecurityProductRemoved:false,
        isDHSSecurityProductRemoved:false,

    },
    vhsBiller: {
        vhsProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        vhsChildList: null,
    },
    techsurecloud: {
        techsureCloud: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        vasChildList: null,
        enableVasChildList: false,
        disconnected:false
    },
    fne: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        isWholeHomeWifiAdded: false,
        whwExtenderProduct:null,
        unitCount: 0,
        isWholeHomeWifiPlusAdded: false,
        isWholeHomeWifi2Added: false
    },
    tvConnections: {
        equipments: null,
        displaySection: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required',
        unitCount: 0,
        profileDummyVRoom: null

    },
    vRoom: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required',
        unitCount: 0
    },
    ceApps: {
        equipments: null,
        displaySection: null,
        displayAccorSection: null,
        optInSelected: false,
        optOutSelected: false,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        loaderForEquipments:false,
        isCeappOnCsr: false,
    },
    fiosTvOne: {
        isAccordionOpen: false,
        accordionStatus: 'optional'
    },
    vms1100: {
        isAccordionOpen: false,
        accordionStatus: 'optional'
    },
    recording: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required'
    },
    dct: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required',
        isDCTEligible: false
    },
    channel: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        loaderForEquipments:false
    },
    internationalChannel: {
        equipments: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        loaderForEquipments:false,
        overlayLanguagePkg:null,
        onProfileProducts: null,
        removedProduct: null
    },
    intlCalling: {
        intlCallingProducts: null,
        selectedProduct: null,
        profileProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required',
        domesticCountry:false
    },
    winback: {
        winbackProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required'
    },
    listing: {
        listingProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required'
    },
    backup: {
        backupProducts: null,
        shipment: {
            shipmentProducts: null,
            selectedProduct: null,
            isAccordionOpen: false,
            accordionStatus: 'required'
        },
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'required',
        isShipmentAvailable: false,
        isShipmentRequired: false,
    },
    existingListing: {
        listingProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: ''
    },
    callingFeatures: {
        callingFeaturesProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: ''
    },
    intlPlans: {
        intlPlansProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional'
    },
    longDistance: {
        longDistanceProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: ''
    },
    wireMaintenance: {
        wireMaintenanceProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: ''
    },
    emergencyServices: {
        emergencyServicesProducts: null,
        selectedProduct: null,
        isAccordionOpen: false,
        accordionStatus: 'optional',
        notificationMethod: 'text',
        missingFieldError:false,
        eMailId: "",
        eMailErr: "",
        isValidMail: false,
        emailValidationResp:"",
        emailRegexValid:true,
        clickHereFlag:false,
        isSuppFlowEmergencyServiceSelected: false,
        email: {
            value: '',
            emailValid: false
        },
        mobile: {
            value: '',
            mobileValid: false
        }
    },
    loadedEquipments: {
        Init: true,
        Router: false,
        Perks:false,
        TechSure: false,
        TechSureclod: false,
        Fne: false,
        Vroom: false,
        Recording: false,
        DCT: false,
        Ceapps:false,
        Channel: false,
        InternationalChannel:false,
        OTT: false,
        Listing: false,
        Winback: false,
        Backup: false,
        Pyoac: false,
        CallingFeatures: false,
        IntlPlans: false,
        LongDistance: false,
        WireMaintenance: false,
        vhsBiller: false,
        dhsBiller:false,
    },
    pyoacProducts: null,
    focusAccordion: false,
    focusParentAccordion: false,
    istoggleMessage: false,
    istoggleBatteryMessage: false,
    istoggleDctMessage: false,
    customRouterCheck: false,
    customRouterName: '',
    customRouterType: '',
    buildprodLoaded: false,
    isGPONIONTEligible: false,
    isBannerChecked: false,
    isSmartCartFlow: false,
    TwoGigNotAllowedMessage: '',
    internationalCallingEnable: false,
    isMarvelOfferInCart: false,
    isIdleTimeCheckout: false,
    previousSelectedSpeed:'',
    isMarvelInPreviousSelSpd:false,
    isBostonDMA: false,
    isIONTStatus: false,
    isMNEnabled: false,
    isECMNEnabled:true,
    internetToggleYoutubePremium: false,
    internetTooglePerks:false,
    internetToogleMoves:false,
    openclassicmodal: false,
    ClassicHOOverlayCount : 1,
    buttonName: '',
    /*
        This classic MN changes might be needed in future. Hence instead of reverting, Setting value to default true as Classic flow MN should be in BAU screens for now.
    */
    mnFromApi: true,
    isDisneyPromoPresent: false,
    isNetmaxPromoEligible: false,
    splPromoOffersList: [],
    isAPDataEnabled: true,
    isStaticMnhEnable: false,
    isPopularPlan: false,
    isCustomizeFromPP: false,
    isMonarchView: false,
    togglePerkEc: false,
    newReviewOrderView: true,
    enableNewMiniCart: true,
    perksAddlInfo: {},
    perkMessages: {},
    ecCheckoutNew: true,
    showMockChoiceOffersEC: false,
    ecreskinBPP:true,
    requiredErrBanner: false,
    SweetnerMsg: {
        currentMsg: '',
        prevMsg: '',
        prevPromos: {
            INTERNET: [],
            TV: []
        },
        isDisplay: true
    },
    couponInfo: {
        coupon: '',
        couponerror: false,
        couponsuccess:false,
        couponremoved:false,
        couponisoc:"",
        referfriendvalidationsucess: false,
        referfriendvalidationfailure: false,
        isRAFCheckoutValidation: false
    },
    vzcCouponInfo: {
        vzcCoupon: '',
        vzcValidationSuccess: false,
        vzcValidationFailure: false,
        currentMsg: '',
        isDisplay: false,
        isvzcCheckoutValidation: false,
        isDiscountEligible: false,
        isDiscountApplied: false,
        vzcCouponRedeemed: false
    },
    ffCouponInfo: {
        ffCoupon: '',
        leadListID: '',
        ffCouponError: false,
        ffValidationSucess: false,
        ffValidationFailure: false,
        ffValidationErrorType: '',
        isFFCheckoutValidation: false,
        profileDataSpeed: '',
        profileFFDiscount: false
    },
    visPreCouponInfo: {
        visPreCoupon: '',
        leadListID: '',
        visPreCouponError: false,
        visPreValidationSucess: false,
        visPreValidationFailure: false,
        visPreValidationErrorType: '',
        isVisPreCheckoutValidation: false,
        isMnhAndTWSAppied:false,
        isDiscountEligible: false,
        isDiscountApplied: false
    },
    hboUnSupportedNotificationInfo: {
        addChannel: null,
        removeChannel: null,
        showNotification: false,
        swapStatus: false
    },
    banner: {
        imgUrl: "acc_hero_image.jpg",
        headerText: "Build your Own bundle",
        footerText: "The best deserves the best. Save $10 off your Verizon Wireless bill and your Verizon Fios bill - a total savings of $20 per month",
        bodyText: ""
    },
    requestTN: '',
    hasOwnTn: {
        ph1: '',
        ph2: '',
        ph3: '',
        portedTn: '',
        isPorted: false
    },
    isenableCheckout: false,
    offersEligible: '',
    contractConfig: { "data": { "1": [{ "Products": "ALL", "Contract": ["M2M"] }], "2": [{ "Products": "DATA,VIDEO", "Contract": ["M2M", "2YR"] }, { "Products": "DATA,FIOS_VOICE", "Contract": ["M2M"] }, { "Products": "VIDEO,FIOS_VOICE", "Contract": ["M2M"] }], "3": [{ "Products": "ALL", "Contract": ["M2M", "2YR"] }] } },
    fcpcontractConfig: { "data": { "1": [{ "Products": "ALL", "Contract": ["M2M"] }], "2": [{ "Products": "DATA,VIDEO", "Contract": ["M2M"] }, { "Products": "DATA,FIOS_VOICE", "Contract": ["M2M"] }, { "Products": "VIDEO,FIOS_VOICE", "Contract": ["M2M"] }], "3": [{ "Products": "ALL", "Contract": ["M2M"] }] } },
    doSmartCart: false,
    initLoadSec: 6000,
    selectedCoreServices: '',
    dobundle: {
        dobundleresponse: null,
        isStandalone: false
    },
    hoabundle: {
        hoaresponse: {
            contract: 'MTM',
            productMap: { },
            defaultMap: {
            },
            defaultUSocs: '',
            giginCart: false,
            customeTvCont :false,
          },
       // isStandalone: false
    },
    viewDetailContent: '',
    tellMeContent: '',
    disclaimerContentFragments: '',
    disclaimerProductsFragments: '',
    disclaimerCommonFragments: '',
    plansPromoFragments: '',
    faqBuildProductContent: '',
    productFragments: '',
    perksFragments: '',
    referafriendcallstart: false,
    ffCallStart: false,
    visPreCallStart:false,
    vzccValidationStart: false,
    currentCouponType: '',
    autoAddStadiaInCart: false,
    autoAddStadiaOfferToCart: false,
    autoAddMarvelInCart: false,
    autoAddMarvelOfferToCart: false,
    upsell: {
        ischeckoutBtnClicked: false,
        isUpsellAvailable: false,
        isUpsellAddedToCart: false,
        isUpsellDenied: false,
        isBundle: false,
        contract: '',
        bundleKey: '',
        oncartkey: '',
        services: '',
        products: null,
        product: null,
        price: '',
        offers: null,
        offersDesc: null,
        equipmentOffers: null,
        addlOffers: null,
        promos: null,
        header: '',
        headercontent: '',
        subheader: '',
        isUpsellCallInProgress: false,
        isnydma: false
    },
    contractoffer: {
        offersInCart: null,
        offerplansMTM: null,
        offerplans2YR: null,
        offerContract: ''
    },
    mm3internetsub :{
        offerplans: null,
        offerplansMTM: null,
        offerplans2YR: null,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen: false,
        accordionStatus: 'action required',
        subAccordionStatus: 'required',
        mm3internetsub:false
    },
    sploffer: {
        offerplans: null,
        offerplansMTM: null,
        offerplans2YR: null,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen: false,
        accordionStatus: 'action required',
        subAccordionStatus: 'required',
        isDataOffer: false,
        isTVOffer: false,
        data: {
            offerplansMTM: null,
            selectedProduct: null,
            isAccordionOpen: false,
            isSubAccordionOpen: false,
            accordionStatus: 'action required',
            subAccordionStatus: 'required',
        },
        tv: {
            offerplansMTM: null,
            selectedProduct: null,
            isAccordionOpen: false,
            isSubAccordionOpen: false,
            accordionStatus: 'action required',
            subAccordionStatus: 'required',
        },

    },
    flashoffer: {
        offerplans: null,
        offerplansMTM: null,
        offerplans2YR: null,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen: false,
        accordionStatus: 'action required',
        subAccordionStatus: 'required',
        isFlashOffer:false
    },
    streamServ: {
        streamServProd: null,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen: false,
        accordionStatus: 'completed',
        subAccordionStatus: 'optional',
        isYoutubeOnCsr: false,
        removedProduct: null,
        isSlingOnCsr: false
    },
    slingStreamServ: {
        selectedProduct: null
    },
    streamDev: {
        streamDevProd: null,
        selectedProduct: null,
        isAccordionOpen: false,
        isSubAccordionOpen: false,
        accordionStatus: 'optional',
        subAccordionStatus: 'optional'
    },
    streamDevCount: {
        streamDevCountProd: null,
        selectedCount: '',
        isAccordionOpen: false,
        accordionStatus: 'optional',
        selectedProduct: null,
    },
    nonSupportedProduct: {
        coreProduct: { data: [], tv: [], voice: [] },
        subProduct: { data: [], tv: [], voice: [] },
        dataProducts: [], tvProducts: [], voiceProducts: [], prodsCount: 0
    },
    emergencyNotification: {
        displayVroomMsg: false,
        autoAdd100MInCart: false,
        isGPONMochaEligible: false
    },
    errorMsgRemoveService: false,
    mobileandhomeEligible: false,
    productOnProfileStatus: {
        internet: false,
        router: false,
        fne: false,
        tv: false,
        vRoom: false,
        recording: false,
        channel: false,
        internationalChannel:false,
        streaming: false,
        voice: false,
        listing: false,
        batteryBackup: false,
        techsure: false,
        techsurecloud: false,
        callingFeatures: false,
        intlPlans: false,
        longDistance: false,
        wireMaintenance: false,
        vhsBiller: false,
        dhsBiller:false,
    },
    ecbannerMessage: '',
    footerMessage:"",
    makechangehits:0,
    splMsgPYP:false,
    defaultAccordion: '',
    planCalled:false,
    sweetnerReducer:{
        vroom:{
            header:"You made a change to your service.",
            body:"Return unneeded equipment. If you don't, you will continue to pay the monthly charges for it.",
            visible:false,
        },
        router:{
            header:"You made a change to your service.",
            body:"Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item.",
            visible:false,
            autoAdd:false,
            profileWhwReplaceChrRouterWhw:false,
            profileWhwReplaceChrRouterWhwBody:"<div>Your current equipment will not work with your new 2 Gigabit service. An upgraded router has been added to your order.</br> Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item.",
            profileBhrxReplaceChrRouterWhw:false,
            profileBhrxReplaceChrRouterWhwBody:"<div>Your current equipment will not work with your new 2 Gigabit service and has been upgraded with this order.</br> Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item."
        },
        whwRouter: {
            header: "<div class='bold'>You are now entitled to Whole Home Wi-Fi on us.</div>",
            body: "It includes the most advanced router we offer and 1 Wi-Fi Extender (if needed, to optimize your internet) all on us. Select it, if interested.",
            visible: false
        },
        tv:{
            header:"",
            headerFD:"You made a change to your service.",
            headerPD:"You made a change to your service",
            body:"Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item",
            visible:false,
        },
        fne:{
            header:"You made a change to your service.",
            body:"Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item.",
            visible:false,
        },
        fneWifi:{
            header:"",
            body:"<div class='bold'>We recommend running a Home Wi-Fi Health Check before requesting an extender.</div>",
            visible:false,
        },
        dvr:{
            header:"We'll ship your new equipment within 3 business days.",
            body:"Return old equipment, If you don't, you will continue to pay monthly charges for it.",
            visible:false,
        },

        fiostvone:{
            header:"We'll ship your new equipment within 3 business days.",
            body:"Return old equipment within 30 days to avoid unreturned equipment charges of up to $375 per item. Note: Digital Adapters and Cable CARDS work with the new equipment, so there's no need to return them.",
            visible:false,
        },
        fttpd_bolton:{
            header:"You made a change to your service.",
            body:"Changes to your internet speed will result in losing your complimentary Gigabit Connection upgrade.",
            visible:false,
        },
        speedDowngrade:{
            header:"You made a change to your service.",
            body:"Reducing your internet speed below Gigabit will increase your Mobile bill by $5/line per month.",
            visible:true,
        },
        speedDowngradeMnh:{
            header:"You made a change to your service.",
            body:"Reducing your speed will change your Mobile + Home Discount and increase your mobile bill by ",
            visible:true,
        },
        speedUpgrade:{
            header:"You made a change to your service.",
            body:"Save an additional $5/line per month on your Mobile bill when you upgrade to Fios Gigabit Connection or higher speed",
            visible:true,
        },
        speedUpgradeMnh:{
            header:"You made a change to your service.",
            body:"Increasing your speed will change your Mobile + Home Discount and decrease your mobile bill by ",
            visible:true,
        },
        fttpd:{
            header:"You made a change to your service.",
            body:"Please note one or more features included with Gigabit Connection may now incur a charge.",
            visible:false,
        },
        whwRouterChange:{
            header:"You made a change to your service.",
            body:"Since you no longer have Gigabit Connection, Whole-Home Wi-Fi is no longer included",
            visible:false,
        },
        whwplusRouterChange:{
            header:"You made a change to your service.",
            body:"Since you no longer have 2 Gig or 1 Gig Complete Package, Whole Home Wi-Fi Plus is no longer included.",
            visible:false,
        },
        discCloudChange:{
            header:"You made a change to your service.",
            body:"Verizon Cloud is no longer included, but we're providing a 30 day trial on us. $14.99/mo therafter. Cancel within 30 days at no charge.",
            visible:false,
        },
    },
    isClassicAccount:false,
    visionId:null,
    customerAddress:null,
    monId:null,
    shallAccountNumber:null,
    fwaState:null,
    wifiBackupStatus:'N',
    parentAccordian: {
        AddInternetMain: false,
        AddTvMain: false,
        AddStreamingMain: false,
        AddVoiceMain: false,
        AddPerksMain: false,
        contractaccordMain: false,
        manualSweetneraccordMain: false
    },
    accordianhierarchy: [
        { AddInternetMain: ['AddInternetReveal', 'networkExtender', 'RouterOptions', 'InternetSecurity', 'InternetEssential', 'CloudStorage', 'TechSupport', 'SecurityIdentity', 'EquipProtection'] },
        { AddStreamingMain: ['internetstreaming', 'hardwareStreaming'] },
        { AddTvMain: ['AddTvReveal', 'TvEquipmentChoices', 'FiosTvUpgrade','VMS1100UPGRADE','StreamingDevice', 'TvCustomPacks', 'TvPremiumChannels', 'ChooseCustomTV', 'TvDigitalAdapter', 'TvSetUpBox', 'TvRecording'] },
        { AddVoiceMain: ['AddVoiceReveal', 'Calling', 'International', 'FVINTLPLANCHANGE', 'WireMaintenance', 'Directory', 'AddBatteryBackup', 'LongDistance'] },
        { contractaccordMain: ['ContractAndOffers'] },
        { manualSweetneraccordMain: ['manualSweetneraccordMain'] }
    ],
    accordion: {
        AddInternetReveal: false,
        RouterOptions: false,
        networkExtender: false,
        internetstreaming: false,
        hardwareStreaming: false,
        AddTvReveal: false,
        TvEquipmentChoices: false,
        FiosTvUpgrade: false,
        StreamingDevice: false,
        TvCustomPacks: false,
        TvPremiumChannels: false,
        AddVoiceReveal: false,
        Calling: false,
        International: false,
        WireMaintenance: false,
        Directory: false,
        AddBatteryBackup: false,
        LongDistance: false,
        InternetSecurity: false,
        ContractAndOffers: false,
        InternetEssential: false,
        CloudStorage: false,
        TechSupport: false,
        SecurityIdentity: false,
        EquipProtection: false,
        OneClickUpgradeRecomm: false,
        QuantumTvUpgrade: false,
        NbonoproductRecomm: false,
        salesZoneBundleRecomm: false,
        salesZoneStandaloneRecomm: false,
        WifiBundleRecomm: false,
        SpecialOffers: false,
        ChooseCustomTV: false,
        TvDigitalAdapter: false,
        TvSetUpBox: false,
        TvRecording: false,
        FVINTLPLANCHANGE: false,
        VMS1100UPGRADE:false
    },
    viewDetails : {
        DAT:null,
        VID:null,
        FDV:null
    },
    pendingProdNotification : {
        displaySpecificErrorMessages : false
    },
    saveTheSale :{
        idleModalBanner: false,
        idleTimeOut: 1000 * 5,
        modalOpenCounter: 0,
        offerApplied: false,
        stsFlag: false,
        stsThrottleFlag:false,
        saveTheSaleFromDataAEM: null,
        displayOffertext:'',
        savetheSaleoffer: null,
        modalOpen:false,
        idleTimeoutfirstModalSeconds:'',
        pzaiPredictScore:'',
        pzaiFiospredictscore:'',        
        
    },
    isEcHeaderVisible:false,
    showConnectedApps:false,
    showConnectedAppsVRoomOverlay:false,
    showConnectedAppsCEAppsOverlay:false,
    showConnectionsChoices: false,
    slingonProfileMoves:false,
    slingnotinprofile:false,
    suppressInterstitial:false,
    suppressInvoke:false,
    upsellBanner:false,
    isCEAppsSetForSCFlow:false,
    isDataPerksSetForSCFlow:false,
    validatePerksForSCFlows:false,
    isVMSSetForSCFlow:false,
    isIntlCallingProductSetForSCFlow:false,
    enableVideoComparison:false,
    showComparisonView: false,
    idleModalBanner: false,
    idleTimeOut: 1000 * 15,
    offerApplied: false,
    modalOpenCounter: 0,
    profileCloudProduct: null,
    isMnhOfferElligble:false,
    disableTvVoice:false,
    disableTv:false,
    disableVoice:false,
    isChrFneQualified:false,
    returnedEquipmentCount:0,
    ecPromoDropped:false,
    ecQualifiedServices:[],
    isSelectedData500Or400:false,
    isbfpromo:false,
    isMnHCustomerDetail:false,
    isReskin : false,
    perkSectionAutoScroll: true,
    isProgressBarDisplayed : false ,
    mnhResponse: null,
    mnhMobileNumber: '',
    mnhZip: '',
    mnhTokenGenerationResponse: '',
    igVerificationInitialed: false,
    verifyButtonMnhStatus: false,
    mhVerificationCode: '',
    mnhStatus: '',
    mnhBannerStatus: "",
    offerIndicator: 'allOtherMarkets',
    isPromoKeywordFlow: false,
    fccLabelInfo: [],
    fccGrandFatheredLabelInfo: [],
    isACPFlag: false,
    mnhBannerFlag: false,
    reskinCartFlag: false,
    isTWSFlag : '',
    isTWSIneligibleFlow: false,
    defaultCeApps: null,
    tilesOrderDesignFlag: false,
    internetAccordionFlag:'',
    fccDataPega: true,
    isVZFwdFlag : false,
    isStreamlineRC : false,
    vzFwdId: "",
    isVZFCreditFlag: false,
    isVzfNYDiscount: false,
    isCloudStepDownEnabled: true,  // disabling flag functionality -chnage to false for enabling
    bppPageSignIn : '',
    isExpandAccordion : '',
    isIwmEligible: false,
    mnTileStyles: null,
    isCheckoutPerksModal: false,
    stickyheaderfooter: true,
    movesstickyheaderfooter:false,
    enableMovePerksOverlay:false,
    enableRoommateScenerioOnOSI : false,
    roommateOptionSelected: "",
    roommateErrorCase: false,
    movesordersummary: true,
    movesminicart: true,
    stickyProgressbar: false,
    enableAutopayOptThrottle:false,
    enableSaveCartStickyMobile : false,
    nsaThrottleResponse: "",
    isRedirectionFromPopular : false,
    isRedirectionToPopular: false,
    emberInfo: {
        hideEmber: false,
        isMF4MRKF15: true,
        isMF4DISC15: false,
        isEmberFlow: true,
    },
    accessoriesProductCount: 0,
    homeSecuritybillStartDate:null,
    punchoutSecurehome:false,
    punchoutSecurehomePlus:false,
    punchoutSecurehomeDtmTag:null,
    punchoutSecurehomeAction:null,
    homesecurityProdDark:false,
    apBuyCount: 0,
    upsellTagLimitFlag : false,
    isSercommFlow : false,
    isResumecartFlow : false,
    showRedCapForCeApp : false,
    lqStreamlineBanner:null,
    lqHomeLoaded: false,
    manualAccordionOpen: "",
    enablePerkRedesign:true,
    skipDefaultAccordion: false,
    isPerksSectionEnabled: false,
    recorProfileFlag : false,
    wirelessLoggedInStatus : false,
    perkRecommendationTestFlag : '',
    perkRecommendNotification : false
}

function replaceM2MSpecialOffers(m2mPlans) {
    try {
        if (Array.isArray(m2mPlans)) {
            return m2mPlans.map(plan => {
                if (Array.isArray(plan?.specialOffers)) {
                    return {
                        ...plan,
                        specialOffers: replaceSpecialOffers(plan?.specialOffers, plan),
                    };
                }
                return plan;
            });
        }
    } catch (e) {
        console.error(e);
    }
    return m2mPlans;
}

function buildProduct(state = initialState, action) {
    const NCFlow =
      !state.internet.isDataOnProfile &&
      !state.tv.isTvOnProfile &&
      !state.voice.isVoiceOnProfile;
    switch (action.type) {
        case "UPDATE_DEFAULT_ACCORDION":
            return Object.assign({}, state, {
                defaultAccordion:action.value
            })
        case "EQUIPMENT_LOAD_STATUS":
            let loadedequipments = Object.assign({}, state.loadedEquipments, {
                Init: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Init) ? action.value.Init : state.loadedEquipments.Init,
                Router: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Router) ? action.value.Router : state.loadedEquipments.Router,
                Perks: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Perks) ? action.value.Perks : state.loadedEquipments.Perks,
                Fne: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Fne) ? action.value.Fne : state.loadedEquipments.Fne,
                TechSure: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.TechSure) ? action.value.TechSure : state.loadedEquipments.TechSure,
                TechSurecloud: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.TechSurecloud) ? action.value.TechSurecloud : state.loadedEquipments.TechSurecloud,
                Vroom: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Vroom) ? action.value.Vroom : state.loadedEquipments.Vroom,
                Recording: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Recording) ? action.value.Recording : state.loadedEquipments.Recording,
                DCT: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.DCT) ? action.value.DCT : state.loadedEquipments.DCT,
                Channel: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Channel) ? action.value.Channel : state.loadedEquipments.Channel,
                Ceapps: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Ceapps) ? action.value.Ceapps :state.loadedEquipments.Ceapps,
                InternationalChannel: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.InternationalChannel) ? action.value.InternationalChannel : state.loadedEquipments.InternationalChannel,
                OTT: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.OTT) ? action.value.OTT : state.loadedEquipments.OTT,
                Listing: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Listing) ? action.value.Listing : state.loadedEquipments.Listing,
                Winback: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Winback) ? action.value.Winback : state.loadedEquipments.Winback,
                Backup: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Backup) ? action.value.Backup : state.loadedEquipments.Backup,
                Pyoac: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.Pyoac) ? action.value.Pyoac : state.loadedEquipments.Pyoac,
                CallingFeatures: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.CallingFeatures) ? action.value.CallingFeatures : state.loadedEquipments.CallingFeatures,
                IntlPlans: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.IntlPlans) ? action.value.IntlPlans : state.loadedEquipments.IntlPlans,
                LongDistance: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.LongDistance) ? action.value.LongDistance : state.loadedEquipments.LongDistance,
                WireMaintenance: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.WireMaintenance) ? action.value.WireMaintenance : state.loadedEquipments.WireMaintenance,
                vhsBiller : InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.vhsBiller) ? action.value.vhsBiller : state.loadedEquipments.vhsBiller,
                dhsBiller : InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.dhsBiller) ? action.value.dhsBiller : state.loadedEquipments.dhsBiller,
            })
            return Object.assign({}, state, {
                loadedEquipments: loadedequipments
            })
        case "RESET_BUILD_PRODUCT_STATE":
            return Object.assign({}, state, initialState);
            break;

        case "SET_DCT_ELIGIBLE":
            return Object.assign({}, state, {
                dct: Object.assign({}, state.dct, {
                    isDCTEligible: action.value
                })
            })
        case "UPDATE_INITLOADSEC":
            return Object.assign({}, state, {
                initLoadSec: action.value
            })
        case "SET_CHOICE_OFFER_NAME":
            let updateChoiceOfferName = Object.assign({}, state.internet, {
                choiceOfferName: action.value
            })
            return Object.assign({}, state, {
                internet: updateChoiceOfferName
            })

        case "SET_CHOICE_OFFERS_COUNT":
            let updateChoiceOfferCount = Object.assign({}, state.internet, {
                choiceOffersCount: action.value
            })
            return Object.assign({}, state, {
                internet: updateChoiceOfferCount
            })
        case "FETCH_CONTRACTCONFIG":
            return Object.assign({}, state, {
                contractConfig: action.value
            })
        case "FETCH_ELIGIBLE_OFFERS":
            return Object.assign({}, state, {
                offersEligible: action.value
            })
        case "FETCH_DATAM2M":
            let internet = Object.assign({}, state.internet, {
                m2mPlans: replaceM2MSpecialOffers(action.value),
            })

            return Object.assign({}, state, {
                internet
            })
        case "EC_FETCH_DATAM2M":
            let ecinternet = Object.assign({}, state.internet, {
                m2mPlans: replaceM2MSpecialOffers(action.value),
            })

            return Object.assign({}, state, {
                internet: ecinternet
            })
        case "SPEED_CODE":
            let speedQualified = Object.assign({}, state.internet, {
                speedCode: action.value
            })
            return Object.assign({}, state, {
                internet: speedQualified
            })
        case "ISOC_INFO":
        let isocDetails = Object.assign({}, state.internet, {
            isocInfo: action.value
        })
        return Object.assign({}, state, {
            internet: isocDetails
        })
        case "ALL_SPEED_CODES":
            let allSpeeds = Object.assign({}, state.internet, {
                allSpeedCodes: action.value
            })
            return Object.assign({}, state, {
                internet: allSpeeds
            })
        case "SELF_INSTALL_MESSAGE":
            let selfInstallMesssage = Object.assign({}, state.internet, {
                selfInstallMesssage: action.message
            })
            return Object.assign({}, state, {
                internet: selfInstallMesssage
            })
        case "EC_FETCH_TECHSURE":
            let modTechSure = [];
            let IWMProdOnProfile = action.value.filter(each => (each.id === "7486966" || each.id === "7487040") && each.isprdOnProfile);
            let VHDOnProfile = action.value.filter(each => (each.id === "7487729") && each.isprdOnProfile);
            if(IWMProdOnProfile.length > 0) {
                modTechSure = action.value.filter(each => each.id !== "7486399")
            }else if(VHDOnProfile.length > 0){
                modTechSure = action.value.filter(each => each.id !== "7486399")
            } else {
                modTechSure = action.value.filter(each => each.id !== "7486966")
            }
            let ectechsure = Object.assign({}, state.techsure, {
                techsureProducts: action.value,
                modTechSureProducts: modTechSure
            })
            return Object.assign({}, state, {
                techsure: ectechsure
            })
        case "FETCH_TECHSURE":
            let techsure = Object.assign({}, state.techsure, {
                techsureProducts: action.value,
                modTechSureProducts: action.value.filter(each => each.id !== "7486966")
            })
            return Object.assign({}, state, {
                techsure: techsure
            })

        case "FETCH_CONTAINER_OPTION":
            let containerOption = Object.assign({}, state.internet, {
                containerOption: action.value
            })
            return Object.assign({}, state, {
                internet: containerOption
            })
        case "FETCH_CONTAINER_MANGEMENT":
            let containerManagementNeeded = Object.assign({}, state.internet, {
                containerManagementNeeded: action.value
            })
            return Object.assign({}, state, {
                internet: containerManagementNeeded
            })
        case "FETCH_HNM_STATUS_CODE":
            let hnm_status_code = Object.assign({}, state.internet, {
                hnm_status_code: action.value
            })
            return Object.assign({}, state, {
                internet: hnm_status_code
            })

        case "FETCH_VHSBILLER":
            let techsureProd = Object.assign({}, state.techsure, {
                techsureProducts: [...state.techsure.techsureProducts,...action.value],
                modTechSureProducts: [...state.techsure.modTechSureProducts,...action.value],
            })
            return Object.assign({}, state, {
                techsure: techsureProd
            })
            case "FETCH_DHSBILLER":
                let techsureDHSProd = Object.assign({}, state.techsure, {
                    techsureProducts: [...state.techsure.techsureProducts,...action.value],
                    modTechSureProducts: [...state.techsure.modTechSureProducts,...action.value],
                })
                return Object.assign({}, state, {
                    techsure: techsureDHSProd
                })
        case "HOME_SECURITY" :
             let homesecProd = Object.assign({}, state.techsure, {
                isHomeSecurityProductAdded: true,
                isHomeSecurityPlusProductAdded:false,
            })
            let selectedhsVhsbiller = Object.assign({}, state.vhsBiller, {
                selectedProduct: null,
                isAccordionOpen: true ,
            })

        return Object.assign({}, state, {
            techsure: homesecProd,
            vhsBiller: selectedhsVhsbiller,

        })
        case "HOME_SECURITY_PLUS" :
             let homesepluscProd = Object.assign({}, state.techsure, {
                isHomeSecurityProductAdded: false,
                isHomeSecurityPlusProductAdded:true,
            })
            let selectedhspVhsbiller = Object.assign({}, state.vhsBiller, {
                selectedProduct: null,
                isAccordionOpen: true ,
            })
        return Object.assign({}, state, {
            techsure: homesepluscProd,
            vhsBiller: selectedhspVhsbiller
        })

        case "HOME_SECURITY_BUNDLE_PRICE" :
            let homeSecBundleprod = Object.assign({}, state.techsure, {
               homeSecurityBundlePrice: action.value,
           })


       return Object.assign({}, state, {
           techsure: homeSecBundleprod,

       })

        case "HOME_SECURITY_CLEAR" :
        let homeseclrpluscProd = Object.assign({}, state.techsure, {
            isHomeSecurityProductAdded: false,
            isHomeSecurityPlusProductAdded:false,
        })
        let selectedhsclrpVhsbiller = Object.assign({}, state.vhsBiller, {
            selectedProduct: null,
            isAccordionOpen: false ,
        })
    return Object.assign({}, state, {
        techsure: homeseclrpluscProd,
        vhsBiller: selectedhsclrpVhsbiller
    })
        case "FETCH_ACESSORIES":

        let hscameras = Object.assign({}, state.vhsBiller, {
            vhsProducts: action.value,
        })
        return Object.assign({}, state, {
            vhsBiller: hscameras
        })

        case "HOME_SECURITY_REMOVED":

        let rmHomeSecurity = Object.assign({}, state.techsure, {
            isHomeSecurityProductRemoved: action.value,
        })
        return Object.assign({}, state, {
            techsure: rmHomeSecurity
        })

        case "DSH_REMOVED":

        let dshSecurity = Object.assign({}, state.techsure, {
            isDHSSecurityProductRemoved: action.value,
        })
        return Object.assign({}, state, {
            techsure: dshSecurity
        })

        case "SET_SERRCOM_PROFILE":
            return Object.assign({}, state, {
                isSercommFlow: action.value
        })


        case "FETCH_TECHSURE_CLOUD":
            let techsurecloud = Object.assign({}, state.techsurecloud, {
                techsureCloud: action.value
            })
            return Object.assign({}, state, {
                techsurecloud: techsurecloud
            })
        case "FETCH_VAS_CHILD":
            let vaschild = Object.assign({}, state.techsure, {
                vasChildList: action.value
            })
            return Object.assign({}, state, {
                techsure: vaschild
            })
        case 'ENABLE_VASCHILD_LIST':
            let enableVasChildList = Object.assign({}, state.techsure, {
                enableVasChildList: action.value
            })
            return Object.assign({}, state, {
                techsure: enableVasChildList
            })

        case "FETCH_DATA2Y":
            let internet2Y = Object.assign({}, state.internet, {
                twoYearPlans: action.value
            })
            return Object.assign({}, state, {
                internet: internet2Y
            })
        case "EC_FETCH_DATA2Y":
            let ecinternet2Y = Object.assign({}, state.internet, {
                twoYearPlans: action.value
            })
            return Object.assign({}, state, {
                internet: ecinternet2Y
            })
        case 'FETCH_TV2Y':
            let tv2Y = Object.assign({}, state.tv, {
                twoYearPlans: action.value
            })
            return Object.assign({}, state, {
                tv: tv2Y
            })
        case 'FETCH_TVM2M':
            let tv = Object.assign({}, state.tv, {
                m2mPlans: action.value
            })
            return Object.assign({}, state, {
                tv: tv
            })
        case 'FETCH_TVM2M_SLING':
            let tvsling = Object.assign({}, state.tv, {
                m2mPlans: []
            })
            return Object.assign({}, state, {
                tv: tvsling
            })
        case 'FETCH_TVBASICDIFF':
            let tvbasicdiff = Object.assign({}, state.tv, {
                basicdiffPlans: action.value
            })
            return Object.assign({}, state, {
                tv: tvbasicdiff
            })
        case 'CHANNEL_MASTERPACKAGEVIEW':
            return Object.assign({}, state, {
                masterpackageview: action.value
            })
        case 'FETCH_CUSTOMTV':
            let customTV = Object.assign({}, state.tv.customTV, {
                plans: action.value
            })
            let updatedCustmTV = Object.assign({}, state.tv, {
                customTV: customTV
            })
            return Object.assign({}, state, {
                tv: updatedCustmTV
            })
        case 'SET_PACKAGE_VIEW_FIOS_FIVE':
            let fiosFiveDetailedChannel = Object.assign({}, state.tv, {
                fiosFiveDetailedChannel: action.value
            })
            return Object.assign({}, state, {
                tv: fiosFiveDetailedChannel
            })
        case 'FETCH_VOICE':
            let voice = Object.assign({}, state.voice, {
                plans: action.value
            })
            return Object.assign({}, state, {
                voice: voice
            })
        case 'FETCH_PERKS':
            let perks = Object.assign({}, state.perks, {
                plans: action.value
            })
            return Object.assign({}, state, {
                perks: perks
            })
        case 'FETCH_PERKS_MESSAGES':
            return Object.assign({}, state, {
                perkMessages: action.value
            })
        case 'SET_HS_PRODUCT_COUNT':
            return Object.assign({}, state, {
                accessoriesProductCount: action.value
            })
            case 'UPDATE_HS_BILLDATE':
                return Object.assign({}, state, {
                    homeSecuritybillStartDate: action.value
                })
            case 'SET_DS_PUNCHOUT_SECURE_HOME':
                 return Object.assign({}, state, {
                     punchoutSecurehome: action.value
                })
            case 'SET_DS_PUNCHOUT_SECURE_HOME_PLUS':
                return Object.assign({}, state, {
                    punchoutSecurehomePlus: action.value
                })
            case 'SET_DS_PUNCHOUT_SECURE_HOME_DTM':
                return Object.assign({}, state, {
                    punchoutSecurehomeDtmTag: action.value
                })        
            case 'SET_DS_PUNCHOUT_SECURE_HOME_ACTION':
                return Object.assign({}, state, {
                    punchoutSecurehomeAction: action.value
                })
                case 'SET_HS_PROD_DARK':
                    return Object.assign({}, state, {
                        homesecurityProdDark: action.value
                   })
    
        
        case 'AP_BUY_COUNT':
            return Object.assign({}, state, {
                apBuyCount: action.value
            })
        case 'DISABLE_VOICE_ACCOR_NGPON2':
            let SkipFDVWithNGPON2 = Object.assign({}, state.voice, {
                // isAccordionDisabled: action.value,
                isSkipFDVWithNGPON2: action.value
            })
            return Object.assign({}, state, {
                voice: SkipFDVWithNGPON2
            })
            case 'DISABLE_VOICE_ACCOR':
                let voiceAccrDisable = Object.assign({}, state.voice, {
                    isAccordionDisabled: action.value
                })
                return Object.assign({}, state, {
                    voice: voiceAccrDisable
                })
        case 'DISABLE_PERKS_ACCOR_NGPON2':
            let perksAccrDisable = Object.assign({}, state.perks, {
                isAccordionDisabled: action.value
            })
            return Object.assign({}, state, {
                perks: perksAccrDisable
            })
        case 'EC_FETCH_INTLCALLING':
            let intlCallingOnProfileProduct = InHomeUtils.isNotNull(action.value) && action.value.length > 0 ? action.value.filter(p => InHomeUtils.isNotNull(p.prdOnProfile) && p.prdOnProfile)[0] : null;
            let ecintlCalling = Object.assign({}, state.intlCalling, {
                intlCallingProducts: action.value,
                profileProduct: InHomeUtils.isNotNull(intlCallingOnProfileProduct) ? intlCallingOnProfileProduct: null,
                accordionStatus: InHomeUtils.isNotNull(intlCallingOnProfileProduct) ? "" : InHomeUtils.isNotNull(state.intlCalling.selectedProduct) ? "added" :"required"
            })

            return Object.assign({}, state, {
                intlCalling: ecintlCalling
            })
        case 'FETCH_INTLCALLING':
            let intlCalling = Object.assign({}, state.intlCalling, {
                intlCallingProducts: action.value
            })
            return Object.assign({}, state, {
                intlCalling: intlCalling
            })

        case 'FETCH_WINBACKPRODUCT':
            let winbackProd = Object.assign({}, state.winback, {
                winbackProducts: action.value
            })
            return Object.assign({}, state, {
                winback: winbackProd
            })
        case 'FETCH_LONG_DISTANCE':
            let longDistance = Object.assign({}, state.longDistance, {
                longDistanceProducts: action.value
            })
            return Object.assign({}, state, {
                longDistance: longDistance
            })
        case 'FETCH_WIRE_MAINTENANCE':
            let wireMaintenance = Object.assign({}, state.wireMaintenance, {
                wireMaintenanceProducts: action.value
            })
            return Object.assign({}, state, {
                wireMaintenance: wireMaintenance
            })
        case 'FETCH_INTERNATIONAL_PLANS':
            let intlPlans = Object.assign({}, state.intlPlans, {
                intlPlansProducts: action.value
            })
            return Object.assign({}, state, {
                intlPlans: intlPlans
            })
        case 'FETCH_PROFILE_INTERNATIONAL_CHANNEL':
            let profileintlChannel = Object.assign({}, state.internationalChannel, {
                onProfileProducts: action.value
            })
            return Object.assign({}, state, {
                internationalChannel: profileintlChannel
            })
        case 'FETCH_CALLING_FEATURES':
            let callingFeatures = Object.assign({}, state.callingFeatures, {
                callingFeaturesProducts: action.value
            })
            return Object.assign({}, state, {
                callingFeatures: callingFeatures
            })
        case 'FETCH_EXISTING_LISTING':
            let fexistingListing = Object.assign({}, state.existingListing, {
                listingProducts: action.value
            })
            return Object.assign({}, state, {
                existingListing: fexistingListing
            })
        case 'FETCH_LISTING':
            let listing = Object.assign({}, state.listing, {
                listingProducts: action.value
            })
            return Object.assign({}, state, {
                listing: listing
            })
        case 'FETCH_PYOAC':
            return Object.assign({}, state, {
                pyoacProducts: action.value
            })

        case 'FETCH_BATTERY':
            let battery = Object.assign({}, state.backup, {
                backupProducts: action.value
            })
            return Object.assign({}, state, {
                backup: battery
            })
        case 'UPDATE_BATTERY_ACCOR_STATUS':
            let batteryAccorStatus = Object.assign({}, state.backup, {
                accordionStatus: action.value
            })
            return Object.assign({}, state, {
                backup: batteryAccorStatus
            })
        case 'FETCH_BATTERY_SHIPMENT':
            let batteryshipment = Object.assign({}, state.backup.shipment, {
                shipmentProducts: action.value
            })
            let updatedShipment = Object.assign({}, state.backup, {
                shipment: batteryshipment,
                isShipmentAvailable: action.value.length > 0
            })
            return Object.assign({}, state, {
                backup: updatedShipment
            })
        case 'FETCH_TVCONNECTIONS':
            let tvConns = Object.assign({}, state.tvConnections, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                tvConnections: tvConns
            })
        case 'FETCH_VROOM':
            let vroom = Object.assign({}, state.vRoom, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                vRoom: vroom
            })
        case 'FETCH_CEAPPS':
            let ceapps = Object.assign({}, state.ceApps, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                ceApps: ceapps
            })
        case 'UPDATE_CEAPPS':
            let updatedceapps = Object.assign({}, state.ceApps, {
                displaySection: action.value
            })
            return Object.assign({}, state, {
                ceApps: updatedceapps
            })
        case 'UPDATE_ACCOR_CEAPPS':
            let updatedaccorceapps = Object.assign({}, state.ceApps, {
                displayAccorSection: action.value
            })
            return Object.assign({}, state, {
                ceApps: updatedaccorceapps
            })
        case 'UPDATE_OPTIN_STATUS':
            let updateOptInSelected = Object.assign({}, state.ceApps, {
                optInSelected: action.value
            })
            return Object.assign({}, state, {
                ceApps: updateOptInSelected
            })
        case 'UPDATE_DESELECTEDPRODUCT':

        return Object.assign({}, state, {
            ceApps: action.value
        })
        case 'UPDATE_OPTOUT_STATUS':
            let updateOptOutSelected = Object.assign({}, state.ceApps, {
                optOutSelected: action.value
            })
            return Object.assign({}, state, {
                ceApps: updateOptOutSelected
            })
        case 'UPDATE_TVCONNECTIONS':
            let updatedtvconnections = Object.assign({}, state.tvConnections, {
                displaySection: action.value
            })
            return Object.assign({}, state, {
                tvConnections: updatedtvconnections
            })
        case 'UPDATE_VROOM':
            let updatevroom = Object.assign({}, state.vRoom);
            let newPrd = { id: 'NOVROOM', prodType: 'VROOM', unitCount: "none", name: "No TVs" };
            updatevroom.equipments = InHomeUtils.isNotNull(updatevroom.equipments) ? updatevroom.equipments.filter(p => p.id !== "NOVROOM") : null;
            if (!action.value.isChecked && action.value.product !== null && ((action.value.product.prodType === 'VCPESTB' && action.value.product.id !== 'NODCT') || action.value.product.prodTypeValue === "LOCLDGTL")) {
                updatevroom.equipments.push(newPrd);
            }
            else if ((InHomeUtils.isNotNull(state.tv.selectedProduct) && InHomeUtils.isNotNull(state.tv.selectedProduct.prodTypeValue) && state.tv.selectedProduct.prodTypeValue === 'LOCLDGTL') || (InHomeUtils.isNotNull(state.dct.selectedProduct) && state.dct.selectedProduct.id !== "NODCT")) {
                updatevroom.equipments.push(newPrd);
            }
            else if (InHomeUtils.isNotNull(state.vRoom.selectedProduct) && (state.vRoom.selectedProduct?.id === "NOVROOM" || state.vRoom.selectedProduct?.prodId === "NOVROOM")) {
                updatevroom.selectedProduct = null;
                updatevroom.accordionStatus = 'required';
            }
            return Object.assign({}, state, {
                vRoom: updatevroom
            })
        case 'FETCH_RECORDING':
            let recording = Object.assign({}, state.recording, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                recording: recording
            })
        case 'FETCH_ROUTER':
            let router = Object.assign({}, state.router, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                router: router
            })
        case 'FETCH_ACCESSPOINT':
            let accessPoint = Object.assign({}, state.accessPoint, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                accessPoint: accessPoint
            })
        case 'FETCH_FNE':
            let fne = Object.assign({}, state.fne, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                fne: fne
            })
        case 'FETCH_DCT':
            let dct = Object.assign({}, state.dct, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                dct: dct
            })
        case 'UPGRADE_ROUTER':
            let upgradeRouter = Object.assign({}, state.router, {
                upgradeRouter: action.value
            })
            return Object.assign({}, state, {
                router: upgradeRouter
            })
        case 'FETCH_CHANNEL':
            let channel = Object.assign({}, state.channel, {
                equipments: action.value
            })
            return Object.assign({}, state, {
                channel: channel
            })
        case 'FETCH_INTERNATIONAL_CHANNEL':
                let internationalChannel = Object.assign({}, state.internationalChannel, {
                    equipments: action.value
                })
                return Object.assign({}, state, {
                    internationalChannel: internationalChannel
                })
        case "UPDATE_CHANNEL_DESC":
            let equipementsMod = [...state.channel.equipments]
            //adding desc if not empty string
            equipementsMod.map(each=>each.id===action.payload.prodId?action.payload.description===""?each.description="No Description available":each.description=action.payload.description:"")
            let channelMod = Object.assign({}, state.channel, {
                equipments: equipementsMod
            })
            return Object.assign({}, state, {
                channel: channelMod
            })
        case "LOADER_FOR_CHANNEL_EQUIPMENTS":
            let loaderToggle = Object.assign({}, state.channel, {
                loaderForEquipments: !state.channel.loaderForEquipments
            })
            return Object.assign({}, state, {
                channel: loaderToggle
            })

        case 'COLLAPSE_ALL_ACCORDION':
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, { isAccordionOpen: false, isSubAccordionOpen: false }),
                tv: Object.assign({}, state.tv, { isAccordionOpen: false, isSubAccordionOpen: false }),
                router: Object.assign({}, state.router, { isAccordionOpen: false }),
                techsure: Object.assign({}, state.techsure, { isAccordionOpen: false}),
                vhsBiller: Object.assign({}, state.vhsBiller, { isAccordionOpen: false}),
                techsurecloud: Object.assign({}, state.techsurecloud, { isAccordionOpen: false }),
                fne: Object.assign({}, state.fne, { isAccordionOpen: false }),
                streamServ: Object.assign({}, state.streamServ, { isAccordionOpen: false, isSubAccordionOpen: false }),
                streamDev: Object.assign({}, state.streamDev, { isAccordionOpen: false }),
                // focusAccordion: true
            })
        case 'TOGGLE_INTERNET_ACCOR': //for opening accordions automatically
            let internetAccor = Object.assign({}, state.internet, {
                isAccordionOpen: action.value === "MarvelFlow" ? true :  !state.internet.isAccordionOpen,
                isSubAccordionOpen: action.value === "DOFlow" ? (state.internet.subAccordionStatus === 'added'
                && state.internet.selectedProduct !== null
                && state.internet.selectedProduct.speedCode === "941"
                && state.flashoffer.selectedProduct === null)?false:true : state.internet.subAccordionStatus !== 'added' ? true : false
            })
            return Object.assign({}, state, {
                internet: internetAccor,
                tv: Object.assign({}, state.tv, {
                    isAccordionOpen: internetAccor.isAccordionOpen ? false : state.tv.isAccordionOpen,
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: (state.internet.subAccordionStatus === 'added' && state.router.accordionStatus !== 'added'
                        && action.value !== "ResumeFlow") ? true : false
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: (state.internet.subAccordionStatus === 'added' && state.router.accordionStatus === 'added'
                        && state.fne.accordionStatus !== 'added' && action.value !== "ResumeFlow") ? true : false
                }),
                // techsure: Object.assign({}, state.techsure, {
                //     isAccordionOpen: (state.internet.subAccordionStatus === 'added' && state.router.accordionStatus === 'added'
                //         && state.techsure.accordionStatus !== 'added' && action.value !== "ResumeFlow") ? true : false
                // }),
                // focusParentAccordion: action.value !== "Init"
            })
        case 'TOGGLE_INTERNET_PLAN_ACCOR':
            let intPlanSplAccr = Object.assign({}, state.sploffer.data, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: !state.internet.isSubAccordionOpen
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intPlanSplAccr
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false
                }),
                perks: Object.assign({}, state.perks, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case "UPDATE_SELECTED_TECHSECURE":
            return Object.assign({}, state, {
                techsure: Object.assign({}, state.techsure, {
                    selectedProduct: [] ,
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false,
                    accordionStatus: 'optional'
                })
            })
        case 'TOGGLE_INTERNET_ROUTER_ACCOR':
            let splOfferOpen = false;
            if(state?.sploffer && state?.sploffer?.offerplansMTM?.length > 0 && (!state.isMNEnabled || (state.isMNEnabled && state.router.isAccordionOpen))) {
                if(!state?.sploffer?.selectedProduct) {
                    splOfferOpen = true;
                }
            }
            let intRouterSplAccr = Object.assign({}, state.sploffer.data, {
                isAccordionOpen: splOfferOpen
            })
            return Object.assign({}, state, {
                router: Object.assign({}, state.router, {
                    isAccordionOpen: action.value === "" ? !state.router.isAccordionOpen : !splOfferOpen
                }),
                // changing identical behavor of internet router when router accordion is clicked
                // internet: Object.assign({}, state.internet, {
                //     isSubAccordionOpen: state.isMNEnabled ? (
                //         (action.value === "" ? !state.router.isAccordionOpen : !splOfferOpen)
                //         || splOfferOpen
                //     ) : false,
                //     isAccordionOpen: action.value === "" ? state.internet.isAccordionOpen : true
                // }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: true
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intRouterSplAccr
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_INTERNET_ACCESS_POINT_ACCOR':  
            return Object.assign({}, state, {
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                accessPoint: Object.assign({}, state.accessPoint, {
                    isAccordionOpen: !state.accessPoint.isAccordionOpen
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: false
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intRouterSplAccr
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false
                }),
            })
        case 'TOGGLE_INTERNET_TECHSURE_ACCOR':
            let intTSSplAccr = Object.assign({}, state.sploffer.data, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : !state.techsure.isAccordionOpen
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: false
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intTSSplAccr
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
            case 'TOGGLE_INTERNET_HOME_TECHSURE_ACCOR':
            let intHSSplAccr = Object.assign({}, state.sploffer.data, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : !state.techsure.isAccordionOpen
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: !state.vhsBiller.isAccordionOpen
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: false
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intTSSplAccr
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })

            case 'TOGGLE_INTERNET_TECHSURE_CLOUD_ACCOR':
                let intVCSplAccr = Object.assign({}, state.sploffer.data, {
                    isAccordionOpen: false
                })
                return Object.assign({}, state, {
                    techsurecloud: Object.assign({}, state.techsurecloud, {
                        isAccordionOpen: !state.techsurecloud.isAccordionOpen
                    }),
                    techsure: Object.assign({}, state.techsure, {
                        isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false
                    }),
                    vhsBiller: Object.assign({}, state.vhsBiller, {
                        isAccordionOpen: false
                    }),
                    router: Object.assign({}, state.router, {
                        isAccordionOpen: false
                    }),
                    internet: Object.assign({}, state.internet, {
                        isSubAccordionOpen: false
                    }),
                    fne: Object.assign({}, state.fne, {
                        isAccordionOpen: false
                    }),
                    sploffer: Object.assign({}, state.sploffer, {
                        data: intVCSplAccr
                    }),
                    flashoffer: Object.assign({}, state.flashoffer, {
                        isAccordionOpen: false
                    }),
                    // focusAccordion: true
                })
        case 'TOGGLE_DATA_SPLOFFER_ACCOR':
            let dataSplOfferAccor = Object.assign({}, state.sploffer.data, {
                isAccordionOpen: action.value === "isleadSpecialOfferInCart" || action.value === "DOFlow" ? true : !state.sploffer.data.isAccordionOpen,
                isSubAccordionOpen: action.value === "DOFlow" || state.sploffer.data.subAccordionStatus !== 'added' ? true : !state.sploffer.data.isSubAccordionOpen,
            })
            return Object.assign({}, state, {
                router: Object.assign({}, state.router, {
                    isAccordionOpen: !(state.sploffer && state.sploffer.data && state.sploffer.data.offerplansMTM && state.sploffer.data.offerplansMTM.length>1 && dataSplOfferAccor.isAccordionOpen)  && (state.router.selectedProduct === null)
                }),
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: state.isMNEnabled,
                    isAccordionOpen: action.value === "DOFlow" ? true : action.value === "" ? state.internet.isAccordionOpen : true
                }),
                perks: Object.assign({}, state.perks, {
                    isAccordionOpen: false,
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    isAccordionOpen: true,
                    data: dataSplOfferAccor,
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'MM3_PERKS_SECTION':
            return Object.assign({}, state, {
                mm3internetsub: Object.assign({}, state.mm3internetsub, {
                    isAccordionOpen: true
                }),
            })
        case 'TOGGLE_DATASUB_ACCOR':
            return Object.assign({}, state, {
                mm3internetsub: Object.assign({}, state.mm3internetsub, {
                    isAccordionOpen: !state.mm3internetsub.isAccordionOpen
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: true,
                }),
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })

        case 'TOGGLE_INTERNET_FNE_ACCOR':
            let intFNESplAccr = Object.assign({}, state.sploffer.data, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: !state.fne.isAccordionOpen
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intFNESplAccr
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_ACCOR':

            let objTVPlans = { customTV: false, dct: false, recordingAccor: false, routerAccor: false, chnlAccor: false, intrlChnAccor:false, vRoomAccor: false, streamDev: false, offerAccr: false, sploffer: false }

            if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                objTVPlans.customTV = true;
            } else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && action.value !== "ResumeFlow") {
                objTVPlans.routerAccor = true;
            } else if (state.dct.isDCTEligible !== undefined && state.dct.isDCTEligible !== null && state.dct.isDCTEligible === true && state.dct.selectedProduct === null) {
                objTVPlans.dct = true;
            } else if (state.vRoom.selectedProduct === null) {
                objTVPlans.vRoomAccor = true;
            } else if (state.recording.selectedProduct === null) {
                objTVPlans.recordingAccor = true;
            } else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null) {
                objTVPlans.chnlAccor = true;
            }
            else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null) {
                objTVPlans.intrlChnAccor = true;
            }
            else if (state.sploffer.isTVOffer && state.sploffer.tv.selectedProduct === null) {
                objTVPlans.offerAccr = true;
            }
            else if (state.streamDev.selectedProduct === null) {
                objTVPlans.streamDev = true;
            }
            else if (state.sploffer.selectedProduct === null) {
                objTVPlans.sploffer = true;
            }
            let custumTVAcc = Object.assign({}, state.tv.customTV, {
                isAccordionOpen: objTVPlans.customTV
            })
            let tvAccor = Object.assign({}, state.tv, {
                isAccordionOpen: action.value === "DOFlow" ? false : !state.tv.isAccordionOpen,
                isSubAccordionOpen: state.tv.subAccordionStatus !== 'added' ? true : false,
                customTV: custumTVAcc
            })
            let tvOffrAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: objTVPlans.offerAccr
            })
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, {
                    isAccordionOpen: tvAccor.isAccordionOpen ? false : state.internet.isAccordionOpen,
                }),
                tv: tvAccor,
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objTVPlans.routerAccor
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: objTVPlans.dct
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: objTVPlans.vRoomAccor
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objTVPlans.vRoomAccor
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objTVPlans.recordingAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objTVPlans.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objTVPlans.intrlChnAccor
                }),
                streamDev: Object.assign({}, state.streamDev, {
                    isAccordionOpen: objTVPlans.streamDev
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    isAccordionOpen: objTVPlans.sploffer,
                    tv: tvOffrAccr
                }),
                // focusParentAccordion: true
            })
        case 'TOGGLE_TV_PLAN_ACCOR':
            let tvPlanSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            let tvPlanAccor = Object.assign({}, state.tv, {
                isSubAccordionOpen: !state.tv.isSubAccordionOpen,
                customTV: Object.assign({}, state.tv.customTV, {
                    isAccordionOpen: false
                })
            })
            return Object.assign({}, state, {
                tv: tvPlanAccor,
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: false
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: false
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: false
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: false
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: false
                }),
                streamDev: Object.assign({}, state.streamDev, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    tv: tvPlanSplAccr
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_CUSTOMTV_ACCOR':
            let tvCustomPlanSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            let customTVAccor = Object.assign({}, state.tv.customTV, {
                isAccordionOpen: action.value === "" ? !state.tv.customTV.isAccordionOpen : true
            })
            let tvAcco = Object.assign({}, state.tv, {
                customTV: customTVAccor,
                isSubAccordionOpen: false,
                isAccordionOpen: action.value === "" ? state.tv.isAccordionOpen : true
            })
            return Object.assign({}, state, {
                tv: tvAcco,
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: false
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: false
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: false
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: false
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    tv: tvCustomPlanSplAccr
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_ROUTER_ACCOR':
            let tvRouterSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false,
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: false
                    }),
                    isAccordionOpen: action.value === "" ? state.tv.isAccordionOpen : true
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: action.value === "" ? !state.router.isAccordionOpen : true
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: false
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: false
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: false
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: false
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    tv: tvRouterSplAccr
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_DCT_ACCOR':
            let tvDCTSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false,
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: false
                    }),
                    isAccordionOpen: action.value === "" ? state.tv.isAccordionOpen : true
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: action.value === "" ? !state.dct.isAccordionOpen : true
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: false
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: false
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: false
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    tv: tvDCTSplAccr
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_SETTOPBOX_ACCOR':
            let tvSTBSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
              tv: Object.assign({}, state.tv, {
                isSubAccordionOpen: false,
                customTV: Object.assign({}, state.tv.customTV, {
                  isAccordionOpen: false,
                }),
                isAccordionOpen:
                  action.value === "" ? state.tv.isAccordionOpen : true,
              }),
              router: Object.assign({}, state.router, {
                isAccordionOpen: false,
              }),
              vRoom: Object.assign({}, state.vRoom, {
                isAccordionOpen:
                  action.value === "" ? !state.vRoom.isAccordionOpen : true,
              }),
              tvConnections: Object.assign({}, state.tvConnections, {
                isAccordionOpen: false,
              }),
              ceApps: Object.assign({}, state.ceApps, {
                isAccordionOpen: false,
              }),
              fiosTvOne: Object.assign({}, state.fiosTvOne, {
                isAccordionOpen: false,
              }),
              recording: Object.assign({}, state.recording, {
                isAccordionOpen: !NCFlow
                  ? !state.productOnProfileStatus?.recording
                    ? state.recording.isAccordionOpen
                    : false
                  : false,
              }),
              channel: Object.assign({}, state.channel, {
                isAccordionOpen: !NCFlow
                  ? state.channel?.selectedProduct === null &&
                    !state.productOnProfileStatus?.channel
                    ? state.channel.isAccordionOpen
                    : false
                  : false,
              }),
              internationalChannel: Object.assign(
                {},
                state.internationalChannel,
                {
                  isAccordionOpen: !NCFlow
                    ? state.internationalChannel?.equipments !== null &&
                      state.internationalChannel?.selectedProduct === null &&
                      !state.productOnProfileStatus?.internationalChannel
                      ? state.internationalChannel.isAccordionOpen
                      : false
                    : false,
                }
              ),
              dct: Object.assign({}, state.dct, {
                isAccordionOpen: false,
              }),
              sploffer: Object.assign({}, state.sploffer, {
                tv: tvSTBSplAccr,
              }),
            //   focusAccordion: true,
            });
        case 'TOGGLE_TV_CONNECTIONS_ACCOR':
            let tvConSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
              tv: Object.assign({}, state.tv, {
                isSubAccordionOpen: false,
                customTV: Object.assign({}, state.tv.customTV, {
                  isAccordionOpen: false,
                }),
                isAccordionOpen:
                  action.value === "" ? state.tv.isAccordionOpen : true,
              }),
              router: Object.assign({}, state.router, {
                isAccordionOpen: false,
              }),
              tvConnections: Object.assign({}, state.tvConnections, {
                isAccordionOpen:
                  action.value === ""
                    ? !state.tvConnections.isAccordionOpen
                    : true,
              }),
              vRoom: Object.assign({}, state.vRoom, {
                isAccordionOpen: false,
              }),
              ceApps: Object.assign({}, state.ceApps, {
                isAccordionOpen: false,
              }),
              fiosTvOne: Object.assign({}, state.fiosTvOne, {
                isAccordionOpen: false,
              }),
              recording: Object.assign({}, state.recording, {
                isAccordionOpen: !NCFlow
                  ? !state.productOnProfileStatus?.recording
                    ? state.recording.isAccordionOpen
                    : false
                  : false,
              }),
              channel: Object.assign({}, state.channel, {
                isAccordionOpen: !NCFlow
                  ? state.channel?.selectedProduct === null &&
                    !state.productOnProfileStatus?.channel
                    ? state.channel.isAccordionOpen
                    : false
                  : false,
              }),
              internationalChannel: Object.assign(
                {},
                state.internationalChannel,
                {
                  isAccordionOpen: !NCFlow
                    ? state.internationalChannel?.equipments !== null &&
                      state.internationalChannel?.selectedProduct === null &&
                      !state.productOnProfileStatus?.internationalChannel
                      ? state.internationalChannel.isAccordionOpen
                      : false
                    : false,
                }
              ),
              dct: Object.assign({}, state.dct, {
                isAccordionOpen: false,
              }),
              sploffer: Object.assign({}, state.sploffer, {
                tv: tvConSplAccr,
              }),
            //   focusAccordion: true,
            });
        case 'TOGGLE_TV_CEAPPS_ACCOR':
            let tvCeAppsSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false,
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: false
                    }),
                    isAccordionOpen: action.value === "" ? state.tv.isAccordionOpen : true
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: false
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: action.value === "" ? !state.ceApps.isAccordionOpen : true
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: false
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: false
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: false
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    tv: tvCeAppsSplAccr
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_FIOSTVONE_ACCOR':
            let fiosTvOneAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false,
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: false
                    }),
                    isAccordionOpen: action.value === "" ? state.tv.isAccordionOpen : true
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: false
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: action.value === "" ? !state.fiosTvOne.isAccordionOpen : true
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: false
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: false
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: false
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    tv: fiosTvOneAccr
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_RECORDING_ACCOR':
            let tvRecSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
              tv: Object.assign({}, state.tv, {
                isSubAccordionOpen: false,
                customTV: Object.assign({}, state.tv.customTV, {
                  isAccordionOpen: false,
                }),
                isAccordionOpen:
                  action.value === "" ? state.tv.isAccordionOpen : true,
              }),
              router: Object.assign({}, state.router, {
                isAccordionOpen: false,
              }),
              tvConnections: Object.assign({}, state.tvConnections, {
                isAccordionOpen: false,
              }),
              vRoom: Object.assign({}, state.vRoom, {
                isAccordionOpen: !NCFlow
                  ? state.vRoom?.selectedProduct === null &&
                    !state.productOnProfileStatus?.vRoom
                    ? state.vRoom.isAccordionOpen
                    : false
                  : false,
              }),
              ceApps: Object.assign({}, state.ceApps, {
                isAccordionOpen: false,
              }),
              fiosTvOne: Object.assign({}, state.fiosTvOne, {
                isAccordionOpen: false,
              }),
              recording: Object.assign({}, state.recording, {
                isAccordionOpen:
                  action.value === "" ? !state.recording.isAccordionOpen : true,
              }),
              channel: Object.assign({}, state.channel, {
                isAccordionOpen: !NCFlow
                  ? state.channel?.selectedProduct === null &&
                    !state.productOnProfileStatus?.channel
                    ? state.channel.isAccordionOpen
                    : false
                  : false,
              }),
              internationalChannel: Object.assign(
                {},
                state.internationalChannel,
                {
                  isAccordionOpen: !NCFlow
                    ? state.internationalChannel?.equipments !== null &&
                      state.internationalChannel?.selectedProduct === null &&
                      !state.productOnProfileStatus?.internationalChannel
                      ? state.internationalChannel.isAccordionOpen
                      : false
                    : false,
                }
              ),
              dct: Object.assign({}, state.dct, {
                isAccordionOpen: false,
              }),
              sploffer: Object.assign({}, state.sploffer, {
                tv: tvRecSplAccr,
              }),
            //   focusAccordion: true,
            });
        case 'TOGGLE_TV_SPLOFFER_ACCOR':
            let tvSplOfferAccor = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: action.value === "DOFlow" ? false : !state.sploffer.tv.isAccordionOpen,
                isSubAccordionOpen: state.sploffer.tv.subAccordionStatus !== 'added' ? true : false
            })
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false,
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: false
                    }),
                    isAccordionOpen: action.value === "" ? state.tv.isAccordionOpen : true
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: false
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false
                }),
                fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: false
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: false
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: false
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    tv: tvSplOfferAccor
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_TV_CHANNEL_ACCOR':
            let tvChannelSplAccr = Object.assign({}, state.sploffer.tv, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
              tv: Object.assign({}, state.tv, {
                isSubAccordionOpen: false,
                customTV: Object.assign({}, state.tv.customTV, {
                  isAccordionOpen: false,
                }),
                isAccordionOpen:
                  action.value === "" ? state.tv.isAccordionOpen : true,
              }),
              router: Object.assign({}, state.router, {
                isAccordionOpen: false,
              }),
              tvConnections: Object.assign({}, state.tvConnections, {
                isAccordionOpen: false,
              }),
              vRoom: Object.assign({}, state.vRoom, {
                isAccordionOpen: !NCFlow
                  ? state.vRoom?.selectedProduct === null &&
                    !state.productOnProfileStatus?.vRoom
                    ? state.vRoom.isAccordionOpen
                    : false
                  : false,
              }),
              ceApps: Object.assign({}, state.ceApps, {
                isAccordionOpen: false,
              }),
              fiosTvOne: Object.assign({}, state.fiosTvOne, {
                isAccordionOpen: false,
              }),
              recording: Object.assign({}, state.recording, {
                isAccordionOpen: !NCFlow
                  ? state.recording?.selectedProduct === null &&
                    !state.productOnProfileStatus?.recording
                    ? state.recording.isAccordionOpen
                    : false
                  : false,
              }),
              channel: Object.assign({}, state.channel, {
                isAccordionOpen:
                  action.value === "" ? !state.channel.isAccordionOpen : true,
              }),
              internationalChannel: Object.assign(
                {},
                state.internationalChannel,
                {
                  isAccordionOpen: !NCFlow
                    ? state.internationalChannel?.equipments !== null &&
                      state.internationalChannel?.selectedProduct === null &&
                      !state.productOnProfileStatus?.internationalChannel
                      ? state.internationalChannel.isAccordionOpen
                      : false
                    : false,
                }
              ),
              dct: Object.assign({}, state.dct, {
                isAccordionOpen: false,
              }),
              sploffer: Object.assign({}, state.sploffer, {
                tv: tvChannelSplAccr,
              }),
            //   focusAccordion: true,
            });
        case 'TOGGLE_TV_INTERNATIONALCHANNEL_ACCOR':
                let tvInternationalChannelSplAccr = Object.assign({}, state.sploffer.tv, {
                    isAccordionOpen: false
                })
                return Object.assign({}, state, {
                  tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false,
                    customTV: Object.assign({}, state.tv.customTV, {
                      isAccordionOpen: false,
                    }),
                    isAccordionOpen:
                      action.value === "" ? state.tv.isAccordionOpen : true,
                  }),
                  router: Object.assign({}, state.router, {
                    isAccordionOpen: false,
                  }),
                  tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: false,
                  }),
                  vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: !NCFlow
                      ? state.vRoom?.selectedProduct === null &&
                        !state.productOnProfileStatus?.vRoom
                        ? state.vRoom.isAccordionOpen
                        : false
                      : false,
                  }),
                  ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: false,
                  }),
                  fiosTvOne: Object.assign({}, state.fiosTvOne, {
                    isAccordionOpen: false,
                  }),
                  recording: Object.assign({}, state.recording, {
                    isAccordionOpen: !NCFlow
                      ? state.recording?.selectedProduct === null &&
                        !state.productOnProfileStatus?.recording
                        ? state.recording.isAccordionOpen
                        : false
                      : false,
                  }),
                  channel: Object.assign({}, state.channel, {
                    isAccordionOpen: !NCFlow
                      ? state.channel?.selectedProduct === null &&
                        !state.productOnProfileStatus?.channel
                        ? state.channel.isAccordionOpen
                        : false
                      : false,
                  }),
                  internationalChannel: Object.assign(
                    {},
                    state.internationalChannel,
                    {
                      isAccordionOpen:
                        action.value === ""
                          ? !state.internationalChannel.isAccordionOpen
                          : true,
                    }
                  ),
                  dct: Object.assign({}, state.dct, {
                    isAccordionOpen: false,
                  }),
                  sploffer: Object.assign({}, state.sploffer, {
                    tv: tvInternationalChannelSplAccr,
                  }),
                //   focusAccordion: true,
                });
        case 'TOGGLE_PHONE_ACCOR':
            let voiceAccor = Object.assign({}, state.voice, {
                isAccordionOpen: !state.voice.isAccordionOpen,
                isSubAccordionOpen: state.voice.subAccordionStatus !== 'added' ? true : false
            })
            return Object.assign({}, state, {
                voice: voiceAccor,
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: state.voice.subAccordionStatus === 'added' && state.intlCalling.accordionStatus !== 'added' ? true : false
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: state.voice.subAccordionStatus === 'added' && state.intlCalling.accordionStatus === 'added' && state.intlPlans.accordionStatus !== 'added' ? true : false
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: state.voice.subAccordionStatus === 'added' && state.intlPlans.accordionStatus === 'added'  &&
                        state.winback.accordionStatus !== 'added' ? true : false
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: state.voice.subAccordionStatus === 'added' && state.winback.accordionStatus === 'added' &&
                        state.listing.accordionStatus !== 'added' ? true : false
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: state.voice.subAccordionStatus === 'added' && state.winback.accordionStatus === 'added' &&
                        state.listing.accordionStatus === 'added' && state.backup.accordionStatus !== 'added' ? true : false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: state.voice.subAccordionStatus === 'added' && state.winback.accordionStatus === 'added' &&
                        state.listing.accordionStatus === 'added' && state.backup.accordionStatus === 'added' && state.emergencyServices.accordionStatus !== 'added' ? true : false
                }),
                // focusParentAccordion: true
            })
        case 'TOGGLE_SPLOFFER_ACCOR':
            let splOfferAccor = Object.assign({}, state.sploffer, {
                isAccordionOpen: action.value === "DOFlow" ? false : !state.sploffer.isAccordionOpen,
                isSubAccordionOpen: state.sploffer.subAccordionStatus !== 'added' ? true : false
            })
            return Object.assign({}, state, {
                sploffer: splOfferAccor,
                // focusParentAccordion: true
            })
        case 'TOGGLE_INTERNET_PERKS_ACCOR':
            let perksAccor  = Object.assign({}, state.perks, {
                isAccordionOpen: !state.perks.isAccordionOpen,
                // isSubAccordionOpen: state.perks.subAccordionStatus !== 'added' ? true : false
            })
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: state.isMNEnabled ? false : state.internet.isSubAccordionOpen
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: state.isMNEnabled ? false : state.router.isAccordionOpen
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: Object.assign({}, state.sploffer.data, {
                        isAccordionOpen: state.isMNEnabled ? false : state.sploffer.data.isAccordionOpen
                    }),
                    isAccordionOpen: state.isMNEnabled ? false : state.sploffer.isAccordionOpen,
                    isSubAccordionOpen: state.isMNEnabled ? false : state.sploffer.isSubAccordionOpen,
                }),
                perks: perksAccor,
                // focusParentAccordion: true
                // focusAccordion: true,
            })
        case 'SPLOFFER_ACCORDION_CLOSE':
            let splOfferAccorClose = Object.assign({}, state.sploffer, {
                isAccordionOpen: action.value
            })
            let techsureOpen = Object.assign({}, state.techsure, {
                isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : state.techsure.isAccordionOpen
            })
            return Object.assign({}, state, {
                sploffer: splOfferAccorClose,
                techsure: techsureOpen
            })
        case 'TOGGLE_FLASHOFFER_ACCOR':
            let flashOfferAccor = Object.assign({}, state.flashoffer, {
                isAccordionOpen: action.value === "DOFlow" ? false : !state.flashoffer.isAccordionOpen,
            })
            let intFlaSplAccr = Object.assign({}, state.sploffer.data, {
                isAccordionOpen: false
            })
            return Object.assign({}, state, {
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.internet.isAccordionOpen : true
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intFlaSplAccr
                }),
                flashoffer: flashOfferAccor,
                // focusParentAccordion: true
            })
        case 'TOGGLE_STREAMINGSERV_ACCOR':
            let streamServAccor = Object.assign({}, state.streamServ, {
                isAccordionOpen: !state.streamServ.isAccordionOpen,
                isSubAccordionOpen: state.streamServ.subAccordionStatus !== 'added' ? true : false
            })
            return Object.assign({}, state, {
                streamServ: streamServAccor,
                streamDev: Object.assign({}, state.streamDev, {
                    isAccordionOpen: state.streamServ.subAccordionStatus === 'added' && state.streamDev.accordionStatus !== 'added' ? true : false
                }),
                streamDevCount: Object.assign({}, state.streamDevCount, {
                    isAccordionOpen: false
                }),
                // focusParentAccordion: true
            })
        case 'TOGGLE_STREAMINGSERV_PLAN_ACCOR':
            return Object.assign({}, state, {
                streamServ: Object.assign({}, state.streamServ, {
                    isSubAccordionOpen: !state.streamServ.isSubAccordionOpen
                }),
                streamDev: Object.assign({}, state.streamDev, {
                    isAccordionOpen: false
                }),
                streamDevCount: Object.assign({}, state.streamDevCount, {
                    isAccordionOpen: false
                }),
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false
                }),
                // focusAccordion: true

            })
        case 'TOGGLE_STREAMINGDEVCNT_PLAN_ACCOR':
            return Object.assign({}, state, {
                streamDevCount: Object.assign({}, state.streamDevCount, {
                    isAccordionOpen: !state.streamDevCount.isAccordionOpen
                }),
                streamServ: Object.assign({}, state.streamServ, {
                    isSubAccordionOpen: false
                }),
                streamDev: Object.assign({}, state.streamDev, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_STREAMINGDEV_PLAN_ACCOR':
            return Object.assign({}, state, {
                streamDev: Object.assign({}, state.streamDev, {
                    isAccordionOpen: !state.streamDev.isAccordionOpen
                }),
                streamServ: Object.assign({}, state.streamServ, {
                    isSubAccordionOpen: false
                }),
                streamDevCount: Object.assign({}, state.streamDevCount, {
                    isAccordionOpen: false
                }),
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_PLAN_ACCOR':
            let voicePlanAccor = Object.assign({}, state.voice, {
                isSubAccordionOpen: !state.voice.isSubAccordionOpen
            })
            return Object.assign({}, state, {
                voice: voicePlanAccor,
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: false
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: false
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: false
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_INTLCALLING_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: action.value === "" ? !state.intlCalling.isAccordionOpen : true,
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false,
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: false,
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: false
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_WINBACKCHECK_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: false,
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false,
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: action.value === "" ? !state.winback.isAccordionOpen : true
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: false
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_LONG_DISTANCE_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                callingFeatures: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: false
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: action.value === "" ? !state.longDistance.isAccordionOpen : true
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: false
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_WIRE_MAINTENANCE_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                callingFeatures: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: false
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: false
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: action.value === "" ? !state.wireMaintenance.isAccordionOpen : true
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_CALLING_FEATURE_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                callingFeatures: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: action.value === "" ? !state.wireMaintenance.isAccordionOpen : true
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: false
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: false
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_INTLPLANS_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                callingFeatures: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: false
                }),
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: false
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: action.value === "" ? !state.intlPlans.isAccordionOpen : true
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: false
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: false
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: false
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: false
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: false
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_EXISTING_LISTING_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                callingFeatures: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: false
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: false
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: false
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: action.value === "" ? !state.existingListing.isAccordionOpen : true
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_LISTING_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: false,
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false,
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: false
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: action.value === "" ? !state.listing.isAccordionOpen : true
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: false
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_PHONE_BACKUP_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: false,
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false,
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: false
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: false
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: action.value === "" ? !state.backup.isAccordionOpen : true
                }),
                // focusAccordion: true
            })
        case 'TOGGLE_EMERGENCY_SERVICES_ACCOR':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isSubAccordionOpen: false,
                    isAccordionOpen: action.value === "" ? state.voice.isAccordionOpen : true
                }),
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: false,
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: false,
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: false,
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: false
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: false
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: action.value === "" ? !state.emergencyServices.isAccordionOpen : true
                }),
                // focusAccordion: true
            })
        case "SET_BACKUP_ACCOR":
            return Object.assign({}, state, {
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: action.value === true ? true : false,
                }),
            });
        case "SET_EMERGENCY_SERVICES_ACCOR":
            return Object.assign({}, state, {
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: action.value === true ? true : false,
                }),
            });
        case 'TOGGLE_OTHER_ACCOR':
            let accorVoice = state.voice
            let accorData = state.internet
            let accorTV = state.tv
            let accorPerks = state.perks
            let accorContract = state.contract
            let sploffer = state.sploffer
            let flashoffer = state.flashoffer
            let streamServ = state.streamServ
            let streamDev = state.streamDev
            let datasploffer = state.sploffer.data
            let tvsploffer = state.sploffer.tv
            if (action.value.indexOf("internet") > -1) {
                accorData = Object.assign({}, state.internet, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : false,
                    isSubAccordionOpen: false
                })
            }
            if (action.value.indexOf("internetSubAccOpen") > -1) {
                accorData = Object.assign({}, state.internet, {
                    isAccordionOpen: true,
                    isSubAccordionOpen: true
                })
            }
            if (action.value.indexOf("internetSubAccClose") > -1) {
                accorData = Object.assign({}, state.internet, {
                    isAccordionOpen: true,
                    isSubAccordionOpen: false
                })
            }
            if (action.value.indexOf("perks") > -1) {
                accorPerks = Object.assign({}, state.perks, {
                    isSubAccordionOpen: true,
                })
            }
            if (action.value.indexOf("tv") > -1) {
                accorTV = Object.assign({}, state.tv, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false
                })
            }
            if (action.value.indexOf("voice") > -1) {
                accorVoice = Object.assign({}, state.voice, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false
                })
            }
            if (action.value.indexOf("contract") > -1) {
                accorContract = Object.assign({}, state.contract, {
                    isAccordionOpen: false
                })
            }
            if (action.value.indexOf("sploffer") > -1) {
                datasploffer = Object.assign({}, state.sploffer.data, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false
                })
                tvsploffer = Object.assign({}, state.sploffer.tv, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false
                })
                sploffer = Object.assign({}, state.sploffer, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false,
                    data: datasploffer,
                    tv: tvsploffer
                })
            }
            if (action.value.indexOf("flashoffer") > -1) {
                flashoffer = Object.assign({}, state.flashoffer, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false
                })
            }
            if (action.value.indexOf("streamingdev") > -1) {
                streamDev = Object.assign({}, state.streamDev, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false
                })
            }
            else if (action.value.indexOf("stream") > -1) {
                streamServ = Object.assign({}, state.streamServ, {
                    isAccordionOpen: false,
                    isSubAccordionOpen: false
                })
            }
            return Object.assign({}, state, {
                voice: accorVoice,
                tv: accorTV,
                perks:accorPerks,
                internet: accorData,
                contract: accorContract,
                sploffer: sploffer,
                flashoffer: flashoffer,
                streamServ: streamServ,
                streamDev: streamDev
            })
        case 'TOGGLE_FOCUS_ACCORDION':
            return Object.assign({}, state, {
                focusAccordion: action.value === true,
            })

        case 'TOGGLE_FOCUS_PARENT_ACCORDION':
            return Object.assign({}, state, {
                focusParentAccordion: false,
                focusAccordion: false
            })

        case 'INTERNET_SELECTEDPROD':
            let prodOnprofile =state.internet.m2mPlans && state.internet.m2mPlans.filter(each=>each.isprdOnProfile)
            let prodOnprofileId =prodOnprofile && prodOnprofile.length>0?prodOnprofile[0].id:"";
            const mnSplOfferAvailable = state?.isMNEnabled && action?.value && (action?.value?.speedCode === '947' || action?.value?.speedCode === '941');

            let selectedInternet = Object.assign({}, state.internet, {
                selectedProduct: action.value,
                isSubAccordionOpen: state.emergencyNotification.isGPONMochaEligible && action.value !== null && (action.value.speedCode === '937' || action.value.speedCode === '936') ,
                subAccordionStatus: action.value === null ? '' : action.value.id===prodOnprofileId ? '' : 'added',
                isAccordionOpen: ((state.router.selectedProduct !== null && state.techsure.selectedProduct !== null && state.techsurecloud.selectedProduct !== null && state.fne.selectedProduct !== null && action.value !== null && action.value.isAlaCarte !== true) || (!state.internet.visitflag && state.defaultAccordion == 'AddTvReveal')) ? false : true,
                visitflag: true,
            })
            // let selectedInternet = Object.assign({}, state.internet, {
            //     selectedProduct: action.value,
            //     isSubAccordionOpen: state.emergencyNotification.isGPONMochaEligible && action.value !== null && (action.value.speedCode === '937' || action.value.speedCode === '936'),
            //     subAccordionStatus: action.value === null ? '' : 'added',
            //     isAccordionOpen: (state.router.selectedProduct !== null && state.techsure.selectedProduct !== null && state.techsurecloud.selectedProduct !== null && state.fne.selectedProduct !== null && action.value !== null && action.value.isAlaCarte !== true) ? false : true
            // })

            return Object.assign({}, state, {
                internet: selectedInternet,
                router: Object.assign({}, state.router, {
                    isAccordionOpen: (!mnSplOfferAvailable && !selectedInternet.isSubAccordionOpen && state.router.selectedProduct === null
                        && state.techsure.selectedProduct === null && state.techsurecloud.selectedProduct === null && state.fne.selectedProduct === null
                        && !state.productOnProfileStatus.router && !state.productOnProfileStatus.fne) ? true : false
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: !(!selectedInternet.isSubAccordionOpen
                        && state.router.selectedProduct === null && state.fne.selectedProduct === null
                        && state.techsure.selectedProduct === null && state.techsurecloud.selectedProduct === null
                        && !state.productOnProfileStatus.router && !state.productOnProfileStatus.fne)
                        && state.flashoffer.isFlashOffer && state.flashoffer.selectedProduct === null ? true : false,
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: (!selectedInternet.isSubAccordionOpen && state.fne.selectedProduct === null &&
                        state.router.selectedProduct !== null && state.techsure.selectedProduct === null && state.techsurecloud.selectedProduct === null
                        && !state.productOnProfileStatus.router && !state.productOnProfileStatus.fne) ? true : false
                }),
                techsure: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ?  Object.assign({}, state.techsure, {
                    isAccordionOpen: true
                 }) : Object.assign({}, state.techsure),
                // techsure: Object.assign({}, state.techsure, {
                //     isAccordionOpen: (state.techsure.selectedProduct === null && state.router.selectedProduct !== null && state.fne.selectedProduct === null && !state.sploffer.isDataOffer) ? true : false
                // }),
                // tv: Object.assign({}, state.tv, {
                //     isSubAccordionOpen: (state.router.selectedProduct !== null && state.techsure.selectedProduct !== null && state.fne.selectedProduct !== null && action.value !== null && action.value.isAlaCarte !== true) ? true : false,
                //     isAccordionOpen: (state.router.selectedProduct !== null && state.techsure.selectedProduct !== null && state.fne.selectedProduct !== null && action.value !== null && action.value.isAlaCarte !== true) ? true : false
                // }),
                tv: (state.isExpandAccordion === 'TestA' || state.isExpandAccordion === 'TestB') ? {...state.tv} : Object.assign({}, state.tv, {
                    isSubAccordionOpen: (state.router.selectedProduct !== null && state.fne.selectedProduct !== null && action.value !== null && action.value.isAlaCarte !== true) ? true : false,
                    isAccordionOpen: (state.router.selectedProduct !== null && state.fne.selectedProduct !== null && action.value !== null && action.value.isAlaCarte !== true) ? true : false
                }),
                //sploffer: availableSpecialOffersInternet
                perks: state.isExpandAccordion === 'TestB' ? Object.assign({}, state.perks, {
                    isAccordionOpen: action.value ? true : false
                }) : Object.assign({}, state.perks, {
                    isAccordionOpen: !selectedInternet.isAccordionOpen && !selectedInternet.isSubAccordionOpen
                })
            })
        case 'INTERNET_SELECTEDPRODID':

            let selectedIternetData = Object.assign({}, state.internet.selectedProduct, {
                id: action.value,
            })
            let tempSelectedInternet = Object.assign({}, state.internet, {
                selectedProduct: selectedIternetData,
                isSubAccordionOpen: false,
                subAccordionStatus: action.value === null ? 'required' : 'added'
            })

            return Object.assign({}, state, {
                internet: tempSelectedInternet,

            })
        case 'TV_SELECTEDPROD':

            let isCustomtvPrd = (action.value !== null && (action.value.prodTypeValue === "CUSTOM_GENERIC" || action.value.prodTypeVal === "CUSTOM_GENERIC")) ? true : false;
            let isLocalPrd = (action.value !== null && action.value.prodTypeValue === "LOCLDGTL") ? true : false;
            let isYoutubePrd = (action.value !== null && action.value.prodTypeValue === Service.youtube) ? true : false;
            let prodOnProfileTV = state.tv.m2mPlans && state.tv.m2mPlans.filter(each => each.isprdOnProfile)
            let prodOnProfileTVId = prodOnProfileTV && prodOnProfileTV.length > 0 ? prodOnProfileTV[0].id : ""

            let subAccordionStatus = action.value === null ? '' : prodOnProfileTVId && action.value.prodId == prodOnProfileTVId ? '' : 'added';
            if (action.value !== null && (action.value.prodTypeValue === 'Fios_Five' || action.value.prodTypeVal === 'Fios_Five')) {
                if (state.tv.fiosFiveSelectedChannels && state.tv.fiosFiveSelectedChannels.length) {
                    subAccordionStatus = 'added';
                } else {
                    subAccordionStatus = 'required';
                }
            }

            let selectedTv = Object.assign({}, state.tv, {
                selectedProduct: action.value && prodOnProfileTVId && action.value.prodId == prodOnProfileTVId ? null: action.value,
                isSubAccordionOpen: false,
                // subAccordionStatus: action.value === null ? 'required' : 'added',
                subAccordionStatus: subAccordionStatus,
                isAccordionOpen: (action.value === null || (isYoutubePrd && (InHomeUtils.isNull(state.streamDev.streamDevProd) || (InHomeUtils.isNotNull(state.streamDev.streamDevProd) && state.streamDev.streamDevProd.length == 0)))) ?state.sweetnerReducer.tv.visible? true: false : true,
                customTV: Object.assign({}, state.tv.customTV, {
                    isAccordionOpen: isCustomtvPrd ? true : false
                }),
                localChannelMsg: isLocalPrd
            })

            // To Pre-select / deselect Streaming bundle connection when TV selection is altered
            // let ceAppsUpdated = null;
            // if(state.vRoom.selectedProduct !== null && state.defaultCeApps !== null && (action.value.id === 'R3377' || action.value.id === 'R3375')) {
            //     ceAppsUpdated = state.defaultCeApps;
            // }

            let objTVAcc = { dct: false, recordingAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, vRoomAccor: false, focusAccordion: false }

            if (!NCFlow && !isCustomtvPrd) {
                if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objTVAcc.routerAccor = true;
                }
                if (state.dct.isDCTEligible !== undefined && state.dct.isDCTEligible !== null && state.dct.isDCTEligible === true && state.dct.selectedProduct === null) {
                    objTVAcc.dct = true;
                }
                if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                    objTVAcc.vRoomAccor = true;
                }
                if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objTVAcc.recordingAccor = true;
                }
                if(state.vRoom.selectedProduct === null && state.channel.selectedProduct === null && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null ){
                    objTVAcc.recordingAccor = true;
                }
                if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objTVAcc.chnlAccor = true;
                }
                if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objTVAcc.intrlChnAccor = true;
                }
                objTVAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            else if (!isCustomtvPrd) {
                if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objTVAcc.routerAccor = true;
                }
                else if (state.dct.isDCTEligible !== undefined && state.dct.isDCTEligible !== null && state.dct.isDCTEligible === true && state.dct.selectedProduct === null) {
                    objTVAcc.dct = true;
                }
                else if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                    objTVAcc.vRoomAccor = true;
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objTVAcc.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objTVAcc.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objTVAcc.intrlChnAccor = true;
                }
                objTVAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                tv: selectedTv,
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objTVAcc.routerAccor
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: objTVAcc.dct,
                    accordionStatus: (state.dct.isDCTEligible !== undefined && state.dct.isDCTEligible !== null && state.dct.isDCTEligible === true && state.dct.selectedProduct === null) ? 'required' : 'added'
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objTVAcc.vRoomAccor,
                    // selectedProduct: (state.vRoom.selectedProduct !== null && state.vRoom.selectedProduct.id === 'NOVROOM') ? null : state.vRoom.selectedProduct,
                    // accordionStatus: (state.vRoom.selectedProduct === null ? 'required' : 'added')
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objTVAcc.recordingAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objTVAcc.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objTVAcc.intrlChnAccor
                }),
                // ceApps: Object.assign({}, state.ceApps, {
                //     selectedProduct: ceAppsUpdated,
                //     isAccordionOpen: ceAppsUpdated === null
                // }),
                //sploffer: availableSpecialOffersTV,
                // focusAccordion: objTVAcc.focusAccordion
            })
        case 'CUSTOMTV_SELECTEDPROD':
            let custTVPlan = Object.assign({}, state.tv.customTV, {
                selectedProduct: action.value,
                isAccordionOpen: (action.value !== null || (action.value == null && state.tv.selectedProduct !== null && ((state.tv.selectedProduct.prodTypeValue !== undefined && state.tv.selectedProduct.prodTypeValue !== "CUSTOM_GENERIC") || (state.tv.selectedProduct.prodTypeVal !== undefined && state.tv.selectedProduct.prodTypeVal !== "CUSTOM_GENERIC")))) ? false : true,
                accordionStatus: (action.value !== null || (action.value == null && state.tv.selectedProduct !== null && ((state.tv.selectedProduct.prodTypeValue !== undefined && state.tv.selectedProduct.prodTypeValue !== "CUSTOM_GENERIC") || (state.tv.selectedProduct.prodTypeVal !== undefined && state.tv.selectedProduct.prodTypeVal !== "CUSTOM_GENERIC")))) ? 'added' : 'required',
            })
            let custTV = Object.assign({}, state.tv, {
                customTV: custTVPlan,
                isSubAccordionOpen: state.tv.selectedProduct !== null ? false : true
            })

            // let availableSpecialOffersCustomTV = Object.assign({}, state.sploffer, {
            //     offerplans: action.value !== null && action.value.specialOffers !== undefined ? action.value.specialOffers : null
            // })

            let objcustTVAcc = { dct: false, recordingAccor: false, routerAccor: false, chnlAccor: false, intrlChnAccor:false, vRoomAccor: false, focusAccordion: false }

            if (!NCFlow && (action.value !== null || (action.value == null && state.tv.selectedProduct !== null && ((state.tv.selectedProduct.prodTypeValue !== undefined && state.tv.selectedProduct.prodTypeValue !== "CUSTOM_GENERIC") || (state.tv.selectedProduct.prodTypeVal !== undefined && state.tv.selectedProduct.prodTypeVal !== "CUSTOM_GENERIC"))))) {
                if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objcustTVAcc.routerAccor = true;
                }
                if (state.dct.isDCTEligible !== undefined && state.dct.isDCTEligible !== null && state.dct.isDCTEligible === true && state.dct.selectedProduct === null) {
                    objcustTVAcc.dct = true;
                }
                if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                    objcustTVAcc.vRoomAccor = true
                }
                if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objcustTVAcc.recordingAccor = true;
                }
                if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objcustTVAcc.chnlAccor = true;
                }
                if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objcustTVAcc.intrlChnAccor = true;
                }
                objcustTVAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            else if (action.value !== null || (action.value == null && state.tv.selectedProduct !== null && ((state.tv.selectedProduct.prodTypeValue !== undefined && state.tv.selectedProduct.prodTypeValue !== "CUSTOM_GENERIC") || (state.tv.selectedProduct.prodTypeVal !== undefined && state.tv.selectedProduct.prodTypeVal !== "CUSTOM_GENERIC")))) {
                if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objcustTVAcc.routerAccor = true;
                }
                else if (state.dct.isDCTEligible !== undefined && state.dct.isDCTEligible !== null && state.dct.isDCTEligible === true && state.dct.selectedProduct === null) {
                    objcustTVAcc.dct = true;
                }
                else if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                    objcustTVAcc.vRoomAccor = true
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objcustTVAcc.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objcustTVAcc.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objcustTVAcc.intrlChnAccor = true;
                }
                objcustTVAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                tv: custTV,
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: objcustTVAcc.dct
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objcustTVAcc.vRoomAccor
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objcustTVAcc.recordingAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objcustTVAcc.routerAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objcustTVAcc.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objcustTVAcc.intrlChnAccor
                }),
                //sploffer: availableSpecialOffersCustomTV,
                // focusAccordion: objcustTVAcc.focusAccordion
            })
        case 'CONTRACTOFFER_UPDATE_CONTRACT':

            let offerContract = Object.assign({}, state.contractoffer, {
                offerContract: action.value,

            })

            return Object.assign({}, state, {
                contractoffer: offerContract,
            })
        case 'CONTRACTOFFER_SELECTEDPRODID':

            let selectedcontractOffer = Object.assign({}, state.contractoffer, {
                offersInCart: action.value,

            })

            return Object.assign({}, state, {
                contractoffer: selectedcontractOffer,
            })
        case 'SPLOFFER_SELECTEDPRODID':

            let selectedsplOffer = Object.assign({}, state.sploffer, {
                selectedProduct: action.value,
                accordionStatus: action.value !== null ? 'completed' : 'required',
                subAccordionStatus: action.value !== null ? 'added' : 'required'
            })

            return Object.assign({}, state, {
                sploffer: selectedsplOffer,
            })
        case 'SPLOFFER_SELECTEDPRODID_DATA':

            let selectedDatasplOffer = Object.assign({}, state.sploffer.data, {
                selectedProduct: action.value,
                accordionStatus: action.value !== null ? 'completed' : 'required',
                subAccordionStatus: action.value !== null ? 'added' : 'required',
                isAccordionOpen: false
            })
            let dataSplOffer = Object.assign({}, state.sploffer, {
                selectedProduct: action.value,
                accordionStatus: action.value !== null ? 'completed' : state.sploffer.accordionStatus,
                subAccordionStatus: action.value !== null ? 'added' : state.sploffer.subAccordionStatus,
                data: selectedDatasplOffer
            })
            return Object.assign({}, state, {
                sploffer: dataSplOffer,
                router: Object.assign({}, state.router, {
                    // isAccordionOpen: false
                    // isAccordionOpen: state?.isMNEnabled ? true : (state.fne.selectedProduct === null && state.router.selectedProduct !== null && state.techsure.selectedProduct === null && state.techsurecloud.selectedProduct === null
                    //     ? false
                    //     : state.router.isAccordionOpen)
                    isAccordionOpen: (state.fne.selectedProduct === null && state.router.selectedProduct !== null && state.techsure.selectedProduct === null && state.techsurecloud.selectedProduct === null
                        ? false
                        : state.router.isAccordionOpen)
                }),
                mm3internetsub: Object.assign({}, state.mm3internetsub, {
                    isAccordionOpen: false
                }),

                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: state.fne.selectedProduct === null &&
                        state.router.selectedProduct !== null && state.techsure.selectedProduct === null && state.techsurecloud.selectedProduct === null
                }),
                techsure: Object.assign({}, state.techsure, {
                    // isAccordionOpen: state.techsure.selectedProduct === null && state.router.selectedProduct !== null && state.fne.selectedProduct === null
                    isAccordionOpen: false
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    // isAccordionOpen: state.techsure.selectedProduct === null && state.router.selectedProduct !== null && state.fne.selectedProduct === null
                    isAccordionOpen: false
                }),
            })
        case 'SPLOFFER_SELECTEDPRODID_TV':

            let selectedTVsplOffer = Object.assign({}, state.sploffer.tv, {
                selectedProduct: action.value,
                accordionStatus: action.value !== null ? 'completed' : state.sploffer.accordionStatus,
                subAccordionStatus: action.value !== null ? 'added' : state.sploffer.subAccordionStatus
            })
            let tvSplOffer = Object.assign({}, state.sploffer, {
                tv: selectedTVsplOffer
            })
            return Object.assign({}, state, {
                sploffer: tvSplOffer
            })
        case 'FLASHOFFER_SELECTEDPRODID':

            let selectedflashOffer = Object.assign({}, state.flashoffer, {
                selectedProduct: action.value === 'no value' ? null : action.value,
                accordionStatus: action.value === null ? 'required' : action.value === 'no value' ? 'completed' : '',
                subAccordionStatus: action.value === null ? 'required' : 'added',
                isAccordionOpen : false
            })
        return Object.assign({}, state, {
                mm3internetsub: Object.assign({}, state.mm3internetsub, {
                    isAccordionOpen: true
                }),
                flashoffer: selectedflashOffer,
            })
        case 'OTTBASIC_SELECTEDPROD':
            let selStreamServ = Object.assign({}, state.streamServ, {
                selectedProduct: action.value,
                isSubAccordionOpen: false,
                subAccordionStatus: action.value === null ? 'optional' : 'added',
                isAccordionOpen: action.value === null ? false : true
            })
            return Object.assign({}, state, {
                streamServ: selStreamServ,
                streamDev: Object.assign({}, state.streamDev, {
                    isAccordionOpen: (state.streamDev.selectedProduct === null) ? true : false
                }),
                streamDevCount: Object.assign({}, state.streamDevCount, {
                    isAccordionOpen: (state.streamDevCount.selectedProduct === null) ? false : false
                }),
                tv: Object.assign({}, state.tv, {
                    isAccordionOpen: state.internet.selectedProduct==null && state.tv.vms1100Eligible && state.tv.FiosTvOneSelected?true:false,
                    isSubAccordionOpen:state.internet.selectedProduct==null && state.tv.vms1100Eligible && state.tv.FiosTvOneSelected?false:state.tv.isAccordionOpen
                })
            })
        case 'SLING_SELECTEDPROD':
            let selSlingStreamServ = Object.assign({}, state.slingStreamServ, {
                selectedProduct: action.value

            })
            return Object.assign({}, state, {
                slingStreamServ: selSlingStreamServ,
                tv: Object.assign({}, state.tv, {
                    isAccordionOpen: false
                })
            })
        case 'OTTEQUIPNRC_SELECTEDPROD':
            let selStreamDev = Object.assign({}, state.streamDev, {
                selectedProduct: action.value,
                isAccordionOpen: (action.value === null) ? false : true
            })
            let selstreamDevCount = Object.assign({}, state.streamDevCount, {
                isAccordionOpen: true,
                selectedProduct: { name: "1 Stream TV Device", unitCount: 1 },
            })
            return Object.assign({}, state, {
                streamDev: selStreamDev,
                streamDevCount: selstreamDevCount
            })
        case 'STREAMDEVCNT_SELECTEDPROD':
            let selStreamDevCnt = Object.assign({}, state.streamDevCount, {
                isAccordionOpen: false,
                selectedProduct: action.value,
            })
            return Object.assign({}, state, {
                streamDevCount: selStreamDevCnt,
            })
        case 'STREAMDEVCNTRESUME_SELECTEDPROD':
            let selStreamDevCntre = Object.assign({}, state.streamDevCount, {
                isAccordionOpen: false,
                selectedProduct: {
                    name: (action.value == "1") ? action.value + " Stream TV Device" : action.value + " Stream TV Devices",
                    unitCount: action.value
                }
            })
            return Object.assign({}, state, {
                streamDevCount: selStreamDevCntre,
            })
        case 'UPDATE_VIDEO_CONTRACT':
            let tvContract = Object.assign({}, state.tv, {
                contract: action.value,
            })
            return Object.assign({}, state, {
                tv: tvContract
            })
        case 'UPDATE_DATA_CONTRACT':
            let dataContract = Object.assign({}, state.internet, {
                contract: action.value,
            })
            return Object.assign({}, state, {
                internet: dataContract
            })
        case 'UPDATE_PERKS_CONTRACT':
            let perksContract = Object.assign({}, state.perks, {
                contract: action.value,
            })
            return Object.assign({}, state, {
                perks: perksContract
            })
        case 'INTLCALLING_SELECTEDPROD':
            let selectedIntlCalling = Object.assign({}, state.intlCalling, {
                selectedProduct: action.value,
                isSubAccordionOpen: action.value === null,
                accordionStatus: action.value === null && state.intlCalling.profileProduct === null ? 'required' : action.value === null && InHomeUtils.isNotNull(state.intlCalling.profileProduct) ? '': 'added'
            });
            return Object.assign({}, state, {
                intlCalling: selectedIntlCalling
            })
        case 'EC_FIOS_VOICE_SELECTEDPROD':
            let selectVoice = Object.assign({}, state.voice, {
                selectedProduct: action.value,
                isSubAccordionOpen: action.value === null ? true: false,
                subAccordionStatus: action.value === null ? '' : 'added'
            })
            let objVoiceAccordion = { intlCallingAccor:false, intlPlansAccor:false, listingAccor: false, backupAccor: false, emergServAccor:false, focusAccordion: false }

            if (action.value !== null) {
                if (state.intlCalling.selectedProduct === null) {
                    objVoiceAccordion.intlCallingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objVoiceAccordion.intlPlansAccor = true;
                }
                else if (state.listing.selectedProduct === null) {
                    objVoiceAccordion.listingAccor = true;
                }
                else if (state.backup.selectedProduct === null || (state.backup.isShipmentAvailable && state.backup.shipment.selectedProduct === null)) {
                    objVoiceAccordion.backupAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null) {
                    objVoiceAccordion.emergServAccor = true;
                }
                objVoiceAccordion.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                voice: selectVoice,
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: objVoiceAccordion.intlCallingAccor
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: objVoiceAccordion.intlPlansAccor
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: objVoiceAccordion.listingAccor
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: objVoiceAccordion.backupAccor
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: objVoiceAccordion.emergServAccor
                }),
                // focusAccordion: objVoiceAccordion.focusAccordion
            })
        case 'EC_LISTING_SELECTEDPROD':
            let selectListing = Object.assign({}, state.listing, {
                selectedProduct: action.value,
                isAccordionOpen: action.value !== null,
                accordionStatus: action.value === null ? 'required' : 'added'
            })

            let objListingAccordion = { backupAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.backup.selectedProduct === null || (state.backup.isShipmentRequired && state.backup.shipment.selectedProduct === null)) {
                    objListingAccordion.backupAccor = true;
                }
                objListingAccordion.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                listing: selectListing,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) || (action.value !== null && !objListingAccordion.backupAccor && !selectListing.isAccordionOpen)) ? false : true
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: objListingAccordion.backupAccor
                }),
                // focusAccordion: objListingAccordion.focusAccordion
            })
        case 'EC_BATTERY_SELECTEDPROD':
            let selectBackup = Object.assign({}, state.backup, {
                selectedProduct: action.value,
                isAccordionOpen: action.value != null,
                accordionStatus: action.value === null || (action.value != null && action.value.keyword.indexOf("CHARGED") > -1 && state.backup.isShipmentAvailable) ? 'required' : 'added',
                isShipmentRequired: action.value != null && action.value.keyword.indexOf("CHARGED") > -1 && state.backup.isShipmentAvailable
            })

            let objBackupAccordion = { listingAccor: false, focusAccordion: false }

            if (action.value !== null && !selectBackup.isShipmentRequired) {
                if (state.listing.selectedProduct === null) {
                    objBackupAccordion.listingAccor = true;
                }
                objBackupAccordion.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                backup: selectBackup,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) || (action.value !== null && !objBackupAccordion.listingAccor && !selectBackup.isAccordionOpen)) ? false : true
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: objBackupAccordion.listingAccor
                }),
                // focusAccordion: objBackupAccordion.focusAccordion
            })
        case 'FIOS_VOICE_SELECTEDPROD':
            let selectedVoice = Object.assign({}, state.voice, {
                selectedProduct: action.value,
                isSubAccordionOpen: !state.voice.isSubAccordionOpen,
                subAccordionStatus: action.value === null ? '' : 'added'
            })
            // let availableSpecialOffersCustomVoice = Object.assign({}, state.sploffer, {
            //     offerplans: action.value !== null && action.value.specialOffers !== undefined ? action.value.specialOffers : null
            // })

            let objVoiceAcc = {intlCallingAccor:false,intlPlansAccor:false, winbackAccor: false, listingAccor: false, backupAccor: false, emergServAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.intlCalling.selectedProduct === null) {
                    objVoiceAcc.intlCallingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objVoiceAcc.intlPlansAccor = true;
                }
                else if (state.winback.selectedProduct === null) {
                    objVoiceAcc.winbackAccor = true;
                }
                else if (state.listing.selectedProduct === null) {
                    objVoiceAcc.listingAccor = true;
                }
                else if (state.backup.selectedProduct === null || (state.backup.isShipmentAvailable && state.backup.shipment.selectedProduct === null)) {
                    objVoiceAcc.backupAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null) {
                    objVoiceAcc.emergServAccor = true;
                }
                objVoiceAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                voice: selectedVoice,
                intlCalling: Object.assign({}, state.intlCalling, {
                    isAccordionOpen: objVoiceAcc.intlCallingAccor
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: objVoiceAcc.intlPlansAccor
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: objVoiceAcc.winbackAccor
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: objVoiceAcc.listingAccor
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: objVoiceAcc.backupAccor
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: objVoiceAcc.emergServAccor
                }),

                //sploffer: availableSpecialOffersCustomVoice,
                // focusAccordion: objVoiceAcc.focusAccordion
            })
        case 'MM3_ROUTER_OPENACCOR':
                let mm3selectedRouter = Object.assign({}, state.router, {
                    isAccordionOpen: true
                });
                return Object.assign({}, state, {
                    router: mm3selectedRouter,}
                )

        case 'EC_AccessPoint_SELECTEDPROD':
            let selectedAccessPoint = Object.assign({}, state.accessPoint, {
                selectedProduct: action.value,
                accordionStatus: action.value === null  ? 'optional' : 'added',
                isAccordionOpen: action.value === null ? true : action.value?.prodType === 'ACCESSPOINTNRCBILLER' && action.value?.quantity > 0 ? true : false,
            })
            return Object.assign({}, state, {
                accessPoint: selectedAccessPoint,
            })
        case 'EC_BuyAccessPoint_SELECTEDPROD':
            let selectedBuyAccessPoint = Object.assign({}, state.accessPoint, {
                buySelectedProduct: action.value,
                accordionStatus: action.value === null  ? 'optional' : 'added',
                isAccordionOpen: action.value === null ? true : action.value?.prodType === 'ACCESSPOINTNRCBILLER' && action.value?.quantity > 0 ? true : false,
            })
            return Object.assign({}, state, {
                accessPoint: selectedBuyAccessPoint,
            })
        case 'EC_RentAccessPoint_SELECTEDPROD':
            let selectedRentAccessPoint = Object.assign({}, state.rentAccessPoint, {
                rentSelectedProduct: action.value,
            })
            return Object.assign({}, state, {
                rentAccessPoint: selectedRentAccessPoint
            })
        case 'AccessPoint_SELECTEDPROD':
        case 'ROUTER_SELECTEDPROD':
        case 'SELECTROUTER_SELECTEDPROD':
        case 'SELECTACCESSPOINT_SELECTEDPROD':
            let routerprodOnprofile = state.router.equipments &&  state.router.equipments.filter(each=>each.isprdOnProfile)
            // console.log("router",routerprodOnprofile)
            routerprodOnprofile = Array.isArray(routerprodOnprofile)?routerprodOnprofile[0]:routerprodOnprofile
            let routerProdOnprofileId = routerprodOnprofile && routerprodOnprofile!==null?(routerprodOnprofile.prodId || routerprodOnprofile.id):""
            let selectedRouter = Object.assign({}, state.router, {
                selectedProduct: action.value && (action.value.id===routerProdOnprofileId || action.value.prodId ===routerProdOnprofileId)?null:action.value,
                accordionStatus: action.value === null  ? 'required' : 'added',
                isAccordionOpen: action.value === null ? true : state.sweetnerReducer.router.visible || state.tv.vms1100Eligible?true : false
            })

            let objrouterAcc = { internetAccor: false, tvAccor: false, techsureAccor: false, techsurecloudAccor:false, fneAccor: false, custTVAccor: false, vRoomAccor: false, recordingAccor: false, chnlAccor: false, intrlChnAccor:false, focusAccordion: false, splOfferAccor: false, flashOfferAccor: false }

            if (state.internet.selectedProduct !== null || state.productOnProfileStatus.internet) {
                objrouterAcc.internetAccor = true
            }
            else if (state.tv.selectedProduct !== null || state.productOnProfileStatus.tv) {
                objrouterAcc.tvAccor = true
            }
            const routerProfileProduct =state.router.equipments


           const olderRouterVersions = state.tv.vms1100Eligible ? !(InHomeUtils.isNotNull(routerProfileProduct) && InHomeUtils.isNotEmpty(routerProfileProduct) && InHomeUtils.isNotNull(routerProfileProduct[0]) &&InHomeUtils.isNotEmpty(routerProfileProduct[0]) && routerProfileProduct[0]&& InHomeUtils.isNotNull(routerProfileProduct[0].keyword) && InHomeUtils.isNotEmpty(routerProfileProduct[0].keyword) && (routerProfileProduct[0].keyword.includes("BHRX") ||routerProfileProduct[0].keyword.includes("CHR") || routerProfileProduct[0].keyword.includes("BHR4") || routerProfileProduct[0].keyword.includes("FQGRENTAL") || routerProfileProduct[0].keyword.includes("ROUTERCATEGORY:200")|| routerProfileProduct[0].keyword.includes("DESC:FIOS_QUANTUM_GATEWAY")||routerProfileProduct[0].keyword.includes("|OWNERSHIP:CUSTOMER|"))) : false

            if (objrouterAcc.internetAccor) {
                if (action.value !== null) {
                    if (state.sploffer.isDataOffer && state.sploffer.subAccordionStatus != 'added') {
                        objrouterAcc.splOfferAccor = true
                    }
                    else if (state.flashoffer.isFlashOffer && state.flashoffer.subAccordionStatus != 'added') {
                        objrouterAcc.flashOfferAccor = true
                    }
                    //Fix for CETC-143028 - to collapse the optional sub-accordions after selecting an internt plan
                    /*else if (state.techsure.selectedProduct === null) {
                        objrouterAcc.techsureAccor = state.tv.vms1100Eligible && olderRouterVersions?false:true
                    }
                    else if (state.techsurecloud.selectedProduct === null) {
                        objrouterAcc.techsurecloudAccor = state.tv.vms1100Eligible && olderRouterVersions?false:true
                    }*/
                    else if (state.fne.selectedProduct === null && !state.productOnProfileStatus.fne) {
                        objrouterAcc.fneAccor =state.tv.vms1100Eligible && olderRouterVersions?false:true
                    }
                    else {
                        objrouterAcc.internetAccor = false
                    }
                    objrouterAcc.focusAccordion =action.preSelect!==null?false: true
                    if(state.tv.vms1100Eligible && olderRouterVersions){
                        objrouterAcc.focusAccordion =  true
                    }
                }
            }
            if (objrouterAcc.tvAccor) {
                if (action.value !== null) {
                    if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                        objrouterAcc.custTVAccor = true
                    }
                    else if (state.dct.isDCTEligible !== undefined && state.dct.isDCTEligible !== null && state.dct.isDCTEligible === true && state.dct.selectedProduct === null) {
                        objrouterAcc.dctAccor = true
                    }
                    else if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                        objrouterAcc.vRoomAccor = true
                    }
                    else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                        objrouterAcc.recordingAccor = true
                    }
                    else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                        objrouterAcc.chnlAccor = true
                    }
                    else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                        objrouterAcc.intrlChnAccor = true
                    }
                    else {
                        objrouterAcc.tvAccor = false;
                    }
                    objrouterAcc.focusAccordion =action.preSelect!==null?false: true;
                }
            }
            let isWholeHomeWifiAdded = InHomeUtils.isNotNull(action.value)&& InHomeUtils.isNotNull(action.value.name) && action.value.id=='R0641' ? true: false;
            let isWholeHomeWifiPlusAdded = InHomeUtils.isNotNull(action.value)&& InHomeUtils.isNotNull(action.value.name) && InHomeUtils.isNotNull(action?.value?.keyword) && action?.value?.keyword.includes('|WHW+|') && action?.value?.prodType == "ROUTERBILLER" ? true: false;
            let isWholeHomeWifi2Added = InHomeUtils.isNotNull(action.value)&& InHomeUtils.isNotNull(action.value.name) && InHomeUtils.isNotNull(action?.value?.keyword) && action?.value?.keyword.includes('|WHW2.0|') && action?.value?.prodType == "ROUTERBILLER" ? true: false;
            let selectedWHWExtender = isWholeHomeWifiAdded && state.fne.equipments &&  state.fne.equipments.filter(item=> item.id === 'R0642' || item.prodId === 'R0642');
            let accessPointExtender = action.value === null ? null : action.value?.apitype === 'extender' ? action.value : null;

            return Object.assign({}, state, {
                router: selectedRouter,
                internet: Object.assign({}, state.internet, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : objrouterAcc.internetAccor
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : objrouterAcc.techsureAccor
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: objrouterAcc.techsurecloudAccor
                }),
                fne: Object.assign({}, state.fne, {
                    selectedProduct: selectedWHWExtender && selectedWHWExtender.length > 0 ? selectedWHWExtender[0] : accessPointExtender ,
                    accordionStatus: (selectedWHWExtender && selectedWHWExtender.length > 0 && selectedWHWExtender[0]) || accessPointExtender !== null ? 'added' : 'optional',
                    unitCount: selectedWHWExtender && selectedWHWExtender.length > 0 ? 1: 0,
                    //unitCount: isWholeHomeWifiAdded ? 1: 0,
                    isAccordionOpen: objrouterAcc.fneAccor,
                    isWholeHomeWifiAdded: isWholeHomeWifiAdded,
                    isWholeHomeWifiPlusAdded: isWholeHomeWifiPlusAdded,
                    isWholeHomeWifi2Added: isWholeHomeWifi2Added
                }),
                dct: Object.assign({}, state.dct, {
                    isAccordionOpen: objrouterAcc.dctAccor
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objrouterAcc.vRoomAccor
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objrouterAcc.recordingAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objrouterAcc.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objrouterAcc.intrlChnAccor
                }),
                tv: (state.isExpandAccordion === 'TestA' || state.isExpandAccordion === 'TestB') ? {...state.tv} : Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: objrouterAcc.custTVAccor
                    }),
                    isAccordionOpen: objrouterAcc.tvAccor,
                    isSubAccordionOpen: (action.value !== null && objrouterAcc.tvAccor && !objrouterAcc.recordingAccor && !objrouterAcc.chnlAccor && !objrouterAcc.intrlChnAccor && !objrouterAcc.vRoomAccor && !objrouterAcc.custTVAccor && !objrouterAcc.dctAccor) ? true : false,
                    //isAccordionOpen : InternetAccor.isAccordionOpen?false:(action.value!==null && state.techsure.selectedProduct!==null)?true:false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    isAccordionOpen: objrouterAcc.splOfferAccor
                }),
                flashoffer: Object.assign({}, state.flashoffer, {
                    isAccordionOpen: objrouterAcc.flashOfferAccor
                }),
                // focusAccordion: objrouterAcc.focusAccordion
            })
        case 'TECHSURE_SELECTEDPROD':
           let techsureprodOnprofile = state.techsure.techsureProducts && state.techsure.techsureProducts.filter(each=>each.isprdOnProfile)
           let techsureProdOnprofileId = techsureprodOnprofile && techsureprodOnprofile.length>0?techsureprodOnprofile[0].prodId || techsureprodOnprofile[0].id:""
            // let modTechSureProducts = state.techsure.techsureProducts

            let selectedTechSure = Object.assign({}, state.techsure, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'optional' : 'added',
                isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? false : true,
                modTechSureProducts:action.modTechSureProducts,
                isVzProtectHomeOpen:false
            })

            return Object.assign({}, state, {
                techsure: selectedTechSure,
                router: Object.assign({}, state.router, {
                    isAccordionOpen: false
                }),
            })
            case 'HOMESECURITY_SELECTED_PROD':

                let techsureProds = state.techsure.techsureProducts;
                let modtechsureProds = state.techsure.modTechSureProducts;
                let selectedProd = state.techsure.selectedProduct
                techsureProds?.map((prod)=>prod?.name === "Home Security" ? prod.isChecked = true :'');
                modtechsureProds?.map((prod)=>prod?.name === "Home Security" ? prod.isChecked = true :'');
                selectedProd?.map((prod)=>prod?.name === "Home Security" ? prod.isChecked = true :'')
            let hsTechSure = Object.assign({}, state.techsure, {
                techsureProducts: techsureProds,
                modTechSureProducts : modtechsureProds,
                selectedProduct: selectedProd

            })

            return Object.assign({}, state, {
                techsure: hsTechSure

            })

            case 'VHSBILLER_SELECTEDPROD':
             // let modTechSureProducts = state.techsure.techsureProducts



             let selectedVhsbiller = Object.assign({}, state.vhsBiller, {
                 selectedProduct : action.value,
                 isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? false : true,
                accordionStatus: action.value === null ? 'optional' : 'added'
             })

             return Object.assign({}, state, {
                 vhsBiller: selectedVhsbiller,
                 router: Object.assign({}, state.router, {
                     isAccordionOpen: false
                 }),
             })
        case 'EC_TECHSURE_SELECTEDPROD':
            let ectechsureprodOnprofile = state.techsure.techsureProducts && state.techsure.techsureProducts.filter(each=>each.isprdOnProfile)
            let ectechsureProdOnprofileId = ectechsureprodOnprofile && ectechsureprodOnprofile.length>0?ectechsureprodOnprofile[0].prodId || ectechsureprodOnprofile[0].id:""
             // let modTechSureProducts = state.techsure.techsureProducts

            let ecselectedTechSure = Object.assign({}, state.techsure, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'optional' : 'added',
                isAccordionOpen: false,
                modTechSureProducts: action.modTechSureProducts,
                isVzProtectHomeOpen: false
            })

            return Object.assign({}, state, {
                techsure: ecselectedTechSure
            })
        case "TOGGLE_VZ_PROTECTHOME_SUBPRODUCTS":
            return Object.assign({}, state, {
                techsure: Object.assign({}, state.techsure, {
                    isVzProtectHomeOpen: !state.techsure.isVzProtectHomeOpen
                })
            })

        case 'TECHSUPPORT_SELECTEDPROD':
            // let selectedTechSure = Object.assign({}, state.techsure, {
            //     selectedProduct: action.value,
            //     accordionStatus: action.value === null ? 'optional' : 'added',
            //     isAccordionOpen: true //action.value === null ? true : false
            //     //isAccordionOpen: (action.value !== null && action.value.length === 2) ? false : true
            // })

            let isAccTechStatus
            let objTechAcc = { focusAccordion: false }

            if (action.value == null) {
                if (state.internet.selectedProduct === null) {
                    isAccTechStatus = false
                }
                else {
                    isAccTechStatus = true;
                }
            }
            else {
                if (state.router.selectedProduct !== null) {
                    isAccTechStatus = false
                }
                else {
                    isAccTechStatus = true
                }
                objTechAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            let InternetAccortech = Object.assign({}, state.internet, {
                isAccordionOpen: selectedTechSure.isAccordionOpen //isAccTechStatus
            })
            return Object.assign({}, state, {
                // techsure: selectedTechSure,
                internet: InternetAccortech,
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: InternetAccortech.isAccordionOpen ? false : (action.value !== null && state.router.selectedProduct !== null && state.internet.selectedProduct !== null && state.internet.selectedProduct.isAlaCarte !== true && state.tv.selectedProduct === null) ? true : false,
                    isAccordionOpen: InternetAccortech.isAccordionOpen ? false : (action.value !== null && state.router.selectedProduct !== null && state.internet.selectedProduct !== null && state.internet.selectedProduct.isAlaCarte !== true && state.tv.selectedProduct === null) ? true : false
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: (action.value !== null && state.router.selectedProduct === null) ? true : false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    isAccordionOpen: (action.value !== null && state.sploffer.selectedProduct === null) ? true : false
                }),
                // focusAccordion: objTechAcc.focusAccordion
            })
        case 'TECHSURECLOUD_SELECTEDPROD':
        case 'CLOUD_SELECTEDPROD':
            let cloudProdOnprofile = state.techsurecloud.techsureCloud && state.techsurecloud.techsureCloud.filter(each=>each.isprdOnProfile)
            let cloudProdOnprofileId = ''
            if(cloudProdOnprofile && cloudProdOnprofile.length>0) {
                if(InHomeUtils.isNotNull(cloudProdOnprofile[0].prodId))
                    cloudProdOnprofileId = cloudProdOnprofile[0].prodId;
                else if(InHomeUtils.isNotNull(cloudProdOnprofile[0].id))
                    cloudProdOnprofileId = cloudProdOnprofile[0].id;
            }
            let selectedID = action.value && action.value.id ? action.value.id : action.value && action.value.prodId ? action.value.prodId : '';
            let selectedTechSureVCloud = Object.assign({}, state.techsurecloud, {
                selectedProduct: action.value && selectedID != '' && selectedID === cloudProdOnprofileId ? null : action.value,
                accordionStatus: action.value === null ? 'optional' : 'added',
                isAccordionOpen:  false
                //isAccordionOpen: (action.value !== null && action.value.length === 2) ? false : true
            })
            return Object.assign({}, state, {
                techsurecloud: selectedTechSureVCloud,
            })
        case 'TECHCLOUDSUPPORT_SELECTEDPROD':
            let selectedTechSureCloud = Object.assign({}, state.techsurecloud, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'optional' : 'added',
                isAccordionOpen: false //action.value === null ? true : false
                //isAccordionOpen: (action.value !== null && action.value.length === 2) ? false : true
            })

            let isAccTechCloudStatus
            let objTechCloudAcc = { focusAccordion: false }

            if (action.value == null) {
                if (state.internet.selectedProduct === null) {
                    isAccTechCloudStatus = false
                }
                else {
                    isAccTechCloudStatus = true;
                }
            }
            else {
                if (state.router.selectedProduct !== null) {
                    isAccTechCloudStatus = false
                }
                else {
                    isAccTechCloudStatus = true
                }
                objTechCloudAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            let InternetAccortechcloud = Object.assign({}, state.internet, {
                isAccordionOpen: selectedTechSureCloud.isAccordionOpen //isAccTechStatus
            })
            return Object.assign({}, state, {
                // techsurecloud: selectedTechSureCloud,
                internet: InternetAccortechcloud,
                tv: Object.assign({}, state.tv, {
                    isSubAccordionOpen: InternetAccortechcloud.isAccordionOpen ? false : (action.value !== null && state.router.selectedProduct !== null && state.internet.selectedProduct !== null && state.internet.selectedProduct.isAlaCarte !== true && state.tv.selectedProduct === null) ? true : false,
                    isAccordionOpen: InternetAccortechcloud.isAccordionOpen ? false : (action.value !== null && state.router.selectedProduct !== null && state.internet.selectedProduct !== null && state.internet.selectedProduct.isAlaCarte !== true && state.tv.selectedProduct === null) ? true : false
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: (action.value !== null && state.router.selectedProduct === null) ? true : false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    isAccordionOpen: (action.value !== null && state.sploffer.selectedProduct === null) ? true : false
                }),
                // focusAccordion: objTechCloudAcc.focusAccordion
            })

        case 'FNE_SELECTEDPROD':
        case 'SELECTFNE_SELECTEDPROD':
            let selectedFne = Object.assign({}, state.fne, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'optional' : 'added',
                isAccordionOpen: action.value !== null ? true : false,
                unitCount: action.value === null ? 0: action.value.unitCount
            })
            let WifiSweetnerMsg = Object.assign({}, state.sweetnerReducer.fneWifi, {
                visible: (InHomeUtils.isNotNull(action.value) && action.value.unitCount > 0) ? true: false
            })
            let updateSweetnerMsg = Object.assign({}, state.sweetnerReducer, {
                fneWifi: WifiSweetnerMsg
            })

            let objfneAcc = { internetAccor: false, techsureAccor: false, techsurecloudAccor:false, routerAccor: false, focusAccordion: false }

            if (state.internet.selectedProduct !== null || state.productOnProfileStatus.internet) {
                objfneAcc.internetAccor = true
            }

            if (objfneAcc.internetAccor) {
                if (action.value !== null) {
                    if (state.techsure.selectedProduct === null) {
                        objfneAcc.techsureAccor = true
                    }
                    else if (state.techsurecloud.selectedProduct === null) {
                        objfneAcc.techsurecloudAccor = true
                    }
                    else if (state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                        objfneAcc.routerAccor = true
                    }
                    else {
                        objfneAcc.internetAccor = false
                    }
                    objfneAcc.focusAccordion =action.preSelect!==null?false: true;
                }
            }
            return Object.assign({}, state, {
                fne: selectedFne,
                internet: Object.assign({}, state.internet, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : objfneAcc.internetAccor
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: state.internetAccordionFlag === 'A' || state.internetAccordionFlag === 'B' ? true : objfneAcc.techsureAccor
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: objfneAcc.techsurecloudAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objfneAcc.routerAccor
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    isAccordionOpen: (action.value !== null && state.sploffer.selectedProduct === null) ? true : false
                }),
                sweetnerReducer: updateSweetnerMsg,
                // focusAccordion: objfneAcc.focusAccordion
            })
         case 'FNE_WHW_SELECTEDPROD':
            let selectedWhwExtender = Object.assign({}, state.fne, {
                whwExtenderProduct: action.value,
                isAccordionOpen: action.value === null ? true : false,
                accordionStatus: action.value === null ? 'optional' : 'added',

            })
            return Object.assign({}, state, {
                fne: selectedWhwExtender,
            })
        case 'VROOM_SELECTEDPROD':
        case 'ADDTV_SELECTEDPROD':
            let selectedVRoom = Object.assign({}, state.vRoom, {
                selectedProduct: action.value && action.value,
                isAccordionOpen: action.value === null ? true : false,
                accordionStatus: action.value === null ? 'required' : 'added',
                unitCount: action.value && action.value  && action.value.unitCount ? parseInt(action.value.unitCount) : 0
            })

            let objvRoomAcc = { recordingAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, custTVAccor: false, focusAccordion: false, ceAppsAccor: false, tvConnectionsAccor: false }

            if(action.value && action.value.prodType !== 'VROOM'){
                selectedVRoom = Object.assign({}, state.vRoom);
            }
            if (action.value !== null) {
                if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objvRoomAcc.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objvRoomAcc.routerAccor = true;
                }
                else if (state.showConnectedApps && action.value && action.value.unitCount && parseInt(action.value.unitCount) === 1) {
                    objvRoomAcc.ceAppsAccor = true;
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objvRoomAcc.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objvRoomAcc.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objvRoomAcc.intrlChnAccor = true;
                }
                objvRoomAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            return Object.assign({}, state, {
                vRoom: selectedVRoom,
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: objvRoomAcc.tvConnectionsAccor
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: objvRoomAcc.ceAppsAccor
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objvRoomAcc.recordingAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objvRoomAcc.routerAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objvRoomAcc.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objvRoomAcc.intrlChnAccor
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: objvRoomAcc.custTVAccor
                    }),
                    isAccordionOpen: (action.value !== null && !objvRoomAcc.recordingAccor && !objvRoomAcc.chnlAccor  && !objvRoomAcc.intrlChnAccor && !objvRoomAcc.routerAccor && !objvRoomAcc.custTVAccor) ? false : true
                }),
                // focusAccordion: objvRoomAcc.focusAccordion
            })
        case 'VROOM_SELECTEDPROD_CEAPPS':
        case 'ADDTV_SELECTEDPROD_CEAPPS':
            let selectedVRoomCEApps = Object.assign({}, state.vRoom, {
                selectedProduct: action.value && action.value.vRoom,
                isAccordionOpen: action.value === null || action.value.vRoom === null || state.showConnectedApps && !(state.tvConnections.selectedProduct || action.value.dummyvRoom) ? true : false,
                accordionStatus: action.value === null || action.value.vRoom === null ? 'required' : 'added',
                unitCount: action.value && action.value.vRoom  && action.value.vRoom.unitCount ? parseInt(action.value.vRoom.unitCount) : 0
            })

            let objvRoomAccCEApps = { recordingAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, custTVAccor: false, focusAccordion: false, ceAppsAccor: false, tvConnectionsAccor: false }

            if (action.value !== null && !state.showConnectedApps) {
                if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objvRoomAccCEApps.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objvRoomAccCEApps.routerAccor = true;
                }
                else if (state.showConnectedApps && action.value && action.value.unitCount && parseInt(action.value.unitCount) > 1 && state.tvConnections.equipments && state.ceApps.equipments && state.ceApps.selectedProduct === null || state.tvConnections.selectedProduct === null ) {
                    objvRoomAccCEApps.tvConnectionsAccor = true;
                }
                else if (state.showConnectedApps && action.value && action.value.vRoom  && action.value.vRoom.unitCount && parseInt(action.value.vRoom.unitCount) === 1) {
                    objvRoomAccCEApps.ceAppsAccor = true;
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objvRoomAccCEApps.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objvRoomAccCEApps.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objvRoomAccCEApps.intrlChnAccor = true;
                }
                objvRoomAccCEApps.focusAccordion =action.preSelect!==null?false: true;
            }
            else if (state.showConnectedApps && selectedVRoomCEApps.isAccordionOpen) {
                objvRoomAccCEApps.focusAccordion = true;
            }
            return Object.assign({}, state, {
                vRoom: selectedVRoomCEApps,
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: objvRoomAccCEApps.tvConnectionsAccor
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: objvRoomAccCEApps.ceAppsAccor
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objvRoomAccCEApps.recordingAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objvRoomAccCEApps.routerAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objvRoomAccCEApps.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objvRoomAccCEApps.intrlChnAccor
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: objvRoomAccCEApps.custTVAccor
                    }),
                    isAccordionOpen: (action.value !== null && !objvRoomAccCEApps.recordingAccor && !objvRoomAccCEApps.chnlAccor  && !objvRoomAccCEApps.intrlChnAccor && !objvRoomAccCEApps.routerAccor && !objvRoomAccCEApps.custTVAccor) ? false : true
                }),
                // focusAccordion: objvRoomAccCEApps.focusAccordion
            })
        case 'DUMMYVROOM_SELECTEDPROD':
            const stbCount = action.value && action.value.dummyvRoom &&  action.value.dummyvRoom.unitCount
                ? action.value.dummyvRoom.unitCount
                : action?.value?.vRoom?.unitCount
                    ? action?.value?.vRoom?.unitCount
                    : 0;
            let selectedTVConnections = Object.assign({}, state.tvConnections, {
                selectedProduct: action?.value?.dummyvRoom || action?.value?.vRoom,
                isAccordionOpen: state.showConnectedApps && !state.vRoom.isAccordionOpen && ((action.value.vRoom && action.value.vRoom.unitCount && (action.value.dummyvRoom === null || (action.value.dummyvRoom && (stbCount && stbCount !== action.value.vRoom.unitCount) && (!action.value.ceApps)))) || (action.value.ceApps && action.value.ceApps.fromTVConnections)) ? true :false,
                accordionStatus: state.showConnectedApps&& action.value.vRoom && action.value.vRoom.unitCount && (action.value.dummyvRoom === null || (action.value.dummyvRoom && (stbCount && stbCount !== action.value.vRoom.unitCount) && (!action.value.ceApps))) ? 'required' : 'added',
                unitCount: stbCount
            })

            let objtvConnAcc = { vRoomAccor: false, ceAppsAccor: false, recordingAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, custTVAccor: false, focusAccordion: false }
            if(state.vRoom.isAccordionOpen) {
                objtvConnAcc.vRoomAccor = true;
            }
            else if (state.tvConnections.selectedProduct != null){
                objtvConnAcc.recordingAccor = true;
                if (action?.value?.ceApps === null){
                    objtvConnAcc.ceAppsAccor = true;
                }
                else if ((action?.value?.ceApps)) {
                    objtvConnAcc.ceAppsAccor = false;
                }
            }
            else if (action.value !== null && !selectedTVConnections.isAccordionOpen) {
                if (state.showConnectedApps && !action.value.ceApps && !selectedTVConnections.isAccordionOpen && (action.value.vRoom && (action.value.vRoom.unitCount === 1 || (stbCount && stbCount === action.value.vRoom.unitCount)))) {
                    objtvConnAcc.ceAppsAccor = true;
                }
                else if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objtvConnAcc.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objtvConnAcc.routerAccor = true;
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objtvConnAcc.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objtvConnAcc.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objtvConnAcc.intrlChnAccor = true;
                }
                objtvConnAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            else {
                objtvConnAcc.focusAccordion = state.focusAccordion
            }
            return Object.assign({}, state, {
                tvConnections: selectedTVConnections,
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: action.value ? objtvConnAcc.vRoomAccor : state.vRoom.isAccordionOpen
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: action.value ? objtvConnAcc.ceAppsAccor : state.ceApps.isAccordionOpen
                  //  isAccordionOpen: action.value ? true : state.ceApps.isAccordionOpen
                }),

                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: action.value ? objtvConnAcc.recordingAccor : state.recording.isAccordionOpen
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: action.value ? objtvConnAcc.routerAccor : state.router.isAccordionOpen
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: action.value ? objtvConnAcc.chnlAccor : state.channel.isAccordionOpen
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: action.value ? objtvConnAcc.intrlChnAccor : state.internationalChannel.isAccordionOpen
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: action.value ? objtvConnAcc.custTVAccor : state.tv.customTV
                    }),
                    isAccordionOpen: (action.value !== null && !objtvConnAcc.recordingAccor && !objtvConnAcc.chnlAccor  && !objtvConnAcc.intrlChnAccor && !objtvConnAcc.routerAccor && !objtvConnAcc.custTVAccor && !objtvConnAcc.vRoomAccor && !objtvConnAcc.ceAppsAccor && !selectedTVConnections.isAccordionOpen) ? false : true
                }),
                // focusAccordion: objtvConnAcc.focusAccordion
            })
        case 'EC_DUMMYVROOM_SELECTEDPROD':
            const stb_Count = action.value && action.value.dummyvRoom &&  action.value.dummyvRoom.unitCount
                ? action.value.dummyvRoom.unitCount
                : action?.value?.vRoom?.unitCount
                    ? action?.value?.vRoom?.unitCount
                    : 0;
            let selectTVConnections = Object.assign({}, state.tvConnections, {
                selectedProduct: action?.value?.dummyvRoom || action?.value?.vRoom,
                isAccordionOpen: state.showConnectedApps && ((action.value.vRoom && action.value.vRoom.unitCount && (action.value.dummyvRoom === null || (action.value.dummyvRoom && (stb_Count && stb_Count !== action.value.vRoom.unitCount) && (!action.value.ceApps)))) || (action.value.ceApps && action.value.ceApps.fromTVConnections)) ? true :false,
                accordionStatus: state.showConnectedApps&& action.value.vRoom && action.value.vRoom.unitCount && (action.value.dummyvRoom === null || (action.value.dummyvRoom && (stb_Count && stb_Count !== action.value.vRoom.unitCount) && (!action.value.ceApps))) ? 'required' : 'added',
                unitCount: stb_Count
            })

            let objtvConnAccordion = { vRoomAccor: false, ceAppsAccor: false, recordingAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, custTVAccor: false, focusAccordion: false }

            if (action.value !== null && !selectTVConnections.isAccordionOpen) {
                if (state.showConnectedApps && !action.value.ceApps && !selectTVConnections.isAccordionOpen && (action.value.vRoom && (action.value.vRoom.unitCount === 1 || (stb_Count && stb_Count === action.value.vRoom.unitCount)))) {
                    objtvConnAccordion.ceAppsAccor = true;
                }
                else if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objtvConnAccordion.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objtvConnAccordion.routerAccor = true;
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objtvConnAccordion.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objtvConnAccordion.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objtvConnAccordion.intrlChnAccor = true;
                }
                objtvConnAccordion.focusAccordion =action.preSelect!==null?false: true;
            }
            else {
                objtvConnAccordion.focusAccordion = state.focusAccordion
            }
            if(state.sweetnerReducer.vroom.visible){
                objtvConnAccordion.vRoomAccor = true
            }
            return Object.assign({}, state, {
                tvConnections: selectTVConnections,
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: action.value ? objtvConnAccordion.vRoomAccor : state.vRoom.isAccordionOpen
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    isAccordionOpen: action.value ? objtvConnAccordion.ceAppsAccor : state.ceApps.isAccordionOpen
                    //isAccordionOpen: action.value ? true : state.ceApps.isAccordionOpen
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: action.value ? objtvConnAccordion.recordingAccor : state.recording.isAccordionOpen
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: action.value ? objtvConnAccordion.routerAccor : state.router.isAccordionOpen
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: action.value ? objtvConnAccordion.chnlAccor : state.channel.isAccordionOpen
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: action.value ? objtvConnAccordion.intrlChnAccor : state.internationalChannel.isAccordionOpen
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: action.value ? objtvConnAccordion.custTVAccor : state.tv.customTV
                    }),
                    isAccordionOpen: (action.value !== null && !objtvConnAccordion.recordingAccor && !objtvConnAccordion.chnlAccor  && !objtvConnAccordion.intrlChnAccor && !objtvConnAccordion.routerAccor && !objtvConnAccordion.custTVAccor && !objtvConnAccordion.vRoomAccor && !objtvConnAccordion.ceAppsAccor && !selectTVConnections.isAccordionOpen) ? false : true
                }),
                // focusAccordion: objtvConnAccordion.focusAccordion
            })

        case 'CEDEVICEAPP_SELECTEDPROD':
        case 'CEDEVICEAPPBNDL_SELECTEDPROD':
            let selectedCEApps = Object.assign({}, state.ceApps, {
                selectedProduct: action.value.ceApps,
                isAccordionOpen: !(action.value.ceApps && action.value.ceApps.fromCEApps) && state.showConnectedApps && action.value.vRoom&&!state.vRoom.isAccordionOpen && ((action.value.vRoom && action.value.vRoom.unitCount && action.value.vRoom.unitCount === 1) || (!action.value.ceApps && action.value.dummyvRoom && action.value.dummyvRoom.unitCount && action.value.dummyvRoom.unitCount === action.value.vRoom.unitCount)) ? true : false,
                accordionStatus: state.showConnectedApps && action.value.vRoom && (parseInt(action.value.vRoom.unitCount) === 1 || (!action.value.ceApps && action.value.dummyvRoom && action.value.dummyvRoom.unitCount && action.value.dummyvRoom.unitCount === action.value.vRoom.unitCount)) ? 'optional' : action.value.ceApps ? 'added' : 'optional'
            })

            let objceAppsAcc = { vRoomAccor: false, tvConnectionsAccor: false, recordingAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, custTVAccor: false, focusAccordion: false }
            if(state.vRoom.isAccordionOpen) {
                objceAppsAcc.vRoomAccor = true;
            }
            else if ((!selectedCEApps.isAccordionOpen && state.tvConnections.isAccordionOpen) ||  (action.value.ceApps &&action.value.ceApps.fromTVConnections)) {
                objceAppsAcc.tvConnectionsAccor = true;
                objceAppsAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            else if (action.value !== null) {
                if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objceAppsAcc.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objceAppsAcc.routerAccor = true;
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objceAppsAcc.recordingAccor = true;
                }
                else if (state.tvConnections.selectedProduct != null){
                    objceAppsAcc.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objceAppsAcc.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objceAppsAcc.intrlChnAccor = true;
                }
                objceAppsAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            else {
                objceAppsAcc.focusAccordion = state.focusAccordion
            }
            return Object.assign({}, state, {
                ceApps: selectedCEApps,
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objceAppsAcc.vRoomAccor
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objceAppsAcc.vRoomAccor
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    isAccordionOpen: objceAppsAcc.tvConnectionsAccor
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objceAppsAcc.recordingAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objceAppsAcc.routerAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objceAppsAcc.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objceAppsAcc.intrlChnAccor
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: objceAppsAcc.custTVAccor
                    }),
                    isAccordionOpen: (action.value !== null && !objceAppsAcc.recordingAccor && !objceAppsAcc.chnlAccor  && !objceAppsAcc.intrlChnAccor && !objceAppsAcc.routerAccor && !objceAppsAcc.custTVAccor) ? false : true
                }),
                // focusAccordion: objceAppsAcc.focusAccordion
            })
        case 'DCT_SELECTEDPROD':
        case 'DIGITALADAPTER_SELECTEDPROD':
            let selectedDCT = Object.assign({}, state.dct, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null ? true : false,
                accordionStatus: action.value === null ? 'required' : 'added'
            })

            let objvDctAcc = { vRoomAccor: false, recordingAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, custTVAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objvDctAcc.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null) {
                    objvDctAcc.routerAccor = true;
                }
                else if (state.vRoom.selectedProduct === null) {
                    objvDctAcc.vRoomAccor = true;
                }
                else if (state.recording.selectedProduct === null) {
                    objvDctAcc.recordingAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null) {
                    objvDctAcc.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null) {
                    objvDctAcc.intrlChnAccor = true;
                }
                objvDctAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            return Object.assign({}, state, {
                dct: selectedDCT,
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objvDctAcc.vRoomAccor
                }),
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objvDctAcc.recordingAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objvDctAcc.routerAccor
                }),
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objvDctAcc.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objvDctAcc.intrlChnAccor
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: objvDctAcc.custTVAccor
                    }),
                    isAccordionOpen: (action.value !== null && !objvDctAcc.vRoomAccor && !objvDctAcc.recordingAccor && !objvDctAcc.chnlAccor && !objvDctAcc.intrlChnAccor && !objvDctAcc.routerAccor && !objvDctAcc.custTVAccor) ? false : true
                }),
                // focusAccordion: objvDctAcc.focusAccordion
            })

        case 'RECORDING_SELECTEDPROD':
        case 'RECORDINGSERVICE_SELECTEDPROD':
            let selectedRecording = Object.assign({}, state.recording, {
              selectedProduct: action.value,
              isAccordionOpen:
                action.value === null
                  ? true
                  : !NCFlow?true:false,
              accordionStatus: action.value === null ? "required" : "added",
            });

            let objRecordingAcc = { vRoomAccor: false, routerAccor: false, chnlAccor: false,intrlChnAccor:false, custTVAccor: false, focusAccordion: false }

            if (!NCFlow && action.value !== null) {
                if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objRecordingAcc.custTVAccor = true;
                }
                if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objRecordingAcc.routerAccor = true;
                }
                if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                    objRecordingAcc.vRoomAccor = true;
                }
                if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objRecordingAcc.chnlAccor = true;
                }
                if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objRecordingAcc.intrlChnAccor = true;
                }
                objRecordingAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            if (action.value !== null) {
                if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objRecordingAcc.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objRecordingAcc.routerAccor = true;
                }
                else if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                    objRecordingAcc.vRoomAccor = true;
                }
                else if (state.channel.accordionStatus === 'optional' && state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                    objRecordingAcc.chnlAccor = true;
                }
                else if (state.internationalChannel.accordionStatus === 'optional' && state.internationalChannel.equipments !== null && state.internationalChannel.selectedProduct === null && !state.productOnProfileStatus.internationalChannel) {
                    objRecordingAcc.intrlChnAccor = true;
                }
                objRecordingAcc.focusAccordion =action.preSelect!==null?false: true;
            }
            if(state.sweetnerReducer.dvr.visible){
                selectedRecording.isAccordionOpen=true
            }

            return Object.assign({}, state, {
                recording: selectedRecording,
                channel: Object.assign({}, state.channel, {
                    isAccordionOpen: objRecordingAcc.chnlAccor
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    isAccordionOpen: objRecordingAcc.intrlChnAccor
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objRecordingAcc.vRoomAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objRecordingAcc.routerAccor
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: objRecordingAcc.custTVAccor
                    }),
                    isAccordionOpen: (action.value !== null && !objRecordingAcc.vRoomAccor && !objRecordingAcc.chnlAccor && !objRecordingAcc.intrlChnAccor && !objRecordingAcc.routerAccor && !objRecordingAcc.custTVAccor) ? selectedRecording.isAccordionOpen : true
                }),
                // focusAccordion: objRecordingAcc.focusAccordion

            })

        case 'TOGGLE_CEAPPS_ACCOR':
            let mm4selectedceapps = Object.assign({}, state.ceApps, {
                isAccordionOpen: true
            });
            return Object.assign({}, state, {
                ceApps: mm4selectedceapps}
            )
        case 'TOGGLE_PERKS_ACCOR':
            let mm3selectedPerks = Object.assign({}, state.perks, {
                isAccordionOpen: true
            });
            return Object.assign({}, state, {
                    internet: Object.assign({}, state.internet, {
                        isSubAccordionOpen: false
                    }),
                    router: Object.assign({}, state.router, {
                        isAccordionOpen: state.isMNEnabled ? false : state.router.isAccordionOpen
                    }),
                    sploffer: Object.assign({}, state.sploffer, {
                        data: Object.assign({}, state.sploffer.data, {
                            isAccordionOpen: state.isMNEnabled ? false : state.sploffer.data.isAccordionOpen
                        }),
                        isAccordionOpen: state.isMNEnabled ? false : state.sploffer.isAccordionOpen,
                        isSubAccordionOpen: state.isMNEnabled ? false : state.sploffer.isSubAccordionOpen,
                    }),
                    perks: mm3selectedPerks,
                    // focusAccordion: true,
                }
            )
        case 'PERKS_SELECTEDPROD':
            let selectedPerks = Object.assign({}, state.perks, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'optional' : 'added',
                // isAccordionOpen: (action.value !== null && action.value.length > 0) ? false : true
            })
                return Object.assign({}, state, {
                    perks: selectedPerks,
                })
        case 'CHANNEL_SELECTEDPROD':
            let selectedChannel = Object.assign({}, state.channel, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'optional' : 'added',
                isAccordionOpen: true, //action.value !== null && action.value.length > 0) ? true : true (removed condition for ACT112-226)
            })

            let objChannelAcc = { vRoomAccor: false, routerAccor: false, recordingAccor: false, custTVAccor: false, focusAccordion: false }

            if (action.value !== null && action.value.length > 0) {
                if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                    objChannelAcc.custTVAccor = true;
                }
                else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                    objChannelAcc.routerAccor = true;
                }
                else if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                    objChannelAcc.vRoomAccor = true;
                }
                else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                    objChannelAcc.recordingAccor = true;
                }
                objChannelAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                recording: Object.assign({}, state.recording, {
                    isAccordionOpen: objChannelAcc.recordingAccor
                }),
                channel: selectedChannel,
                vRoom: Object.assign({}, state.vRoom, {
                    isAccordionOpen: objChannelAcc.vRoomAccor
                }),
                router: Object.assign({}, state.router, {
                    isAccordionOpen: objChannelAcc.routerAccor
                }),
                tv: Object.assign({}, state.tv, {
                    customTV: Object.assign({}, state.tv.customTV, {
                        isAccordionOpen: objChannelAcc.custTVAccor
                    }),
                    isAccordionOpen: (!objChannelAcc.vRoomAccor && !objChannelAcc.recordingAccor && !objChannelAcc.routerAccor && !objChannelAcc.custTVAccor && action.value !== null && action.value.length === 20) ? false : true
                }),
                // focusAccordion: objChannelAcc.focusAccordion
            })
            case 'INTERNATIONALCHANNEL_SELECTEDPROD':
                let selectedInternationalChannel = Object.assign({}, state.internationalChannel, {
                    selectedProduct: action.value,
                    accordionStatus: action.value === null ? 'optional' : 'added',
                    isAccordionOpen: true, //action.value !== null && action.value.length > 0) ? false : true (removed condition for ACT112-226)
                })

                let objIntrnlChannelAcc = { vRoomAccor: false, chnlAccor:false, routerAccor: false, recordingAccor: false, custTVAccor: false, focusAccordion: false }

                if (action.value !== null && action.value.length > 0) {
                    if (state.tv.selectedProduct !== null && (state.tv.selectedProduct.prodTypeValue === "CUSTOM_GENERIC" || state.tv.selectedProduct.prodTypeVal === "CUSTOM_GENERIC") && state.tv.customTV.selectedProduct === null) {
                        objIntrnlChannelAcc.custTVAccor = true;
                    }
                    else if (state.internet.selectedProduct === null && state.router.selectedProduct === null && !state.productOnProfileStatus.router) {
                        objIntrnlChannelAcc.routerAccor = true;
                    }
                    else if (state.vRoom.selectedProduct === null && !state.productOnProfileStatus.vRoom) {
                        objIntrnlChannelAcc.vRoomAccor = true;
                    }
                    else if (state.recording.selectedProduct === null && !state.productOnProfileStatus.recording) {
                        objIntrnlChannelAcc.recordingAccor = true;
                    }
                    else if (state.channel.selectedProduct === null && !state.productOnProfileStatus.channel) {
                        objIntrnlChannelAcc.chnlAccor = true;
                    }
                    objIntrnlChannelAcc.focusAccordion =action.preSelect!==null?false: true;
                }

                return Object.assign({}, state, {
                    recording: Object.assign({}, state.recording, {
                        isAccordionOpen: objIntrnlChannelAcc.recordingAccor
                    }),
                    internationalChannel: selectedInternationalChannel,
                    vRoom: Object.assign({}, state.vRoom, {
                        isAccordionOpen: objIntrnlChannelAcc.vRoomAccor
                    }),
                    router: Object.assign({}, state.router, {
                        isAccordionOpen: objIntrnlChannelAcc.routerAccor
                    }),
                    tv: Object.assign({}, state.tv, {
                        customTV: Object.assign({}, state.tv.customTV, {
                            isAccordionOpen: objIntrnlChannelAcc.custTVAccor
                        }),
                        isAccordionOpen: (!objIntrnlChannelAcc.vRoomAccor && !objIntrnlChannelAcc.recordingAccor && !objIntrnlChannelAcc.routerAccor && !objIntrnlChannelAcc.custTVAccor && action.value !== null && action.value.length === 20) ? false : true
                    }),
                    // focusAccordion: objIntrnlChannelAcc.focusAccordion
                })
        case 'CHANNEL_SELECTEDPROD_ON_TVCHANGE':
            let ch = Object.assign({}, state.channel, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'optional' : 'added'
            })
            return Object.assign({}, state, {
                channel: ch,
            })
        case 'INTERNATIONALCHANNEL_SELECTEDPROD_ON_TVCHANGE':
                let intrlch = Object.assign({}, state.internationalChannel, {
                    selectedProduct: action.value,
                    accordionStatus: action.value === null ? 'optional' : 'added'
                })
                return Object.assign({}, state, {
                    internationalChannel: intrlch,
                })
        case 'WINBACK_ACCORDSTATUS':
            let selectedWinbackstatus = Object.assign({}, state.winback, {
                accordionStatus: action.value
            })
            return Object.assign({}, state, {
                winback: selectedWinbackstatus

            })
        case 'INTERNATIONALCHANNELPLAN_SELECTEDPROD':
            let selectedIntlCallingPlan = Object.assign({}, state.intlCalling, {
                selectedProduct: action.value,
                accordionStatus: action.value === null ? 'required' : 'added'
            })
            return Object.assign({}, state, {
                intlCalling: selectedIntlCallingPlan
            })
        case 'WINBACK_SELECTEDPROD':
            let selectedWinback = Object.assign({}, state.winback, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null,
                accordionStatus: action.value === null ? 'required' : 'added'
            })

            let objWinbackAcc = { listingAccor: false, backupAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.listing.selectedProduct === null) {
                    objWinbackAcc.listingAccor = true;
                }
                else if (state.backup.selectedProduct === null || (state.backup.isShipmentRequired && state.backup.shipment.selectedProduct === null)) {
                    objWinbackAcc.backupAccor = true;
                }
                objWinbackAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                winback: selectedWinback,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) || (action.value !== null && !objWinbackAcc.listingAccor && !objWinbackAcc.backupAccor && !selectedWinback.isAccordionOpen)) ? false : true
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: objWinbackAcc.listingAccor
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: objWinbackAcc.backupAccor
                }),
                // focusAccordion: objWinbackAcc.focusAccordion
            })
        case 'CALLINGFEATURE_SELECTEDPROD':
            let selectedCallingFeature = Object.assign({}, state.callingFeatures, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null,
                accordionStatus: action.value === null ? '' : 'added'
            })

            let objCallingAcc = { callingAccor: false, intlPlansAccor: false, wireMaintenanceAccor: false, longDistAccor: false, listingAccor: false, emergServAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.callingFeatures.selectedProduct === null) {
                    objCallingAcc.callingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objCallingAcc.intlPlansAccor = true;
                }
                else if (state.longDistance.selectedProduct === null) {
                    objCallingAcc.longDistAccor = true;
                }
                else if (state.wireMaintenance.selectedProduct === null) {
                    objCallingAcc.wireMaintenanceAccor = true;
                }
                else if (state.existingListing.selectedProduct === null) {
                    objCallingAcc.listingAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null) {
                    objCallingAcc.emergServAccor = true;
                }
                objCallingAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                callingFeature: selectedCallingFeature,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) ||
                    (action.value !== null && !objCallingAcc.intlPlansAccor &&
                        !objCallingAcc.longDistAccor && !objCallingAcc.wireMaintenanceAccor &&
                        !objCallingAcc.listingAccor && !objCallingAcc.backupAccor &&
                        !selectedCallingFeature.isAccordionOpen)) ? false : true
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: objCallingAcc.intlPlansAccor
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: objCallingAcc.longDistAccor
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: objCallingAcc.longDistAccor
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: objCallingAcc.listingAccor
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: objCallingAcc.emergServAccor
                }),
                // focusAccordion: objCallingAcc.focusAccordion
            })
        case 'INTLPLAN_SELECTEDPROD':
            let selectedIntlPlans = Object.assign({}, state.intlPlans, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null,
                accordionStatus: action.value === null ? 'optional' : 'added'
            })

            let objIntlPlansAcc = { callingAccor: false, intlPlansAccor: false, wireMaintenanceAccor: false, longDistAccor: false, listingAccor: false,winbackAccor: false, emergServAccor:false, focusAccordion: false }

            if (action.value !== null) {
                if (state.winback.selectedProduct === null) {
                    objIntlPlansAcc.winbackAccor = true;
                }
                else if (state.callingFeatures.selectedProduct === null) {
                    objIntlPlansAcc.callingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objIntlPlansAcc.intlPlansAccor = true;
                }
                else if (state.longDistance.selectedProduct === null) {
                    objIntlPlansAcc.longDistAccor = true;
                }
                else if (state.wireMaintenance.selectedProduct === null) {
                    objIntlPlansAcc.wireMaintenanceAccor = true;
                }
                else if (state.existingListing.selectedProduct === null) {
                    objIntlPlansAcc.listingAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null) {
                    objIntlPlansAcc.emergServAccor = true;
                }
                objIntlPlansAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                intlPlans: selectedIntlPlans,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) ||
                        (action.value !== null && !objIntlPlansAcc.callingAccor &&
                            !objIntlPlansAcc.longDistAccor && !objIntlPlansAcc.wireMaintenanceAccor &&
                            !objIntlPlansAcc.listingAccor && !objIntlPlansAcc.backupAccor && !objIntlPlansAcc.winbackAccor &&
                            !selectedIntlPlans.isAccordionOpen)) ? false : true
                }),
                callingFeature: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: objIntlPlansAcc.callingAccor
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: objIntlPlansAcc.longDistAccor
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: objIntlPlansAcc.longDistAccor
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: objIntlPlansAcc.listingAccor
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: objIntlPlansAcc.winbackAccor
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: objIntlPlansAcc.emergServAccor
                }),
                // focusAccordion: objIntlPlansAcc.focusAccordion
            })
        case 'LONGDISTANCE_SELECTEDPROD':
            let selectedLongDistance = Object.assign({}, state.longDistance, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null,
                accordionStatus: action.value === null ? '' : 'added'
            })

            let objLongDistanceAcc = { callingAccor: false, intlPlansAccor: false, wireMaintenanceAccor: false, longDistAccor: false, listingAccor: false, emergServAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.callingFeatures.selectedProduct === null) {
                    objLongDistanceAcc.callingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objLongDistanceAcc.intlPlansAccor = true;
                }
                else if (state.longDistance.selectedProduct === null) {
                    objLongDistanceAcc.longDistAccor = true;
                }
                else if (state.wireMaintenance.selectedProduct === null) {
                    objLongDistanceAcc.wireMaintenanceAccor = true;
                }
                else if (state.existingListing.selectedProduct === null) {
                    objLongDistanceAcc.listingAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null) {
                    objLongDistanceAcc.emergServAccor = true;
                }
                objLongDistanceAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                longDistance: selectedLongDistance,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) ||
                        (action.value !== null && !objLongDistanceAcc.callingAccor &&
                            !objLongDistanceAcc.intlPlansAccor && !objLongDistanceAcc.wireMaintenanceAccor &&
                            !objLongDistanceAcc.listingAccor && !objLongDistanceAcc.backupAccor &&
                            !selectedLongDistance.isAccordionOpen)) ? false : true
                }),
                callingFeature: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: objLongDistanceAcc.callingAccor
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: objLongDistanceAcc.intlPlans
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: objLongDistanceAcc.longDistAccor
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: objLongDistanceAcc.listingAccor
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: objLongDistanceAcc.emergServAccor
                }),
                // focusAccordion: objLongDistanceAcc.focusAccordion
            })
        case 'WIREMAINTENANCE_SELECTEDPROD':
            let selectedWireMaintenance = Object.assign({}, state.wireMaintenance, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null,
                accordionStatus: action.value === null ? '' : 'added'
            })

            let objWireMainAcc = { callingAccor: false, intlPlansAccor: false, wireMaintenanceAccor: false, longDistAccor: false, listingAccor: false, emergServAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.callingFeatures.selectedProduct === null) {
                    objWireMainAcc.callingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objWireMainAcc.intlPlansAccor = true;
                }
                else if (state.longDistance.selectedProduct === null) {
                    objWireMainAcc.longDistAccor = true;
                }
                else if (state.wireMaintenance.selectedProduct === null) {
                    objWireMainAcc.wireMaintenanceAccor = true;
                }
                else if (state.existingListing.selectedProduct === null) {
                    objWireMainAcc.listingAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null) {
                    objWireMainAcc.emergServAccor = true;
                }
                objWireMainAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                wireMaintenance: selectedWireMaintenance,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) ||
                        (action.value !== null && !objWireMainAcc.callingAccor &&
                            !objWireMainAcc.longDistAccor && !objWireMainAcc.intlPlansAccor &&
                            !objWireMainAcc.listingAccor && !objWireMainAcc.backupAccor &&
                            !selectedWireMaintenance.isAccordionOpen)) ? false : true
                }),
                callingFeature: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: objWireMainAcc.callingAccor
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: objWireMainAcc.longDistAccor
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: objWireMainAcc.longDistAccor
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: objWireMainAcc.listingAccor
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: objWireMainAcc.emergServAccor
                }),
                // focusAccordion: objWireMainAcc.focusAccordion
            })
        case 'EXISTING_LISTING_SELECTEDPROD':
            let ecExistingListing = Object.assign({}, state.existingListing, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null,
                accordionStatus: action.value === null ? '' : 'added'
            })

            let objExlistingAcc = { callingAccor: false, intlPlansAccor: false, wireMaintenanceAccor: false, longDistAccor: false, listingAccor: false, emergServAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.callingFeatures.selectedProduct === null) {
                    objExlistingAcc.callingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objExlistingAcc.intlPlansAccor = true;
                }
                else if (state.longDistance.selectedProduct === null) {
                    objExlistingAcc.longDistAccor = true;
                }
                else if (state.wireMaintenance.selectedProduct === null) {
                    objExlistingAcc.wireMaintenanceAccor = true;
                }
                else if (state.listing.selectedProduct === null) {
                    objExlistingAcc.listingAccor = true;
                }
                else if (state.backup.selectedProduct === null || (state.backup.isShipmentRequired && state.backup.shipment.selectedProduct === null)) {
                    objExlistingAcc.backupAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null) {
                    objExlistingAcc.emergServAccor = true;
                }

                objExlistingAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                existingListing: ecExistingListing,
                callingFeature: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: objExlistingAcc.callingAccor
                }),
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) ||
                    (action.value !== null && !objExlistingAcc.intlPlansAccor &&
                        !objExlistingAcc.longDistAccor && !objExlistingAcc.wireMaintenanceAccor &&
                        !objExlistingAcc.listingAccor && !objExlistingAcc.backupAccor &&
                        !ecExistingListing.isAccordionOpen)) ? false : true
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: objExlistingAcc.intlPlansAccor
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: objExlistingAcc.longDistAccor
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: objExlistingAcc.wireMaintenanceAccor
                }),
                emergencyServices: Object.assign({}, state.emergencyServices, {
                    isAccordionOpen: objExlistingAcc.emergServAccor
                }),

                // focusAccordion: objExlistingAcc.focusAccordion
            })

        case 'LISTING_SELECTEDPROD':
            let selectedListing = Object.assign({}, state.listing, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null,
                accordionStatus: action.value === null ? 'required' : 'added'
            })

            let objListingAcc = { winbackAccor: false, backupAccor: false, focusAccordion: false }

            if (action.value !== null) {
                if (state.winback.selectedProduct === null) {
                    objListingAcc.winbackAccor = true;
                }
                else if (state.backup.selectedProduct === null || (state.backup.isShipmentRequired && state.backup.shipment.selectedProduct === null)) {
                    objListingAcc.backupAccor = true;
                }
                objListingAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                listing: selectedListing,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) || (action.value !== null && !objListingAcc.winbackAccor && !objListingAcc.backupAccor && !selectedListing.isAccordionOpen)) ? false : true
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: objListingAcc.winbackAccor
                }),
                backup: Object.assign({}, state.backup, {
                    isAccordionOpen: objListingAcc.backupAccor
                }),
                // focusAccordion: objListingAcc.focusAccordion
            })

        case 'IS_SUPP_EMERGENCY_SELECTEDPROD':
            let isSuppEmerSelected = Object.assign({}, state.emergencyServices, {
                isSuppFlowEmergencyServiceSelected: action.value
            })
            return Object.assign({}, state, {
                emergencyServices: isSuppEmerSelected
            })

        case 'EMERGENCY_SERVICES_SELECTEDPROD':
            let selectedEmergServ = Object.assign({}, state.emergencyServices, {
                selectedProduct: action.value,
                accordionStatus: action.option === 'yes' ? 'required' : 'added',
                notificationMethod: 'text',
                email: {
                    value: '',
                    emailValid: false
                },
                mobile: {
                    value: '',
                    mobileValid: false
                }
            })


            let objEmergServ = { callingAccor: false, intlPlansAccor: false, wireMaintenanceAccor: false, longDistAccor: false, listingAccor: false, emergServAccor:false, focusAccordion: false }

            if (action.value !== null) {
                if (state.callingFeatures.selectedProduct === null) {
                    objEmergServ.callingAccor = true;
                }
                else if (state.intlPlans.selectedProduct === null) {
                    objEmergServ.intlPlansAccor = true;
                }
                else if (state.longDistance.selectedProduct === null) {
                    objEmergServ.longDistAccor = true;
                }
                else if (state.wireMaintenance.selectedProduct === null) {
                    objEmergServ.wireMaintenanceAccor = true;
                }
                else if (state.existingListing.selectedProduct === null) {
                    objEmergServ.listingAccor = true;
                }
                else if (state.emergencyServices.selectedProduct === null){
                    objEmergServ.emergServAccor = true;
                }
                objEmergServ.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                emergencyServices: selectedEmergServ,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) ||
                        (action.value !== null && !objEmergServ.callingAccor &&
                            !objEmergServ.longDistAccor && !objEmergServ.intlPlansAccor &&
                            !objEmergServ.listingAccor && !objEmergServ.backupAccor &&
                            !selectedEmergServ.isAccordionOpen)) ? false : true
                }),
                callingFeature: Object.assign({}, state.callingFeatures, {
                    isAccordionOpen: objEmergServ.callingAccor
                }),
                intlPlans: Object.assign({}, state.intlPlans, {
                    isAccordionOpen: objEmergServ.longDistAccor
                }),
                longDistance: Object.assign({}, state.longDistance, {
                    isAccordionOpen: objEmergServ.longDistAccor
                }),
                existingListing: Object.assign({}, state.existingListing, {
                    isAccordionOpen: objEmergServ.listingAccor
                }),
                wireMaintenance: Object.assign({}, state.wireMaintenance, {
                    isAccordionOpen: objEmergServ.wireMaintenanceAccor
                }),
                // focusAccordion: objEmergServ.focusAccordion
            })

        case 'EMERGENCY_SERVICES_NOTIFICATION_CHANGE':
            let selectedEmergServNotification = Object.assign({}, state.emergencyServices, {
                notificationMethod: action.value,
                accordionStatus: action.value ==='' ? 'added' : action.value === 'email' && state.emergencyServices?.email?.emailValid ? 'added' : action.value === 'text' && state.emergencyServices?.mobile?.mobileValid ? 'added' : 'required',                
                eMailId:action.value === 'text' ? '': state.emergencyServices.eMailId,
                eMailErr: state.emergencyServices.eMailId === '' || action.value === 'text' ? 'Please enter a valid email address' : state.emergencyServices.eMailErr,
                isValidMail: state.emergencyServices.eMailId === '' || action.value === 'text' ? false : state.emergencyServices.isValidMail,
                emailValidationResp:action.value === 'text' ? "" : state.emergencyServices.emailValidationResp,
                email: {
                    value: action.value === 'text' ?'' : state.emergencyServices.email.value,
                    emailValid: state.emergencyServices.eMailId === "" || action.value === 'text' ? false : state.emergencyServices.email.emailValid
                },
                mobile: {
                    value: action.value === 'email' ? '' : state.emergencyServices.mobile.value,
                    mobileValid: state.emergencyServices.mobile.value ==="" || action.value === 'email' ? false : state.emergencyServices.mobile
                }
            })
            return Object.assign({}, state, {
                emergencyServices: selectedEmergServNotification
            })


        case 'EMERGENCY_SERVICES_CHANGE_EMAIL':
             let emailChangeEmergServObj = Object.assign({}, state.emergencyServices, {
                email: action.value
            })
            return Object.assign({}, state, {
                emergencyServices: emailChangeEmergServObj
            })

        case 'UPDATE_EMAIL_VALIDATION':
                let emailValObj = Object.assign({}, state.emergencyServices, {
                    emailValidationResp : action.value
                })
                return Object.assign({}, state, {
                    emergencyServices: emailValObj
                })
        case 'UPDATE_EMAIL_REGEX':
                let eRegexObj = Object.assign({}, state.emergencyServices, {
                    emailRegexValid : action.value
                })
                return Object.assign({}, state, {
                    emergencyServices: eRegexObj
                })

        case 'UPDATE_CLICK_FLAG':
                let clickObj = Object.assign({}, state.emergencyServices, {
                    clickHereFlag : action.value
                })
                return Object.assign({}, state, {
                    emergencyServices: clickObj
                })
        case 'EMERGENCY_SERVICES_CHANGE_MOBILE':
            let mobileChangeEmergServObj = Object.assign({}, state.emergencyServices, {
                mobile: action.value
            })
            return Object.assign({}, state, {
                emergencyServices: mobileChangeEmergServObj
            })
        case BuildProduct.updateContactInfo:
            let data = Object.assign({}, state.emergencyServices, {
                eMailId: (action.value.eMailId !== undefined && action.value.eMailId !== state.emergencyServices.eMailId) ? action.value.eMailId : state.emergencyServices.eMailId,
                eMailErr: (action.value.eMailErr !== undefined && action.value.eMailErr !== state.emergencyServices.eMailErr) ? action.value.eMailErr : state.emergencyServices.eMailErr,
                isValidMail: (action.value.isValidMail !== undefined && action.value.isValidMail !== state.emergencyServices.isValidMail) ? action.value.isValidMail : state.emergencyServices.isValidMail,
                email: { value: (action.value.eMailId !== undefined && action.value.eMailId !== state.emergencyServices.eMailId) ? action.value.eMailId : state.emergencyServices.eMailId, emailValid: (action.value.isValidMail !== undefined && action.value.isValidMail !== state.emergencyServices.isValidMail) ? action.value.isValidMail : state.emergencyServices.isValidMail }
            })
            return Object.assign({}, state, {
                emergencyServices: data,
       })


        case 'EMERGENCY_SERVICES_CHANGE_ACCOR_STATUS':
            let accorStatusChangeEmergServ = Object.assign({}, state.emergencyServices, {
                accordionStatus: action.value
            })
            return Object.assign({}, state, {
                emergencyServices: accorStatusChangeEmergServ
            })

        case 'SELECTED_FIRE_ALARM_DETAILS':
            let SelectedFire = action.value && action.value.notificationStatus == 'Y' ? {value:'yes', prodType:'EmergencyServ'} : {value:'no', prodType:'EmergencyServ'};
            let emailObj = action.value && action.value.email && action.value.email.length > 0 ? {value: action.value.email ,emailValid: true} : {value: '' ,emailValid: false};
            let mobileObj = action.value && action.value.mtn && action.value.mtn.length > 0 ? {value: action.value.mtn ,mobileValid: true} : {value: '' ,mobileValid: false}
            let selectedFireAlarmProduct = Object.assign({}, state.emergencyServices, {
                selectedProduct: SelectedFire,
                notificationMethod: action.value.notificationType == "B" ? 'both' : action.value.notificationType == "M" ? 'text' : action.value.notificationType == "E" ? 'email' : '',
                email: emailObj,
                mobile: mobileObj,
                accordionStatus: action.value && action.value.notificationStatus == 'Y' ? 'added' : 'optional'
            })

            return Object.assign({}, state, {
                emergencyServices: selectedFireAlarmProduct
            })

        case 'BATTERY_SELECTEDPROD':
            let selectedBackup = Object.assign({}, state.backup, {
                selectedProduct: action.value,
                isAccordionOpen: action.value === null || (action.value != null && action.value.keyword.indexOf("CHARGED") > -1 && state.backup.isShipmentAvailable),
                accordionStatus: action.value === null || (action.value != null && action.value.keyword.indexOf("CHARGED") > -1 && state.backup.isShipmentAvailable) ? 'required' : 'added',
                isShipmentRequired: action.value != null && action.value.keyword.indexOf("CHARGED") > -1 && state.backup.isShipmentAvailable
            })

            let objBackupAcc = { winbackAccor: false, listingAccor: false, focusAccordion: false }

            if (action.value !== null && !selectedBackup.isShipmentRequired) {
                if (state.winback.selectedProduct === null) {
                    objBackupAcc.winbackAccor = true;
                }
                else if (state.listing.selectedProduct === null) {
                    objBackupAcc.listingAccor = true;
                }
                objBackupAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                backup: selectedBackup,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: ((action.value === null && state.voice.selectedProduct === null) || (action.value !== null && !objBackupAcc.winbackAccor && !objBackupAcc.listingAccor && !selectedBackup.isAccordionOpen)) ? false : true
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: objBackupAcc.winbackAccor
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: objBackupAcc.listingAccor
                }),
                // focusAccordion: objBackupAcc.focusAccordion
            })
        case 'BBUSHIPMENT_SELECTEDPROD':
            let selectedBackupShip = Object.assign({}, state.backup.shipment, {
                selectedProduct: action.value,
                isAccordionOpen: state.backup.isShipmentRequired,
                accordionStatus: action.value === null && state.backup.isShipmentRequired ? 'required' : 'added'
            })
            let updatedBackup = Object.assign({}, state.backup, {
                selectedProduct: state.backup.selectedProduct,
                isAccordionOpen: state.voice.selectedProduct !== null && (state.backup.selectedProduct === null || selectedBackupShip.isAccordionOpen),
                accordionStatus: state.backup.selectedProduct != null ? selectedBackupShip.accordionStatus : state.backup.accordionStatus,
                shipment: selectedBackupShip
            })

            let objBackupShipAcc = { winbackAccor: false, listingAccor: false, focusAccordion: false }

            if (!updatedBackup.isAccordionOpen) {
                if (state.winback.selectedProduct === null) {
                    objBackupShipAcc.winbackAccor = true;
                }
                else if (state.listing.selectedProduct === null) {
                    objBackupShipAcc.listingAccor = true;
                }
                objBackupShipAcc.focusAccordion =action.preSelect!==null?false: true;
            }

            return Object.assign({}, state, {
                backup: updatedBackup,
                voice: Object.assign({}, state.voice, {
                    isAccordionOpen: state.voice.selectedProduct === null || (!state.backup.isShipmentRequired && !objBackupShipAcc.winbackAccor && !objBackupShipAcc.listingAccor && !updatedBackup.isAccordionOpen) ? false : true
                }),
                winback: Object.assign({}, state.winback, {
                    isAccordionOpen: objBackupShipAcc.winbackAccor
                }),
                listing: Object.assign({}, state.listing, {
                    isAccordionOpen: objBackupShipAcc.listingAccor
                }),
                // focusAccordion: objBackupShipAcc.focusAccordion
            })
        case 'TOGGLE_MESSAGE':
            return Object.assign({}, state, {
                istoggleMessage: !state.istoggleMessage
            })
        case BuildProduct.toggleBatteryMsg:
            return Object.assign({}, state, {
                istoggleBatteryMessage: !state.istoggleBatteryMessage
            })
        case BuildProduct.toggleDctMsg:
            return Object.assign({}, state, {
                istoggleDctMessage: !state.istoggleDctMessage
            })
        case BuildProduct.toggleTVMoreOpt:
            let moreOption = Object.assign({}, state.tv.moreOption, {
                isMoreOptAccordionOpen: !state.tv.moreOption.isMoreOptAccordionOpen
            })
            let tvMoreOption = Object.assign({}, state.tv, {
                moreOption: moreOption
            })
            return Object.assign({}, state, {
                tv: tvMoreOption
            })
        case BuildProduct.toggleRouterMoreOpt:
            let moreOptionRouter = Object.assign({}, state.router.moreOption, {
                    isMoreOptAccordionOpen: !state.router.moreOption.isMoreOptAccordionOpen
            })
            let routerMoreOption = Object.assign({}, state.router, {
                    moreOption: moreOptionRouter
            })
            return Object.assign({}, state, {
                router: routerMoreOption
            })
        case BuildProduct.SweetnerMsg:
            let prevPromos = Object.assign({}, state.SweetnerMsg.prevPromos, {
                INTERNET: action.value && action.value.prevPromos && action.value.prevPromos.INTERNET ? action.value.prevPromos.INTERNET : state.SweetnerMsg.prevPromos.INTERNET,
                TV: action.value && action.value.prevPromos && action.value.prevPromos.TV ? action.value.prevPromos.TV : state.SweetnerMsg.prevPromos.TV
            })
            let SweetnerMsg = Object.assign({}, state.SweetnerMsg, {
                currentMsg: action.value.currentMsg,
                prevMsg: action.value.prevMsg,
                prevPromos: prevPromos,
                isDisplay: action.value.isDisplay
            })
            return Object.assign({}, state, {
                SweetnerMsg: SweetnerMsg
            })
        case BuildProduct.buildprodLoaded:
            return Object.assign({}, state, {
                buildprodLoaded: action.value
            })
        case 'BANNER_UPDATED':
            let fiosqualified = Object.assign({}, state.banner, {
                imgUrl: action.value.imgUrl,
                headerText: action.value.headerText,
                bodyText: action.value.bodyText,
                footerText: action.value.footerText
            })
            return Object.assign({}, state, {
                banner: fiosqualified
            })
        case 'LOAD_TN':
            return Object.assign({}, state, {
                requestTN: action.value
            })
        case 'UPDATE_WB_PH1':
            let ph1 = Object.assign({}, state.hasOwnTn, {
                ph1: action.value
            })
            return Object.assign({}, state, {
                hasOwnTn: ph1
            })
        case 'UPDATE_WB_PH2':
            let ph2 = Object.assign({}, state.hasOwnTn, {
                ph2: action.value
            })
            return Object.assign({}, state, {
                hasOwnTn: ph2
            })
        case 'UPDATE_WB_PH3':
            let ph3 = Object.assign({}, state.hasOwnTn, {
                ph3: action.value
            })
            return Object.assign({}, state, {
                hasOwnTn: ph3
            })
        case 'UPDATE_PORTEDTN':
            let portedTn = Object.assign({}, state.hasOwnTn, {
                portedTn: action.value
            })
            return Object.assign({}, state, {
                hasOwnTn: portedTn
            })
        case 'UPDATE_TNPORTABILITY':
            let isPortedTn = Object.assign({}, state.hasOwnTn, {
                isPorted: action.value
            })
            return Object.assign({}, state, {
                hasOwnTn: isPortedTn
            })
        case BuildProduct.cutomeRouterCheck:
            return Object.assign({}, state, {
                customRouterCheck: !action.value
            })
        case 'SETCUSTOMROUTERNAME':
            let name = '';
            if (action.value === 'BHR3')
                name = 'Customer owned Advanced Wi-Fi Router';
            else if (action.value === 'BHR4')
                name = 'Customer-Owned Router';
            return Object.assign({}, state, {
                customRouterType: action.value,
                customRouterName: name
            })
        case 'TOGGLE_CONTRACT_ACCOR':
            let contractAccor = Object.assign({}, state.contract, {
                isAccordionOpen: !state.contract.isAccordionOpen,
                contractType: state.contract.contractType
            })
            return Object.assign({}, state, {
                contract: contractAccor,
                // focusParentAccordion: true
            })
        case BuildProduct.updateCheckoutBtnStatus:
            return Object.assign({}, state, {
                isenableCheckout: action.value
            })
        case 'DO_SMARTCART':
            return Object.assign({}, state, {
                doSmartCart: action.value
            })
        case "COUPONVALIDATIONERROR":
            let couponError = Object.assign({}, state.couponInfo, {
                couponerror: action.value
            })
            return Object.assign({}, state, {
                couponInfo: couponError
            })
        case "COUPONVALIDATION":
            let couponInfoInput = Object.assign({}, state.couponInfo, {
                coupon: action.value.referralCode !== undefined &&
                    action.value.referralCode !== state.couponInfo.coupon ? action.value.referralCode : state.couponInfo.coupon
            })
            return Object.assign({}, state, {
                couponInfo: couponInfoInput,
            })
        case "COUPONSUCCESS":
            let couponSuccess = Object.assign({}, state.couponInfo, {
                couponsuccess: action.value
            })
            return Object.assign({}, state, {
                couponInfo: couponSuccess
            })
        case "COUPONREMOVED":
        let couponRemoved = Object.assign({}, state.couponInfo, {
            couponremoved: action.value
        })
        return Object.assign({}, state, {
            couponInfo: couponRemoved
        })
        case "COUPONISOC":
            let couponisoc = Object.assign({}, state.couponInfo, {
                couponisoc: action.value
            })
            return Object.assign({}, state, {
                couponInfo: couponisoc
            })
        case "COUPONEMPTY":
            let couponInfoInputva = Object.assign({}, state.couponInfo, {
                coupon: action.value
            })
            return Object.assign({}, state, {
                couponInfo: couponInfoInputva,
            })
        case "REFERAFRIENDCOUPONVALIDATIONSUCESS":
            let referfriendvalidationsucess = Object.assign({}, state.couponInfo, {
                referfriendvalidationsucess: action.value
            })
            return Object.assign({}, state, {
                couponInfo: referfriendvalidationsucess
            })
        case "REFERAFRIENDBACKENDCALSTART":
            return Object.assign({}, state, {
                referafriendcallstart: action.value
            })
        case "REFERAFRIENDCOUPONVALIDATIONFAILURE":
            let referfriendvalidationfailure = Object.assign({}, state.couponInfo, {
                referfriendvalidationfailure: action.value
            })
            return Object.assign({}, state, {
                couponInfo: referfriendvalidationfailure
            })
        case "RAFPACKAGE_CHECKOUT_VALIDATION":
            let isRAFCheckoutValidation = Object.assign({}, state.couponInfo, {
                isRAFCheckoutValidation: action.value
            })
            return Object.assign({}, state, {
                couponInfo: isRAFCheckoutValidation
            })
        case "RESUME_RAFPACKAGE_COUPONVALIDATION":
            let resumeCouponInfoInput = Object.assign({}, state.couponInfo, {
                coupon: action.value,
                referfriendvalidationsucess: true
            })
            return Object.assign({}, state, {
                couponInfo: resumeCouponInfoInput,
            })
        case "FFCOUPONVALIDATIONERROR":
            let ffCouponError = Object.assign({}, state.ffCouponInfo, {
                ffCouponError: action.value
            })
            return Object.assign({}, state, {
                ffCouponInfo: ffCouponError
            })
        case "FFCOUPONVALIDATION":
            let ffCouponInfo = Object.assign({}, state.ffCouponInfo, {
                ffCoupon: action.value !== undefined &&
                    action.value !== state.ffCouponInfo.ffCoupon ? action.value : state.ffCouponInfo.ffCoupon
            })
            return Object.assign({}, state, {
                ffCouponInfo: ffCouponInfo,
            })
        case "FFCOUPONEMPTY":
            let ffCouponInfoInput = Object.assign({}, state.ffCouponInfo, {
                ffCoupon: action.value
            })
            return Object.assign({}, state, {
                ffCouponInfo: ffCouponInfoInput,
            })
        case "FFCOUPONVALIDATIONSUCCESS":
            let ffCouponValidationInfo = Object.assign({}, state.ffCouponInfo, {
                ffCoupon: action.value.ffCoupon,
                leadListID: action.value.leadListID,
                ffCouponError: false,
                ffValidationErrorType: action.value.ffValidationErrorType,
                ffValidationSucess: action.value.ffValidationSucess,
                ffValidationFailure: action.value.ffValidationFailure,
                isFFCheckoutValidation: false,
                profileDataSpeed: action.value.profileDataSpeed
            })
            return Object.assign({}, state, {
                ffCouponInfo: ffCouponValidationInfo
            })
        case "FFBACKENDCALLSTART":
            return Object.assign({}, state, {
                ffCallStart: action.value
            })
        case "VISPREBACKENDCALLSTART":
            return Object.assign({}, state, {
                visPreCallStart: action.value
            })
        case "CURRENTCOUPONVALIDATION":
            return Object.assign({}, state, {
                currentCouponType: action.value
            })

        case "FFCOUPONVALIDATIONFAILURE":
            let ffValidationFailureInfo = Object.assign({}, state.ffCouponInfo, {
                ffValidationFailure: action.value.ffValidationFailure,
                ffValidationErrorType: action.value.ffValidationErrorType,
            })
            return Object.assign({}, state, {
                ffCouponInfo: ffValidationFailureInfo
            })
        case "VISPRECOUPONVALIDATIONFAILURE":
            let visPreValidationFailureInfo = Object.assign({}, state.visPreCouponInfo, {
                visPreValidationFailure: action.value.visPreValidationFailure,
                visPreValidationErrorType: action.value.visPreValidationErrorType,
            })
            return Object.assign({}, state, {
                visPreCouponInfo: visPreValidationFailureInfo
            })
        case "FFPACKAGE_CHECKOUT_VALIDATION":
            let isFFCheckoutValidation = Object.assign({}, state.ffCouponInfo, {
                isFFCheckoutValidation: action.value
            })
            return Object.assign({}, state, {
                ffCouponInfo: isFFCheckoutValidation
            })
        case "VZCCOUPON_NOTIFCATION":
            let vzcCouponNotificationMsgInfo = Object.assign({}, state.vzcCouponInfo, {
                currentMsg: action.value.currentMsg,
                isDisplay: action.value.isDisplay
            })
            return Object.assign({}, state, {
                vzcCouponInfo: vzcCouponNotificationMsgInfo
            })
        case "VZCCOUPONVALIDATIONSTART":
            return Object.assign({}, state, {
                vzccValidationStart: action.value
            })
        case "VZCCOUPONVALIDATION":
            let vzcCouponValidationInfo = Object.assign({}, state.vzcCouponInfo, {
                vzcCoupon: (action.value !== undefined && action.value !== null && action.value.vzcCoupon !== undefined && action.value.vzcCoupon !== null && InHomeUtils.isNotEmpty(action.value.vzcCoupon)) ? action.value.vzcCoupon : state.vzcCouponInfo.vzcCoupon,
                vzcValidationSuccess: (action.value !== undefined && action.value !== null && action.value.vzcValidationSuccess !== undefined && action.value.vzcValidationSuccess !== null && action.value.vzcValidationSuccess) ? true : false,
                vzcValidationFailure: (action.value !== undefined && action.value !== null && action.value.vzcValidationFailure !== undefined && action.value.vzcValidationFailure !== null && action.value.vzcValidationFailure) ? true : false,
                currentMsg: (action.value !== undefined && action.value !== null && action.value.currentMsg !== undefined && action.value.currentMsg !== null && InHomeUtils.isNotEmpty(action.value.currentMsg)) ? action.value.currentMsg : '',
                isDisplay: (action.value !== undefined && action.value !== null && action.value.isDisplay !== undefined && action.value.isDisplay !== null && action.value.isDisplay) ? true : false,
                isvzcCheckoutValidation: (action.value !== undefined && action.value !== null && action.value.isvzcCheckoutValidation !== undefined && action.value.isvzcCheckoutValidation !== null && action.value.isvzcCheckoutValidation) ? true : false,
                isDiscountEligible: (action.value !== undefined && action.value !== null && action.value.isDiscountEligible !== undefined && action.value.isDiscountEligible !== null && action.value.isDiscountEligible) ? true : false,
                isDiscountApplied: (action.value !== undefined && action.value !== null && action.value.isDiscountApplied !== undefined && action.value.isDiscountApplied !== null && action.value.isDiscountApplied) ? true : false

            })
            return Object.assign({}, state, {
                vzcCouponInfo: vzcCouponValidationInfo
            })
        case "VZCPACKAGE_CHECKOUT_VALIDATION":
            let isvzcCheckoutValidation = Object.assign({}, state.vzcCouponInfo, {
                isvzcCheckoutValidation: action.value
            })
            return Object.assign({}, state, {
                vzcCouponInfo: isvzcCheckoutValidation
            })
        case "VZCOUPONREEDEMED":
            let isRedeemedAlready = Object.assign({}, state.vzcCouponInfo, {
                vzcCouponRedeemed: action.value
            })
            return Object.assign({}, state, {
                vzcCouponInfo: isRedeemedAlready
            })
        case "VZCCOUPONVALID":
            let vzcCouponInfo = Object.assign({}, state.vzcCouponInfo, {
                vzcCoupon: action.value !== undefined && action.value !== state.vzcCouponInfo.vzcCoupon ? action.value : state.vzcCouponInfo.vzcCoupon
            })
            return Object.assign({}, state, {
                vzcCouponInfo: vzcCouponInfo,
            })
        case "VISPRPCOUPONVALID":
            let visPreCouponInfo = Object.assign({}, state.visPreCouponInfo, {
                visPreCoupon: action.value !== undefined && action.value !== state.visPreCouponInfo.visPreCoupon ? action.value : state.visPreCouponInfo.visPreCoupon
                })
            return Object.assign({}, state, {
                visPreCouponInfo: visPreCouponInfo,
            })
        case "ISTWSANDMNH":
            let isMnhAndTWSAppied = Object.assign({}, state.visPreCouponInfo, {
                isMnhAndTWSAppied: action.value
                })
            return Object.assign({}, state, {
                visPreCouponInfo: isMnhAndTWSAppied,
                })
        case "VISPRECOUPONVALIDATIONSTATUS":
            let VisPreCouponValidationInfo = Object.assign({}, state.visPreCouponInfo, {
                visPreCoupon: (action.value && action.value.visPreCoupon) ? action.value.visPreCoupon : state.visPreCouponInfo.visPreCoupon ,
                leadListID: (action.value && action.value.leadListID) ? action.value.leadListID : state.visPreCouponInfo.leadListID ,
                visPreCouponError: (action.value && action.value.visPreCouponError) ? action.value.visPreCouponError : state.visPreCouponInfo.visPreCouponError ,
                visPreValidationSucess: (action.value && action.value.visPreValidationSucess) ? action.value.visPreValidationSucess : state.visPreCouponInfo.visPreValidationSucess ,
                visPreValidationFailure: (action.value && action.value.visPreValidationFailure) ? action.value.visPreValidationFailure : state.visPreCouponInfo.visPreValidationFailure ,
                visPreValidationErrorType :(action.value && action.value.visPreValidationErrorType) ? action.value.visPreValidationErrorType : state.visPreCouponInfo.visPreValidationErrorType,
                isVisPreCheckoutValidation: (action.value && action.value.isVisPreCheckoutValidation) ? action.value.isVisPreCheckoutValidation : state.visPreCouponInfo.isVisPreCheckoutValidation ,
                isDiscountEligible: (action.value && action.value.isDiscountEligible) ? action.value.isDiscountEligible : state.visPreCouponInfo.isDiscountEligible,
                isDiscountApplied: (action.value && action.value.isDiscountApplied) ? action.value.isDiscountApplied : state.visPreCouponInfo.isDiscountApplied
                })
            return Object.assign({}, state, {
                visPreCouponInfo: VisPreCouponValidationInfo
                })
        case "HBOUNSUPPORTED_NOTIFICATION":
            let hboNotificationInfo = Object.assign({}, state.hboUnSupportedNotificationInfo, {
                addChannel: (action.value !== undefined && action.value !== null && action.value.addChannel !== undefined && action.value.addChannel !== null) ? action.value.addChannel : state.hboUnSupportedNotificationInfo.addChannel,
                removeChannel: (action.value !== undefined && action.value !== null && action.value.removeChannel !== undefined && action.value.removeChannel !== null) ? action.value.removeChannel : state.hboUnSupportedNotificationInfo.removeChannel,
                showNotification: (action.value !== undefined && action.value !== null && action.value.showNotification !== undefined && action.value.showNotification !== null) ? action.value.showNotification : state.hboUnSupportedNotificationInfo.showNotification,
                swapStatus: (action.value !== undefined && action.value !== null && action.value.swapStatus !== undefined && action.value.swapStatus !== null) ? action.value.swapStatus : state.hboUnSupportedNotificationInfo.swapStatus
            })
            return Object.assign({}, state, {
                hboUnSupportedNotificationInfo: hboNotificationInfo
            })
        case "UPDATE_SCRESUME_PRODUCTSPLANS_MATCHSTATUS":
            let productsPlansMatchInfo = Object.assign({}, state.scResumeProductsPlansMatchInfo, {
                isTvPlanMatchSet: (action.value !== undefined && action.value !== null && action.value.isTvPlanMatchSet !== undefined && action.value.isTvPlanMatchSet !== null) ? action.value.isTvPlanMatchSet : state.scResumeProductsPlansMatchInfo.isTvPlanMatchSet,
                isDataPlanMatchSet: (action.value !== undefined && action.value !== null && action.value.isDatPlanMatchSet !== undefined && action.value.isDatPlanMatchSet !== null) ? action.value.isDatPlanMatchSet : state.scResumeProductsPlansMatchInfo.isDatPlanMatchSet
            })
            return Object.assign({}, state, {
                scResumeProductsPlansMatchInfo: productsPlansMatchInfo
            })
        case "FETCH_DOBUNDLE":
            let dobundleresponse = Object.assign({}, state.dobundle, {
                dobundleresponse: action.value,
                isStandalone: false
            })
            return Object.assign({}, state, {
                dobundle: dobundleresponse,
            })
        case "FETCH_HOABUNDLE":
             let hoaresponse = Object.assign({}, state.hoabundle, {
                 hoaresponse: action.value
                })
             return Object.assign({}, state, {
                hoabundle: hoaresponse,
                })
        case "UPDATE_HOADETAILS_ROUTER":
            if(!InHomeUtils.isNotEmpty(action.value) && !action.value){
                Object.assign({}, state, {
                    hoabundle: state.hoabundle,
                })
            }
            let valueRouter = action.value[0];
            let hoaresponseRouter = Object.assign({}, state.hoabundle.hoaresponse, {
                defaultMap : {
                    ...state.hoabundle.hoaresponse.defaultMap,
                    "router" : valueRouter.name
                },
                defaultUSocs : `${state.hoabundle.hoaresponse.defaultUSocs},${valueRouter.id}`
               })
            return Object.assign({}, state, {
                    hoabundle: Object.assign({}, state.hoabundle, {
                        hoaresponse :hoaresponseRouter ,
                     }),
                })
        case "UPDATE_HOADETAILS_CUSTOMETV":
            let hoaresponseCustomeTv = Object.assign({}, state.hoabundle.hoaresponse, {
                    defaultMap : {
                            ...state.hoabundle.hoaresponse.defaultMap
                        },
                        defaultUSocs : `${state.hoabundle.hoaresponse.defaultUSocs}`  ,
                        customeTvCont :    action.value
                       })
            return Object.assign({}, state, {
                            hoabundle: Object.assign({}, state.hoabundle, {
                                hoaresponse :hoaresponseCustomeTv ,
                        }),
                })

        case DOFlow.onSelectedCoreService:
            return Object.assign({}, state, {
                selectedCoreServices: action.value.selectedCoreService
            })

        case BuildProduct.updateContractAccordionStatus:
            let ctrct = Object.assign({}, state.contract, {
                isAccordionDisabled: action.value,
            })
            return Object.assign({}, state, {
                contract: ctrct
            })
        case BuildProduct.contractInSmartCart:
            let internetcontract = Object.assign({}, state.internet, {
                contract: action.value.contract
            })
            let tvcontract = Object.assign({}, state.tv, {
                contract: action.value.contract
            })
            let voicecontract = Object.assign({}, state.voice, {
                contract: action.value.contract
            })
            let maincontract = Object.assign({}, state.contract, {
                isAccordionOpen: false,
                isAccordionDisabled: (action.value !== undefined && action.value !== null && action.value.isEmpFlow !== undefined && action.value.isEmpFlow !== null && action.value.isEmpFlow) ? true : false,
                isAccordionOpenRequired: action.value.tileFlag,
                contractType: action.value.contract,
                isContractSwitched: false
            })
            return Object.assign({}, state, {
                internet: internetcontract,
                tv: tvcontract,
                voice: voicecontract,
                contract: maincontract
            })

        case "EMPTYBUILDFIOSSTATE":
            return initialState

        case "UPDATE_VIEWDETAILCONTENT":
            return Object.assign({}, state, {
                viewDetailContent: action.value
            })
        case "UPDATE_TELLMECONTENT":
            return Object.assign({}, state, {
                tellMeContent: action.value
            })
        case "DISCLAIMER_CONTENT_FRAGMENTS":
            return Object.assign({}, state, {
                disclaimerContentFragments: action.value
            })
        case "DISCLAIMER_CONTENT_FRAGMENTS_FROM_AEM":
                return Object.assign({}, state, {
                    disclaimerContentFragments: action.value
                })
        case "DISCLAIMER_PRODUCTS_FRAGMENTS":
            return Object.assign({}, state, {
                disclaimerProductsFragments: action.value
            })
        case "DISCLAIMER_COMMON_FRAGMENTS":
            return Object.assign({}, state, {
                disclaimerCommonFragments: action.value
            })
        case "PLANSPROMO_CONTENT_FRAGMENTS":
            return Object.assign({}, state, {
                plansPromoFragments: action.value
            })
        case "PLANSPROMO_CONTENT_FRAGMENTS_FROM_AEM":
            return Object.assign({}, state, {
                plansPromoFragments: action.value
            })
        case "FAQ_BUILDPRODUCT_CONTENT":
            return Object.assign({}, state, {
                faqBuildProductContent: action.value
            })
        case 'UPDATE_UNSUPPORTED_PRODUCTS':
            return Object.assign({}, state, {
                nonSupportedProduct: action.value
            })
        case 'ERRORMSG_REMOVESERVICE':
            return Object.assign({}, state, {
                errorMsgRemoveService: action.value
            })
        case 'ALL_PRODUCTS_AEM_FRAGMENTS':
            let obj = {};
            if(action && action.value && action.value.servType) {
                obj[action.value.servType] = action.value.response;
            }
            return Object.assign({}, state, {
                productFragments: {
                    ...state.productFragments,
                    ...obj
                }
            })
        case 'ALL_PERKS_AEM_FRAGMENTS':
        let obje = {};
        if(action && action.value && action.value.servType) {
            obje[action.value.servType] = action.value.response;
        }
        return Object.assign({}, state, {
            perksFragments: {
                ...state.perksFragments,
                ...obje
            }
        })
        case BuildProduct.saveUpsell:
            let upsellData = Object.assign({}, state.upsell, {
                isUpsellAvailable: action.value !== null && action.value.bundlekey !== undefined && action.value.bundlekey !== null && action.value.bundlekey !== '',
                isBundle: action.value.bundle,
                contract: action.value.contract,
                bundleKey: action.value.bundlekey,
                oncartkey: action.value.oncartkey,
                services: action.value.services,
                products: action.value.products,
                product: action.value.product,
                price: action.value.price,
                offers: action.value.offers,
                offersDesc: action.value.offersDesc,
                equipmentOffers: action.value.equipmentOffers,
                addlOffers: action.value.addlOffers,
                promos: action.value.promos,
                header: action.value.header,
                headercontent: action.value.headercontent,
                subheader: action.value.subheader,
                isUpsellCallInProgress: false,
                isnydma: action.value.nydma
            })
            return Object.assign({}, state, {
                upsell: upsellData
            })
        case BuildProduct.upsellCallStatus:
            let upsellCall = Object.assign({}, state.upsell, {
                isUpsellCallInProgress: action.value
            })
            return Object.assign({}, state, {
                upsell: upsellCall
            })
        case BuildProduct.upsellCTA:
            let upsellCart = Object.assign({}, state.upsell, {
                isUpsellAddedToCart: action.value.isUpsellAddedToCart,
                isUpsellDenied: action.value.isUpsellDenied
            })
            return Object.assign({}, state, {
                upsell: upsellCart
            })
        case 'SET_UPSELL_PRODUCTS':
            let upsellProducts = Object.assign({}, state.upsell, {
                products: action.value.products,
                product: action.value.product,
                isUpsellAvailable: action.value.status
            })
            return Object.assign({}, state, {
                upsell: upsellProducts
            })

        case BuildProduct.checkoutBtnSelection:
            let upsellSelect = Object.assign({}, state.upsell, {
                ischeckoutBtnClicked: action.value
            })
            return Object.assign({}, state, {
                upsell: upsellSelect
            })
        case BuildProduct.AutoAddStadiaGigToCart: {
            return (Object.assign({}, state, {
                autoAddStadiaInCart: action.autoAddStadiaInCart
            }))
        }
        case BuildProduct.AutoAddStadiaOfferToCart: {
            return (Object.assign({}, state, {
                autoAddStadiaOfferToCart: action.autoAddStadiaOfferToCart
            }))
        }
        case BuildProduct.AutoAddMarvelGigToCart: {
            return (Object.assign({}, state, {
                autoAddMarvelInCart: action.autoAddMarvelInCart
            }))
        }
        case BuildProduct.AutoAddMarvelOfferToCart: {
            return (Object.assign({}, state, {
                autoAddMarvelOfferToCart: action.autoAddMarvelOfferToCart
            }))
        }

        case 'TOGGLE_CONTRACT_ACCOR_IONT':
            let contractAccorIont = Object.assign({}, state.contract, {
                isAccordionOpen: !state.contract.isAccordionOpen,
                isAccordionOpenRequired: !state.contract.isAccordionOpenRequired,
            })
            return Object.assign({}, state, {
                contract: contractAccorIont
            })
        case 'ENABLE_NEW_CHECKOUT_FLOW':
            return Object.assign({}, state, {
                ecCheckoutNew : action.value
            })
        case 'SHOW_CHOICE_OFFERS_MOCK_EC':
            return Object.assign({}, state, {
                showMockChoiceOffersEC : action.value
            })
        case 'SHOW_REQUIRED_ERR_BANNER':
            return Object.assign({}, state, {
                requiredErrBanner : action.value
            })
        case 'ENABLE_NEW_BPP_HEADER':
            return Object.assign({}, state, {

                ecreskinBPP : action.value
            })
        case 'TOGGLE_CONTRACT_ACCOR_IONT_STATUS':
            return Object.assign({}, state, {
                isIONTStatus: action.value
            })
        case BuildProduct.isGPONIONTEligible:
            return Object.assign({}, state, {
                isGPONIONTEligible: action.value
            })
        case BuildProduct.isBannerChecked:
            return Object.assign({}, state, {
                isBannerChecked: action.value
            })
        case BuildProduct.isSmartCartFlow:
            return Object.assign({}, state, {
                isSmartCartFlow: action.value
            })
        case BuildProduct.isMarvelOfferInCart:
            return Object.assign({}, state, {
                isMarvelOfferInCart: action.value
            })
        case BuildProduct.isIdleTimeCheckout:
            return Object.assign({}, state, {
                isIdleTimeCheckout: action.value
            })
        case BuildProduct.previousSelectedSpeed:
            return Object.assign({}, state, {
                previousSelectedSpeed: action.value
            })
        case BuildProduct.isMarvelInPreviousSelSpd:
            return Object.assign({}, state, {
                isMarvelInPreviousSelSpd: action.value
            })
        case 'BOSTONDMA':
            return Object.assign({}, state, {
                isBostonDMA: action.value
            })
        case 'ULTIMATE_DRIVE_AVL':
            let ultimateDrive = Object.assign({}, state.tv, {
                isUltimateTestDriveEligible: action.value
            })
            return Object.assign({}, state, {
                tv: ultimateDrive
            })
        case 'ULTIMATE_USOC':
            let ultimateTV = Object.assign({}, state.tv, {
                ultimateTvUsoc: action.value
            })
            return Object.assign({}, state, {
                tv: ultimateTV
            })
        case 'TESTDRIVEOPTOUT':
            let optOut = Object.assign({}, state.tv, {
                testdriveOptOut: !action.value
            })
            return Object.assign({}, state, {
                tv: optOut
            })
        case 'FIOS_TV_ONE_ELIGIBLE':
            let fiosOne = Object.assign({}, state.tv, {
                fiosTvOneEligible: action.value
            })
            return Object.assign({}, state, {
                tv: fiosOne
            })
        case 'SPANISH_TV':
            let spanishTab = Object.assign({},state.tv,{
                spanishTV:action.value
            })
            return Object.assign({}, state, {
                tv: spanishTab
            })
        case 'SET_MIDNIGHT':
            return Object.assign({}, state,{
                isMNEnabled : action.value
            })
        case 'SET_ECMIDNIGHT':
        return Object.assign({}, state,{
            isECMNEnabled : action.value
        })
        case 'SET_APENABLED':
            return Object.assign({}, state,{
                isAPDataEnabled : action.value
            })
        case 'SET_MnhToggle':
            return Object.assign({}, state,{
                isStaticMnhEnable : action.value
            })
        case 'SET_PPENABLED':
            return Object.assign({}, state,{
                isPopularPlan : action.value
            })
        case 'SET_CUSTOMIZE_FROM_PP':
            return Object.assign({}, state,{
                isCustomizeFromPP : action.value
            })

        case 'SET_MVAPERKS':
            let mvaECPerks = Object.assign({}, state.perks, {
                mvaECPerks: action.value
            })
            return Object.assign({}, state, {
                    perks: mvaECPerks
                })

        case 'VMS1100_ELIGIBLE':
            let vms1100 = Object.assign({}, state.tv, {
                vms1100Eligible: action.value
            })
            return Object.assign({}, state, {
                    tv: vms1100
            })
        case 'VMS41001100_ELIGIBLE':
            let vms41001100 = Object.assign({}, state.tv, {
                vms41001100Eligible: action.value
            })
            return Object.assign({}, state, {
                    tv: vms41001100
            })

        case 'STREAMTV_ELIGIBLE':
            let streamTv = Object.assign({}, state.tv, {
                streamTvEligible: action.value
            })
            return Object.assign({}, state, {
                 tv: streamTv
            })
        case 'ANDROID_ELIGIBLE':
            let android = Object.assign({}, state.tv, {
                AndriodUpgradeEligible: action.value
            })
            return Object.assign({}, state, {
                tv: android
            })
        case 'QAM_ELIGIBLE':
            let qam = Object.assign({}, state.tv, {
                QAMEligible: action.value
            })
            return Object.assign({}, state, {
                tv: qam
            })

        case 'FIOSTV_ONE_OPTIONS':
            let fiosOneProducts = Object.assign({}, state.tv, {
                fiosTvOneUpgradeOptions: action.value
            })
            return Object.assign({}, state, {
                tv: fiosOneProducts
            })
        case 'FIOSTV_ONE_SELECTED':
            let fiosOneSelected = Object.assign({}, state.tv, {
                FiosTvOneSelected: action.value
            })
            return Object.assign({}, state, {
                tv: fiosOneSelected
            })
        case 'VMS_PRODUCT_SELECTED':
            let VMSSelected = Object.assign({}, state.tv, {
                VMSProductSelected: action.value
            })
            return Object.assign({}, state, {
                tv: VMSSelected
            })
        case 'STREAMTV_PRODUCT_SELECTED':
            let StreamTVSelected = Object.assign({}, state.tv, {
                StreamTVProductSelected: action.value
            })
            return Object.assign({}, state, {
                tv: StreamTVSelected
            })

        case 'UPDATE_VCPE_STB_Qty':
            let tvSetTopBoxes = Object.assign({}, state.tv, {
                vcpestbQty: action.value
            })
            return Object.assign({}, state, {
                tv: tvSetTopBoxes
            })
        case 'UPDATE_GPONIONT_CONTRACT':
            let gponIONTContract = Object.assign({}, state.contract, {
                isAccordionOpen: true,
                isAccordionOpenRequired: true,
                contractType: action.value,
                isContractSwitched: true,
            })
            return Object.assign({}, state, {
                contract: gponIONTContract
            })
        case 'UPDATE_CONTRACT_STATUS':
            let contractStatus = Object.assign({}, state.contract, {
                isAccordionOpen: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.isAccordionOpen) ? action.value.isAccordionOpen : state.contract.isAccordionOpen,
                isAccordionDisabled: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.isAccordionDisabled) ? action.value.isAccordionDisabled : state.contract.isAccordionDisabled,
                isAccordionOpenRequired: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.isAccordionOpenRequired) ? action.value.isAccordionOpenRequired : state.contract.isAccordionOpenRequired,
                contractType: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.contractType) ? action.value.contractType : state.contract.contractType,
                isContractSwitched: InHomeUtils.isNotNull(action.value) && InHomeUtils.isNotNull(action.value.isContractSwitched) ? action.value.isContractSwitched : state.contract.isContractSwitched,
            })
            return Object.assign({}, state, {
                contract: contractStatus
            })
        case 'FETCH_CONTRACTOFFER':
            let contractOffer = Object.assign({}, state.contractoffer, {
                offerplansMTM: action.value !== null && action.value.offersMTM !== undefined && action.value.offersMTM !== null ? action.value.offersMTM : null,
                offerplans2YR: action.value !== null && action.value.offer2YR !== undefined && action.value.offer2YR !== null ? action.value.offer2YR : null,
            })
            return Object.assign({}, state, {
                contractoffer: contractOffer
            })
        case 'FETCH_SPLOFFER':
            let dataSplOffers = Object.assign({}, state.sploffer.data, {
                offerplansMTM: replaceSpecialOffers(action.value !== null && action.value.dataOffersMTM !== undefined && action.value.dataOffersMTM !== null ? action.value.dataOffersMTM : null, state.internet.selectedProduct),
                isAccordionOpen: action.value !== null && action.value.isDataOffer !== undefined && action.value.isDataOffer && state.sploffer.data.selectedProduct === null,
            })
            let tvSplOffers = Object.assign({}, state.sploffer.tv, {
                offerplansMTM: action.value !== null && action.value.tvOffersMTM !== undefined && action.value.tvOffersMTM !== null ? action.value.tvOffersMTM : null,
                isAccordionOpen: action.value !== null && action.value.isTVOffer !== undefined && action.value.isTVOffer && state.sploffer.tv.selectedProduct === null,
            })
            let splOffer = Object.assign({}, state.sploffer, {
                offerplansMTM: replaceSpecialOffers(action.value !== null && action.value.offersMTM !== undefined && action.value.offersMTM !== null ? action.value.offersMTM : null, state.internet.selectedProduct),
                offerplans2YR: replaceSpecialOffers(action.value !== null && action.value.offer2YR !== undefined && action.value.offer2YR !== null ? action.value.offer2YR : null,state.internet.selectedProduct),
                isDataOffer: action.value !== null && action.value.isDataOffer !== undefined && action.value.isDataOffer,
                isTVOffer: action.value !== null && action.value.isTVOffer !== undefined && action.value.isTVOffer,
                isAccordionOpen: state.router.selectedProduct !== null && state.tvConnections.selectedProduct !== null && state.sploffer.selectedProduct === null,
                data: dataSplOffers,
                tv: tvSplOffers
            })
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, {
                    isSubAccordionOpen: state.isMNEnabled && action.value !== null && action.value.isDataOffer !== undefined && action.value.isDataOffer && state.sploffer.data.selectedProduct === null
                }),
                sploffer: splOffer
            })
        case 'FETCH_FLASHOFFER':
            let flashOffer = Object.assign({}, state.flashoffer, {
                offerplansMTM: action.value !== null && action.value.flashoffersMTM !== undefined && action.value.flashoffersMTM !== null ? action.value.flashoffersMTM : null,
                offerplans2YR: action.value !== null && action.value.flashoffer2YR !== undefined && action.value.flashoffer2YR !== null ? action.value.flashoffer2YR : null,
                isAccordionOpen: action.value?.isFlashOffer === true && state.flashoffer.selectedProduct === null && !state.router.isAccordionOpen && state.router.selectedProduct !== null,
                isFlashOffer: action.value && action.value.isFlashOffer,
            })
            let intFlashSplAccr = Object.assign({}, state.sploffer.data, {
               // isAccordionOpen: (state.sploffer.data.offerplansMTM && state.sploffer.data.offerplansMTM.length && !state.sploffer.data.selectedProduct) && !flashOffer.isFlashOffer
                isAccordionOpen : true
            })
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, {
                    // isSubAccordionOpen: state.isMNEnabled
                    isSubAccordionOpen: state.isMNEnabled
                        ? state.perks.isAccordionOpen ? false : state.internet.isSubAccordionOpen
                        : false
                }),
                router: Object.assign({}, state.router, {
                    // isAccordionOpen: (action.value && action.value.isFlashOffer && !flashOffer.isAccordionOpen && !intFlashSplAccr.isAccordionOpen && state.router.selectedProduct === null)? true:false
                    isAccordionOpen: (action.value?.isFlashOffer && state.flashoffer.selectedProduct === null)
                        ? (action.value && action.value.isFlashOffer && !flashOffer.isAccordionOpen && !intFlashSplAccr.isAccordionOpen && state.router.selectedProduct === null) ? true : false
                        : state.router.isAccordionOpen
                }),
                fne: Object.assign({}, state.fne, {
                    isAccordionOpen: false
                }),
                techsure: Object.assign({}, state.techsure, {
                    isAccordionOpen: false
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    isAccordionOpen: false
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    isAccordionOpen: false
                }),
                sploffer: Object.assign({}, state.sploffer, {
                    data: intFlashSplAccr
                }),
                flashoffer: flashOffer
            })
        case 'FETCH_STREAMSERV':
            let streamserv = Object.assign({}, state.streamServ, {
                streamServProd: action.value !== null ? action.value : null
            })
            return Object.assign({}, state, {
                streamServ: streamserv
            })
        case 'FETCH_STREAMDEV':
            var count = 3;
            let originalPrice = 0;
            let id = "";
            let OriginalName = "";
            let streamdev = Object.assign({}, state.streamDev, {
                streamDevProd: action.value !== null ? action.value : null
            })
            if (streamdev.streamDevProd !== undefined && streamdev.streamDevProd !== null && streamdev.streamDevProd.length > 0) {
                originalPrice = streamdev.streamDevProd[0].originalPrice;
                id = streamdev.streamDevProd[0].id;
                OriginalName = streamdev.streamDevProd[0].name;
            }
            var ProdCnt = [];
            for (var i = 1; i <= count; i++) {
                let price = (i * originalPrice).toFixed(2);
                ProdCnt.push({
                    unitCount: i,
                    prodType: 'STREAMDEVCNT',
                    selectedProduct: null,
                    displayPrice: "$" + price,
                    id: id,
                    name: (i == 1) ? i + " " + OriginalName + " Device" : i + " " + OriginalName + " Devices",
                    OriginalName: OriginalName
                })
            }
            return Object.assign({}, state, {
                streamDev: streamdev,
                streamDevCount: Object.assign({}, state.streamDevCount, {
                    streamDevCountProd: ProdCnt
                })
            })
        case 'SET_FIOSFIVE_SEARCH_VHO_PARAMS':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveSearchVhoParams: Object.assign({}, state.tv.fiosFiveSearchVhoParams, {
                        regionId: action.value.regionId,
                        lfa: action.value.lfa,
                        lfaName: action.value.lfaName,
                        vhoName: action.value.vhoName
                    })
                })
            })
        case 'SET_FIOSFIVE_SEARCH_SUGGESTIONS':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveSearchSuggestions: action.value
                })
            })
        case 'SET_FIOSFIVE_SEARCH_MATCHED_CHANNELS':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveSearchMatchedChannels: action.value
                })
            })
        case 'SET_FIOSFIVE_BASIC_CHANNELS':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveBasicChannels: action.value
                })
            })
        case 'SET_FIOSFIVE_SELECTED_CHANNELS':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveSelectedChannels: action.value
                })
            })
        case 'SET_FIOSFIVE_SELECTED_CHANNELS_PROFILE':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveSelectedChannelsProfile: action.value
                })
            })
        case 'SET_FIOSFIVE_BASIC_CHANNEL_ISOCS':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveBasicChannelIsocs: action.value
                })
            })
        case "SET_FIOSFIVE_RECOMMENDED_CHANNELS":
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveRecommendedChannels: action.value,
                }),
            });
        case "SET_FIOSFIVE_RECOMMENDED_CHANNEL_ISOCS":
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    fiosFiveRecommendedChannelIsocs: action.value,
                }),
            });
        case 'SET_FIOSFIVE_EVENT_TYPE':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    isNewChannelSet: action.value
                })
            })
        case BuildProduct.fcpSeeDetails:
            return Object.assign({}, state, {
                fcpSeeDetails: action.value
            })
        case 'CUSTOMTV_PREFERRED_RECOMM':
            let custTv = Object.assign({}, state.tv.customTV, {
                isAccordionOpen: false
            })
            let updatedCustomTV = Object.assign({}, state.tv, {
                customTV: custTv,
                isSubAccordionOpen: true
            })
            return Object.assign({}, state, {
                tv: updatedCustomTV,
                // focusAccordion: true
            })
        case 'CUSTOMTV_RECOMM':
            return Object.assign({}, state, {
                // focusAccordion: true
            })
        case 'SET_FIOS_FIVE_MODAL_DETAILS':
            let fiosFive = Object.assign({}, state.tv.fiosFive, {
                fiosFiveModal: action.payload.modalType,
                selectedChannels: action.payload.selectedChannels
            })
            let updatedFiosFive = Object.assign({}, state.tv, {
                fiosFive: fiosFive,
            })
            return Object.assign({}, state, {
                tv: updatedFiosFive,
            })

        case 'EMERGENCY_PRESELECT_100M':
            let autoAdd100M = Object.assign({}, state.emergencyNotification, {
                autoAdd100MInCart: action.value
            })
            return Object.assign({}, state, {
                emergencyNotification: autoAdd100M
            })
        case 'EMERGENCY_GPON_MOCHA_ELIGIBLE':
            let gponMocha = Object.assign({}, state.emergencyNotification, {
                isGPONMochaEligible: action.value
            })
            return Object.assign({}, state, {
                emergencyNotification: gponMocha
            })
        case 'MOBILE_AND_HOME_ELIGIBLE':
            return Object.assign({}, state, {
                mobileandhomeEligible: action.value
            })
        case BuildProduct.clearBuildProductState:
            return initialState
        case 'CLEARCART':
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, {
                    selectedProduct: null,
                    accordionStatus: '',
                    subAccordionStatus: '',
                    disconnected: false
                }),
                mm3internetsub : Object.assign({},state.mm3internetsub,{
                    offerplansMTM : null,
                    offerplans2YR : null,
                    accordionStatus : '',
                    subAccordionStatus:'',
                    selectedProduct:null,
                    offerplans : null,

                }),
                returnedEquipmentCount:0,
                tv: Object.assign({}, state.tv, {
                    selectedProduct: null,
                    testdriveOptOut: false,
                    accordionStatus: '',
                    subAccordionStatus: '',
                    disconnected: false,
                    FiosTvOneSelected: false,
                    VMSProductSelected: false,
                    StreamTVProductSelected: false
                }),
                voice: Object.assign({}, state.voice, {
                    selectedProduct: null,
                    accordionStatus: '',
                    subAccordionStatus: '',
                    disconnected: false
                }),
                perks: Object.assign({}, state.perks, {
                    selectedProduct: null,
                    accordionStatus: '',
                    disconnected: false
                }),
                router: Object.assign({}, state.router, {
                    selectedProduct: null,
                    accordionStatus: ''
                }),
                accessPoint: Object.assign({}, state.accessPoint, {
                    selectedProduct: null,
                    accordionStatus: ''
                }),
                techsure: Object.assign({}, state.techsure, {
                    selectedProduct: null,
                    accordionStatus: '',
                    modTechSureProducts:state.techsure.modTechSureProducts,
                    disconnected:false,
                    disconnectedProducts:null,
                    isHomeSecurityProductAdded:false,
                    isHomeSecurityPlusProductAdded:false,
                    isHomeSecurityProductRemoved:false,
                    homeSecurityBundlePrice:null
                }),
                vhsBiller: Object.assign({}, state.vhsBiller, {
                    vhsProducts: null,
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: 'optional',
                    vhsChildList: null,
                }),
                techsurecloud: Object.assign({}, state.techsurecloud, {
                    selectedProduct: null,
                    accordionStatus: '',
                    disconnected:false
                }),
                fne: Object.assign({}, state.fne, {
                    selectedProduct: null,
                    accordionStatus: '',
                    isWholeHomeWifiAdded: false,
                    whwExtenderProduct:null,
                    unitCount: 0,
                    isWholeHomeWifiPlusAdded: false,
                    isWholeHomeWifi2Added: false
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    selectedProduct: null,
                    accordionStatus: ''
                }),
                recording: Object.assign({}, state.recording, {
                    selectedProduct: null,
                    accordionStatus: ''
                }),
                channel: Object.assign({}, state.channel, {
                    selectedProduct: null,
                    accordionStatus: 'optional'
                }),
                internationalChannel: Object.assign({}, state.internationalChannel, {
                    selectedProduct: null,
                    accordionStatus: 'optional',
                    removedProduct: null
                }),
                streamServ: Object.assign({}, state.streamServ, {
                    selectedProduct: null,
                    accordionStatus: '',
                    removedProduct: null,
                    subAccordionStatus:''
                }),
                longDistance:Object.assign({},state.longDistance,{
                    longDistanceProducts: null,
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: ''
                }),
                intlPlans:Object.assign({},state.intlPlans,{
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: ''
                }),
                intlCalling:Object.assign({},state.intlCalling,{
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: 'required'
                }),
                backup:Object.assign({},state.backup,{
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: 'required',
                    isShipmentAvailable: false,
                    isShipmentRequired: false

                }),
                listing:Object.assign({},state.listing,{
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: 'required'
                }),
                winback:Object.assign({},state.winback,{
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: 'required'
                }),
                emergencyServices:Object.assign({},state.emergencyServices,{
                    emergencyServicesProducts: null,
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: 'optional',
                    notificationMethod: 'text',
                    email: {
                        value: '',
                        emailValid: false
                    },
                    mobile: {
                        value: '',
                        mobileValid: false
                    }
                }),
                slingStreamServ: Object.assign({}, state.slingStreamServ, {
                    selectedProduct: null
                }),
                tvConnections:Object.assign({},state.tvConnections,{
                    selectedProduct: null,
                    displaySection: null,
                    isAccordionOpen: false,
                    accordionStatus: ''
                }),
                ceApps:Object.assign({},state.ceApps,{
                    displaySection: null,
                    displayAccorSection: null,
                    selectedProduct: null,
                    isAccordionOpen: false,
                    accordionStatus: '',
                }),
                sweetnerReducer:Object.assign({}, state.sweetnerReducer,{
                    vroom:{
                        header:"You made a change to your service.",
                        body:"Return unneeded equipment. If you don't, you will continue to pay the monthly charges for it.",
                        visible:false,
                    },
                    router:{
                        header:"You made a change to your service.",
                        body:"Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item.",
                        visible:false,
                        autoAdd:false,
                        profileWhwReplaceChrRouterWhw:false,
                        profileWhwReplaceChrRouterWhwBody:"<div>Your current equipment will not work with your new 2 Gigabit service. An upgraded router has been added to your order.</br> Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item.",
                        profileBhrxReplaceChrRouterWhw:false,
                        profileBhrxReplaceChrRouterWhwBody:"<div>Your current equipment will not work with your new 2 Gigabit service and has been upgraded with this order.</br> Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item."
                    },
                    tv:{
                        header:"",
                        headerFD:"You made a change to your service.",
                        headerPD:"You made a change to your service",
                        body:"Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item",
                        visible:false,
                    },
                    fne:{
                        header:"You made a change to your service.",
                        body:"Unneeded equipment must be returned within 30 days to avoid unreturned equipment charges of up to $375 per item.",
                        visible:false,
                    },
                    dvr:{
                        header:"We'll ship your new equipment within 3 business days.",
                        body:"Return old equipment, If you don't, you will continue to pay monthly charges for it.",
                        visible:false,
                    },
                    fiostvone:{
                        header:"We'll ship your new equipment within 3 business days.",
                        body:"Return old equipment within 30 days to avoid unreturned equipment charges of up to $375 per item. Note: Digital Adapters and Cable CARDS work with the new equipment, so there's no need to return them.",
                        visible:false,
                    },
                    fttpd_bolton:{
                        header:"You made a change to your service.",
                        body:"Changes to your internet speed will result in losing your complimentary Gigabit Connection upgrade.",
                        visible:false,
                    },
                    speedDowngrade:{
                        header:"You made a change to your service.",
                        body:"Reducing your internet speed below Gigabit will increase your Mobile bill by $5/line per month.",
                        visible:true,
                    },
                    speedUpgrade:{
                        header:"You made a change to your service.",
                        body:"Save an additional $5/line per month on your Mobile bill when you upgrade to Fios Gigabit Connection or higher speed",
                        visible:true,
                    },
                    fttpd:{
                        header:"You made a change to your service.",
                        body:"Please note features that were included with Gigabit Connection will now incur a charge",
                        visible:false,
                    },
                    whwRouterChange:{
                        header:"You made a change to your service.",
                        body:"Since you no longer have Gigabit Connection, Whole-Home Wi-Fi is no longer included",
                        visible:false,
                    },
                    whwplusRouterChange:{
                        header:"You made a change to your service.",
                        body:"Since you no longer have 2 Gig or 1 Gig Complete Package, Whole Home Wi-Fi Plus is no longer included.",
                        visible:false,
                    },
                    discCloudChange:{
                        header:"You made a change to your service.",
                        body:"Verizon Cloud is no longer included, but we're providing a 30 day trial on us. $14.99/mo therafter. Cancel within 30 days at no charge.",
                        visible:false,
                    },

                }),
                ecPromoDropped:false
            })
        case 'UPDATEREQUIREDSATUS':
            let requiredobject = action.value;
            return Object.assign({}, state, {

                router: Object.assign({}, state.router, {
                    accordionStatus: requiredobject.routerStatus
                }),
                vRoom: Object.assign({}, state.vRoom, {
                    // selectedProduct: null,
                    accordionStatus: requiredobject.vroomStatus
                }),
                recording: Object.assign({}, state.recording, {
                    selectedProduct: requiredobject?.recordingStatus === "required" ? null : state.recording.selectedProduct,
                    accordionStatus: requiredobject.recordingStatus
                }),
                dct: Object.assign({}, state.dct, {
                    selectedProduct: requiredobject?.dctStatus === "required" ? null : state.dct.selectedProduct,
                    accordionStatus: requiredobject.dctStatus
                }),
                tvConnections: Object.assign({}, state.tvConnections, {
                    selectedProduct: requiredobject?.tvConnectionStatus === "required" ? null : state.tvConnections.selectedProduct,
                    accordionStatus: requiredobject.tvConnectionStatus
                }),
                ceApps: Object.assign({}, state.ceApps, {
                    accordionStatus: requiredobject.ceAppsStatus
                }),
            })
        case 'UPDATEDISCONNECTTV':
            return Object.assign({}, state, {
                tv: Object.assign({}, state.tv, {
                    disconnected: action.value
                })
            })
        case 'UPDATEDISCONNECTINTERNET':
            return Object.assign({}, state, {
                internet: Object.assign({}, state.internet, {
                    disconnected: action.value
                })
            })
        case 'MNHSIGNUPINDICATOR':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet, {
                    mnhSignupIndicator : action.value})
            })
        case 'STRIKE_PRICE_INDICATOR':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet,{
                    strikePrice : action.value
                })
            })
            case 'LEGACY_STB_LEAD_LIST_CUSTOMERS':
                return Object.assign({},state,{
                    internet: Object.assign({},state.internet,{
                        legSTBLeadLstCust: action.value
                    })
                })
            case 'LEAD_LIST_ADDRESS_VALIDATION':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet,{
                    isLeadListAddress : action.value
                })
            }) 
            case 'IS_FEE_WAIVED_FOR_ALL':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet,{
                    isFeeWaivedForAll : action.value
                })
            })
        case 'STRIKE_PRICE_INDICATOR1':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet,{
                    typeofDiscount: action.value
                })
            })
        case 'STRIKE_PRICE_INDICATOR2':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet,{
                    typeOfDiscountScenario : action.value
                })
            })
        case 'MM3INTERNETSUBPROD':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet,{

                    mm3internetsubprod : action.value
                })
            })
        case 'MM3QUALIFIED':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet, {
                    mm3Qualified : action.value
                })
            })
        case 'VZEMPLOYEE':
                return Object.assign({},state,{
                    internet : Object.assign({},state.internet, {
                        vzEmployee : action.value
                    })
                })
        case 'MM3_PLANS_AVAILABLE':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet, {
                    isMM3PlansAvailable : action.value
                })
            })
        case 'MM2_PLANS_AVAILABLE':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet, {
                    isMM2PlansAvailable : action.value
                })
            })
        case 'SET_MM3_PAGE_VERSION':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet, {
                    isMM3PageVersion : action.value
                })
            })
        case 'IS_DATA_ON_PROFILE':
            return Object.assign({},state,{
                internet : Object.assign({},state.internet, {
                    isDataOnProfile : action.value
                })
            })
        case 'IS_TV_ON_PROFILE':
            return Object.assign({},state,{
                tv : Object.assign({},state.tv, {
                    isTvOnProfile : action.value
                })
        })
        case 'ALLOW_MUTLIGIG_TV_ENABLE':
            return Object.assign({},state,{
                tv : Object.assign({},state.tv, {
                    allowMutliGigTVEnable : action.value
                })
        })
        case 'IS_VOICE_ON_PROFILE':
            return Object.assign({},state,{
                voice : Object.assign({},state.voice, {
                    isVoiceOnProfile : action.value
                })
        })
        case 'IS_PERKS_ON_PROFILE':
            return Object.assign({},state,{
                perks : Object.assign({},state.perks, {
                    isPerksOnProfile : action.value
            })
        })
        case 'NETMAX_OFFER_TOGGLE':
            return Object.assign({},state,{
                perks : Object.assign({},state.perks, {
                    netMaxOfferToggle : action.value
                })
            })
        case 'FETCH_DATASUBPROD':
            let datasubprod = Object.assign({}, state.mm3internetsub, {
                offerplansMTM: action.value !== null && action.value !== undefined ? action.value : null,
                offerplans2YR: action.value !== null && action.value !== undefined  ? action.value : null,
                isAccordionOpen: state.mm3internetsub.selectedProduct === null,

            })
            return Object.assign({}, state, {
                mm3internetsub: datasubprod,
                router: Object.assign({}, state.router, {
                    // isAccordionOpen:false
                    isAccordionOpen: state.mm3internetsub.selectedProduct === null && action.value !== null && action.value !== undefined && Array.isArray(action.value) && action.value.length > 0
                        ? false
                        : state.router.isAccordionOpen
                })
            })
        case 'FETCH_PERKSUBPROD':
                let perksubprod = Object.assign({}, state.mm3perksub, {
                    offerplansMTM: action.value !== null && action.value !== undefined ? action.value : null,
                    isAccordionOpen: state.mm3perksub.selectedProduct === null,
                })
                return Object.assign({}, state, {
                    mm3perksub: perksubprod,
                })
        case 'MM3_SELECTEDPROD':
                let selecteddatasubprod = Object.assign({}, state.mm3internetsub, {
                    selectedProduct : action.value ,
                    subAccordionStatus: action.value === null ? 'required' : 'added',
                    accordionStatus : action.value === null ? 'required' : 'added',
                    isAccordionOpen : action.flag == true ? false : action.value === null ? true : false

                })
                let internetAcc = Object.assign({}, state.internet, {
                    isAccordionOpen : action.flag == true ? false : state.internet.isAccordionOpen
                })
                return Object.assign({}, state, {
                        internet: internetAcc,
                        mm3internetsub: selecteddatasubprod
                })
                case 'MM3_PROFILE_SELECTEDPROD':
                    let profileprod = Object.assign({}, state.mm3internetsub, {
                        subAccordionStatus: action.value === null ? 'required' : 'added',
                        accordionStatus : action.value === null ? 'required' : 'added',
                    isAccordionOpen : action.value === null ? true:false

                    })
                    return Object.assign({}, state, {
                            mm3internetsub: profileprod
                    })

        case 'UPDATEDISCONNECTVOICE':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    disconnected: action.value
                })
            })
        case 'UPDATE_DISCONNECT_VAS':
            if(action.payload.vasType==="techsure"){ //disconnecting based on action payload type..
                return Object.assign({}, state, {
                    techsure: Object.assign({}, state.techsure, {
                            disconnected: action.payload.value
                    })
                })
            }else{
                return Object.assign({}, state, {
                    techsurecloud: Object.assign({}, state.techsurecloud, {
                            disconnected: action.payload.value
                    })
                })

            }


        case 'TOGGLE_DATA_PLANS':
            let isShowMorePlans = Object.assign({}, state.internet, {
                isShowMorePlans: !state.internet.isShowMorePlans
            })
            return Object.assign({}, state, {
                internet: isShowMorePlans
            })
        case 'ONPROFILESTATUS':
            return Object.assign({}, state, {
                productOnProfileStatus: Object.assign({}, state.productOnProfileStatus, action.value)
            })
        case 'IS_YOUTUBE_ONCSR':
            let profileyoutube = Object.assign({}, state.streamServ, {
                isYoutubeOnCsr: action.value
            })
            return Object.assign({}, state, {
                streamServ: profileyoutube
        })
        case 'DataAccordionOpen':
            let tempinternet = Object.assign({}, state.internet, {
                accordionStatus: action.value,
                subAccordionStatus:action.value
            })
            return Object.assign({}, state, {
                internet: tempinternet
        })
        case 'SET_EC_BANNER_MESSAGE':
            return Object.assign({}, state, {
                ecbannerMessage: action.value
            })
        case 'SPL_OFFER_PYP':
            return Object.assign({}, state, {
                splMsgPYP: action.value
            })
        case 'REFER_NO_CHANGE':
            return Object.assign({}, state, {
                voice: Object.assign({}, state.voice, {
                    isRefNoChange: action.value
                })
            })
        case 'MAKE_CHANGE_HITS':
            return Object.assign({}, state, {
                makechangehits: state.makechangehits + action.value
            })
        case 'SKIP_DEFAULT_ACCORDION':
            return Object.assign({}, state, {
                skipDefaultAccordion: action.value
            })
        case "SET_DEFAULT_ACCORDION":
            if(!state.planCalled) { //stopping accordion render after first time
                // let inter = Object.assign({}, state.internet, {
                //     isAccordionOpen: status,
                //     isSubAccordionOpen: status
                // })
                let internetAccStatus= false;
                //state.accordion[state.defaultAccordion] = true;
                internetAccStatus = ((state.defaultAccordion === '' || state.defaultAccordion === FlowRoute.classicToFCP || state.defaultAccordion === 'AddInternetReveal') ? true : false)
                if(internetAccStatus) state.parentAccordian.AddInternetMain = true;
                let defAcc = state.defaultAccordion.split('-')[0];
                if(state.defaultAccordion !== undefined && state.defaultAccordion !== null
                    && state.defaultAccordion.trim() != '' && !state.accordion[state.defaultAccordion]) {
                        var defaultAccordion = state.defaultAccordion;
                        if (state.defaultAccordion.indexOf('-') > -1)
                            defaultAccordion = state.defaultAccordion.split('-')[0];
                        defaultAccordion = defaultAccordion.trim();
                        if (defaultAccordion != 'SpecialOffers') {
                            var objectssearch = state.accordianhierarchy;
                            var resultparent = '';
                            for (var i = 0; i < objectssearch.length; i++) {
                                for (var key in objectssearch[i]) {
                                    var tempobj = objectssearch[i];
                                    if (tempobj[key].indexOf(defaultAccordion) != -1) {
                                        resultparent = key;
                                        break;
                                    }
                                }
                            }
                            if (!state.parentAccordian[resultparent])
                                state.parentAccordian[resultparent] = true;
                            if (!state.accordion[defaultAccordion])
                                state.accordion[defaultAccordion] = true;
                        }
                }
                let focusAccStatus =  (state.accordion[defAcc] || internetAccStatus) ? true : false;
                return Object.assign({}, state, {
                    internet: Object.assign({}, state.internet, {
                        isAccordionOpen: (!state?.perkSectionAutoScroll || state.skipDefaultAccordion) ? false : state.parentAccordian.AddInternetMain,
                        isSubAccordionOpen: internetAccStatus
                    }),
                    router: Object.assign({}, state.router, {
                        isAccordionOpen: state.accordion.RouterOptions,
                        isSubAccordionOpen: state.accordion.RouterOptions
                    }),
                    fne: Object.assign({}, state.fne, {
                        isAccordionOpen: state.accordion.networkExtender,
                        isSubAccordionOpen: state.accordion.networkExtender
                    }),
                    techsure: Object.assign({}, state.techsure, {
                        isAccordionOpen: state.accordion.SecurityIdentity,
                        isSubAccordionOpen: state.accordion.SecurityIdentity
                    }),
                    techsurecloud: Object.assign({}, state.techsurecloud, {
                        isAccordionOpen: state.accordion.CloudStorage,
                        isSubAccordionOpen: state.accordion.CloudStorage
                    }),
                    streamServ: Object.assign({}, state.streamServ, {
                        isAccordionOpen: state.parentAccordian.AddStreamingMain,
                        isSubAccordionOpen: state.accordion.internetstreaming
                    }),
                    tv: Object.assign({}, state.tv, {
                        isAccordionOpen: state.parentAccordian.AddTvMain,
                        isSubAccordionOpen: state.accordion.AddTvReveal
                    }),
                    channel: Object.assign({}, state.channel, {
                        isAccordionOpen: state.accordion.TvPremiumChannels,
                        isSubAccordionOpen: state.accordion.TvPremiumChannels
                    }),
                    vRoom: Object.assign({}, state.vRoom, {
                        isAccordionOpen: state.accordion.TvEquipmentChoices? state.accordion.TvEquipmentChoices:state.accordion.VMS1100UPGRADE,
                        isSubAccordionOpen: state.accordion.TvEquipmentChoices? state.accordion.TvEquipmentChoices:state.accordion.VMS1100UPGRADE,
                    }),
                    fiosTvOne: Object.assign({}, state.fiosTvOne, {
                        isAccordionOpen: state.accordion.FiosTvUpgrade,
                        isSubAccordionOpen: state.accordion.FiosTvUpgrade
                    }),
                    vms1100: Object.assign({}, state.vms1100, {
                        isAccordionOpen: state.accordion.VMS1100UPGRADE,
                        isSubAccordionOpen: state.accordion.VMS1100UPGRADE
                    }),
                    tvConnections: Object.assign({}, state.tvConnections, {
                        isAccordionOpen: state.accordion.StreamingDevice,
                        isSubAccordionOpen: state.accordion.StreamingDevice
                    }),
                    voice: Object.assign({}, state.voice, {
                        isAccordionOpen: state.parentAccordian.AddVoiceMain,
                        isSubAccordionOpen: state.accordion.AddVoiceReveal
                    }),
                    perks: Object.assign({}, state.perks, {
                        isAccordionOpen: !state?.perkSectionAutoScroll ? true : state.parentAccordian.AddPerksMain
                    }),
                    intlCalling: Object.assign({}, state.intlCalling, {
                        isAccordionOpen: state.parentAccordian.AddVoiceMain,
                        isSubAccordionOpen: state.accordion.FVINTLPLANCHANGE
                    }),
                    // focusAccordion:  focusAccStatus,
                    planCalled: focusAccStatus
                })
            }
        case 'VIEW_DETAILS_AEM_UPDATE':
            let viewDetailsObj = Object.assign({}, state.viewDetails, {
                DAT: action.value && action.value.DAT ? action.value.DAT : state.viewDetails.DAT,
                VID: action.value && action.value.VID ? action.value.VID : state.viewDetails.VID,
                FDV: action.value && action.value.FDV ? action.value.FDV : state.viewDetails.FDV,
            })
            return Object.assign({}, state, {
                viewDetails: viewDetailsObj
            })
        case "SWEETNER_UPDATE":
            let profileRouter = state.router.equipments?.filter(each=>each.isprdOnProfile)
            let selectedSweetnerMsg = state.sweetnerReducer[`${action.value}`]
            if(selectedSweetnerMsg){
            if(action.value!=="tv" && action.value!=='router' && action.value!=='fttd' && action.value!=='fttpd' && selectedSweetnerMsg){
                if(!action.isChecked){
                    selectedSweetnerMsg.visible = true
                    }else{
                    selectedSweetnerMsg.visible = false
                }
            }
            if(action.value==='router'){
                    selectedSweetnerMsg.visible = action.showRouterBanner
                    selectedSweetnerMsg.autoAdd = action.autoAdd
                if(action.autoAdd){
                if(action.product &&
                 ((action.product.productKeyword || action.product.keyword).includes('|2G|'))
                  ||  ((state.internet.selectedProduct.productKeyword || state.internet.selectedProduct.keyword).includes('|2G|') && (action.product.productKeyword || action.product.keyword).includes('|WHW|')))
                 {
                    if(profileRouter && profileRouter.length>0 && profileRouter[0].keyword.includes('|WHW|')){
                       if((state.router.selectedProduct && state.router.selectedProduct.keyword.includes('|CHR|')
                       &&state.router.selectedProduct &&state.router.selectedProduct.keyword.includes('|WHW|')
                       &&state.router.selectedProduct && !state.router.selectedProduct.keyword.includes('AUTOADDEXTENDER:R0840'))){
                        selectedSweetnerMsg.profileWhwReplaceChrRouterWhw = true
                        selectedSweetnerMsg.visible = true

                       }
                    }
                    if(profileRouter && profileRouter.length>0 && profileRouter[0].keyword.includes('|BHRX|')){
                        if((state.router.selectedProduct && state.router.selectedProduct.keyword.includes('|CHR|')
                        &&state.router.selectedProduct &&state.router.selectedProduct.keyword.includes('|WHW|'))
                        &&state.router.selectedProduct && !state.router.selectedProduct.keyword.includes('AUTOADDEXTENDER:R0840')){
                            selectedSweetnerMsg.profileBhrxReplaceChrRouterWhw = true
                           selectedSweetnerMsg.visible = true

                        }
                    }
                }else{
                    selectedSweetnerMsg.profileWhwReplaceChrRouterWhw = false
                    selectedSweetnerMsg.profileBhrxReplaceChrRouterWhw = false
                    selectedSweetnerMsg.visible = action.showRouterBanner

                }
            }
            }
            if(action.value === 'fttp_bolton'){
                selectedSweetnerMsg.visible = true;
            }

            if(action.value === "vroom"){
                if(action.showVroomBanner){
                selectedSweetnerMsg.visible=true
                }else{
                selectedSweetnerMsg.visible=false

                }
            }
            if(action.value==='fttpd'){
                if(action.showWhWbanner && action.showCloudbanner){
                    state.sweetnerReducer.whwRouterChange.visible = true
                    state.sweetnerReducer.whwplusRouterChange.visible = false
                    state.sweetnerReducer.discCloudChange.visible = true
                    selectedSweetnerMsg.visible = true
                }
                else if(action.showWhWplusbanner && action.showCloudbanner){
                    state.sweetnerReducer.whwRouterChange.visible = false
                    state.sweetnerReducer.whwplusRouterChange.visible = true
                    state.sweetnerReducer.discCloudChange.visible = true
                    selectedSweetnerMsg.visible = true
                }
                else if(action.showWhWbanner) {
                    state.sweetnerReducer.whwRouterChange.visible = true
                    state.sweetnerReducer.whwplusRouterChange.visible = false
                    state.sweetnerReducer.discCloudChange.visible = false
                    selectedSweetnerMsg.visible = true
                }
                else if(action.showWhWplusbanner) {
                    state.sweetnerReducer.whwplusRouterChange.visible = true
                    state.sweetnerReducer.whwRouterChange.visible = false
                    state.sweetnerReducer.discCloudChange.visible = false
                    selectedSweetnerMsg.visible = true
                }
                else if(action.showCloudbanner) {
                    state.sweetnerReducer.whwRouterChange.visible = false
                    state.sweetnerReducer.discCloudChange.visible = true
                    selectedSweetnerMsg.visible = true

                }else{
                    state.sweetnerReducer.whwRouterChange.visible = false
                    state.sweetnerReducer.discCloudChange.visible = false
                    state.sweetnerReducer.whwplusRouterChange.visible = false
                    selectedSweetnerMsg.visible = false
                }
            }
            // if(action.value === "fne"){
            //     if(action.isFneOnProfile){
            //     selectedSweetnerMsg.visible=true
            //     }else{
            //     selectedSweetnerMsg.visible=false

            //     }
            // }
            if((action.value!=="vroom" || action.value!=="tv") && action.product?.isprdOnProfile && selectedSweetnerMsg){
                selectedSweetnerMsg.visible=false
            }

            if(action.value==="tv"){
                if(action.tvDisconnect){
                    selectedSweetnerMsg.header=selectedSweetnerMsg.headerFD
                    selectedSweetnerMsg.visible = true

                }else if(!action.tvDisconnect && action.product?.isprdOnProfile){
                    selectedSweetnerMsg.visible = false
                    selectedSweetnerMsg.header=selectedSweetnerMsg.header
                    state.sweetnerReducer.vroom.visible=false;
                    state.sweetnerReducer.dvr.visible=false;

                }else{
                    selectedSweetnerMsg.header=selectedSweetnerMsg.headerPD
                    selectedSweetnerMsg.visible = false


                }
            }
            return Object.assign({}, state, {
                sweetnerReducer: Object.assign({}, state.sweetnerReducer, {
                    selectedSweetnerMsg


        })
    })
     }
    case "CLASSIC_ACCOUNT_CHECK":
        return Object.assign({}, state, {
            isClassicAccount: action?.value?.classicAccount || false
        })
    case "SAVE_MON_ID":
        return Object.assign({}, state, {
            monId: action?.value
        })
    case "SAVE_CUSTOMER_ADDRESS":
            return Object.assign({}, state, {
                customerAddress: action?.value
            })
            case "SET_WIFI_BACKUP_STATUS":
                return Object.assign({}, state, {
                    wifiBackupStatus: action?.value
                })
    case "SAVE_FWA_STATE":
            return Object.assign({}, state, {
                fwaState: action?.value
            })
    case "SAVE_SHALL_ACCOUNT_NUMBER":
        return Object.assign({}, state, {
            shallAccountNumber: action?.value
        })
    case "UTD_NEWRECOMM_MSG":
        let utdNewMsg = Object.assign({}, state.tv, {
            utdNewRecommMsg: action.value
        })
        return Object.assign({}, state, {
            tv: utdNewMsg
        })
    case "DISPLAY_PENDING_PRODUCTS":
        let notificationProds = Object.assign({}, state.pendingProdNotification, {
            displaySpecificErrorMessages : action.value
        })
        return Object.assign({}, state, {
            pendingProdNotification: notificationProds
        })

    case 'IS_CEAPPS_ONCSR' :
        let profileceapp = Object.assign({}, state.ceApps, {
            isCeappOnCsr: action.value
        })
        return Object.assign({}, state, {
            ceApps: profileceapp })
    case "IntrOverlayProducts":
        let lanpackage = Object.assign({}, state.internationalChannel, {
            overlayLanguagePkg : action.value
        })
        return Object.assign({}, state, {
            internationalChannel: lanpackage
        })

    case 'OTTBASIC_REMOVEDPROD':
        let removeStreamServ = Object.assign({}, state.streamServ, {
            removedProduct: action.value

        })
        return Object.assign({}, state, {
            streamServ: removeStreamServ,
            tv: Object.assign({}, state.tv, {
                isAccordionOpen: false
            })
        })
    case 'PERKS_REMOVEDPROD':
    let removePerks = Object.assign({}, state.perks, {
        removedProduct: action.value

    })
    return Object.assign({}, state, {
        perks: removePerks,
    })
    case 'IS_SLING_ONCSR':
        let profilesling = Object.assign({}, state.streamServ, {
            isSlingOnCsr: action.value
        })
        return Object.assign({}, state, {
            streamServ: profilesling
    })
    case 'HANDLE_EC_HEADER':
        return {
            ...state,
            isEcHeaderVisible: action.payload,
        }
    case 'INTERNATIONAL_REMOVEDPROD':
        let removeintrnlChannel = Object.assign({}, state.internationalChannel, {
            removedProduct: action.value

        })
        return Object.assign({}, state, {
            internationalChannel: removeintrnlChannel,
    })
    case 'SHOW_CONNECTED_APPS_EXP':
        return {
            ...state,
            showConnectedApps: action.value,
        }
    case 'CEAPPS_FOR_SCFLOWS':
        return {
                ...state,
                isCEAppsSetForSCFlow: action.value,
        }
    case 'PERKS_FOR_SCFLOWS':
        return {
                ...state,
                isDataPerksSetForSCFlow: action.value,
        }
        case 'VALIDATE_PERKS_FOR_SCFLOWS':
            return {
                    ...state,
                validatePerksForSCFlows: action.value,
            }
    case 'VMS_FOR_SCFLOWS':
        return {
                ...state,
                isVMSSetForSCFlow: action.value,
            }
    case 'INTLCALLINGPRODUCT_FOR_SCFLOW':
            return {
                    ...state,
                    isIntlCallingProductSetForSCFlow: action.value,
        }
    case 'SHOW_CONNECTED_APPS_VROOM_OVERLAY':
        return {
            ...state,
            showConnectedAppsVRoomOverlay: action.value,
        }
    case 'SHOW_CONNECTED_APPS_CEAPPS_OVERLAY':
        return {
            ...state,
            showConnectedAppsCEAppsOverlay: action.value,
        }
    case  'SHOW_CONNECTIONS_CHOICES':
        return Object.assign({}, state, {
            showConnectionsChoices: action.value
        })
    case  'MOVES_SLINGONPROFILE':
        return Object.assign({}, state, {
            slingonProfileMoves: action.value
        })
    case  'MOVES_SLINGNOTINPROFILE':
        return Object.assign({}, state, {
            slingnotinprofile: action.value
        })
    case 'MNH_SUPPRESSINTERSTITIAL':
        return Object.assign({}, state, {
            suppressInterstitial: action.value
                })
    case 'MNH_SUPPRESSINVOKE':
        return Object.assign({}, state, {
            suppressInvoke: action.value
                })
    case 'MNH_UPSELL_BANNER':
        return Object.assign({}, state, {
            upsellBanner: action.value
                })
    case 'UPDATE_VAS_PRODS_WITH_KEY':
        return Object.assign({}, state, { techsure: { ...state.techsure, disconnectedProducts: action.value } });
    case 'SET_PROFILE_DUMMY_VROOM' :
        let profileconnection = Object.assign({}, state.tvConnections, {
            profileDummyVRoom: action.value
        })
        return Object.assign({}, state, {
            tvConnections: profileconnection })
    case 'SET_CUSTOMTV_PACKAGE_STATUS' :
        let customTVStatus = Object.assign({}, state.tv.customTV, {
            changePackage: action.value,
            isAccordionOpen: action.value
        })
        let updatedCustTv = Object.assign({}, state.tv, {
            customTV: customTVStatus,
            isAccordionOpen: action.value,
            isSubAccordionOpen: !(action.value)
        })
        return Object.assign({}, state, {
            tv: updatedCustTv
        })
    case 'SET_WHOLE_WIFI_STATUS' :
        let updatedfne = Object.assign({}, state.fne, {
            isWholeHomeWifiAdded: action.value === null ? false : action.value
        })
        return Object.assign({}, state, {
            fne: updatedfne
        })
    case 'SET_WHOLE_WIFIPLUS_STATUS' :
        let updatedWHWPlus = Object.assign({}, state.fne, {
            isWholeHomeWifiPlusAdded: action.value === null ? false : action.value
        })
        return Object.assign({}, state, {
            fne: updatedWHWPlus
        })
    case 'SET_WHOLE_WIFIPLUS2_STATUS' :
        let updatedWHW2 = Object.assign({}, state.fne, {
            isWholeHomeWifi2Added: action.value === null ? false : action.value
        })
        return Object.assign({}, state, {
            fne: updatedWHW2
        })
    case 'SET_UNIT_COUNT' :
        let fnecount = Object.assign({}, state.fne, {
            unitCount: action.value
        })
        let selectedWifiSweetnerMsg = Object.assign({}, state.sweetnerReducer.fneWifi, {
            visible: ((action.value)) > 0 ? true: false
        })
        let updateSweetner = Object.assign({}, state.sweetnerReducer, {
            fneWifi: selectedWifiSweetnerMsg
        })
        return Object.assign({}, state, {
            fne: fnecount,
            sweetnerReducer: updateSweetner
        })
    case 'DOMESTIC_COUNTRY_INPUT':
      return Object.assign({}, state, { intlCalling: { ...state.intlCalling, domesticCountry: action.value } });
    case 'SHOW_VIDEO_COMPARISON_EXP':
        return Object.assign({}, state, {
            enableVideoComparison: action.value
        })
    case 'UPDATE_COMPARISON_CONFIRM':
        return Object.assign({}, state, {
            showComparisonView: action.value
        })
    case 'UPDATE_PROFILE_CLOUD':
        return Object.assign({}, state, {
            profileCloudProduct: action.value
        })
    case 'MNH_OFFER_CHECK':
        return Object.assign({}, state, {
            isMnhOfferElligble: action.value
        })
    case 'DISABLE_TV_VOICE':
        return Object.assign({}, state, {
            disableTvVoice: action.value
        })
    case 'DISABLE_TV':
            return Object.assign({}, state, {
                disableTv: action.value
        })
    case 'DISABLE_VOICE':
            return Object.assign({}, state, {
                disableVoice: action.value
        })
    case 'CHR_FNE_QUALIFIED':
        return Object.assign({}, state, {
            isChrFneQualified: action.value
        })
    case "RETURN_EQUIPMENT_COUNT":
        return Object.assign({}, state, {
            returnedEquipmentCount: action.value
        })
    case "EC_PROMO_DROP_ERROR":
        return Object.assign({}, state, {
            ecPromoDropped: action.value
        })
    case "QUALFIED_SERVICES":
        return Object.assign({}, state, {
            ecQualifiedServices: action.value
        })
    case "IS_SELECTED_DATA_500_OR_400":
        return Object.assign({}, state, {
            isSelectedData500Or400: action.value
        })
    case "MM3_UPDATEOFFERS":
        let products = Object.assign({}, state.mm3internetsub, {
            offerplans : action.value
        })
        return Object.assign({}, state, {
            mm3internetsub : products
        })
    case "EXPAND_INTERNETACC_ONLOAD":
        return Object.assign({},state,{
            internet : Object.assign({},state.internet,{

                expandOnPageLoad : action.value
            })
        })

    case "TOGGLE_INTERNET_ACCR_FIOSTV":
        return Object.assign({},state,{
            internet : Object.assign({},state.internet,{
                isAccordionOpen : false
            })
        })

    case 'BF_ACCOR_EXPANSION':
        return Object.assign({},state,{
            internet: Object.assign({}, state.internet, {
                isSubAccordionOpen: state.isMNEnabled
                    ? state.sploffer.data.isAccordionOpen
                    : state.internet.isSubAccordionOpen
            }),
            flashoffer: Object.assign({}, state.flashoffer, {
                isAccordionOpen: state.flashoffer.isFlashOffer ? true : false
            }),
            router: Object.assign({}, state.router, {
                isAccordionOpen : false
                // isAccordionOpen: state.flashoffer.isFlashOffer ? false : true
            }),
            mm3internetsub: Object.assign({}, state.mm3internetsub, {
                isAccordionOpen: false
            }),
            isbfpromo: Object.assign({}, state, {
                isbfpromo: true
            })

        })

    case 'BF_PROMOS':
        return Object.assign({},state,{
            isbfpromo: Object.assign({}, state, {
                isbfpromo: true
            })
            })
    case 'CHANGE_SELECTCTASPEED':
        let selectCTAinternet = Object.assign({}, state.internet, {
            selectCtaSpeed: action.value
        })

        return Object.assign({}, state, {
            internet: selectCTAinternet
        })
    case 'UPDATE_INSTALLFEEWAIVED_ALLPLANS':
        let installFeeWaivedInternet = Object.assign({}, state.internet, {
            isInstallFeeWaivedAllPrd: action.value
        })

        return Object.assign({}, state, {
            internet: installFeeWaivedInternet
        })
    case 'UPDATEMNHDETAILS':
        return Object.assign({}, state, {
            isMnHCustomerDetail: action.value
        })

    case 'CHANGE_PLANDETAILS_STATUS':
        let plandetailsInternet = Object.assign({}, state.internet, {
            showPlanDetails: action.value
        })

        return Object.assign({}, state, {
            internet: plandetailsInternet
        })
    case 'UPDATERESKIN':
        return Object.assign({}, state, {
            isReskin: action.value
            })
    case 'UPDATE_PROGRESSBAR_STATUS':
        return Object.assign({}, state, {
            isProgressBarDisplayed: action.value
        })
    case 'UPDATE_M2MPLANS_EXPANDED':
        let tempM2M = state.internet.mobileViewInternetTileExpander;
        tempM2M[action.value] = !tempM2M[action.value];

        let tempM2MInternet = Object.assign({}, state.internet, {
            mobileViewInternetTileExpander : tempM2M
        })

        return Object.assign({}, state, {
            internet: tempM2MInternet
        })

    case 'TOGGLE_ACCORDION_15G':
        return Object.assign({}, state, {
            mm3internetsub: Object.assign({}, state.mm3internetsub, {
                isAccordionOpen: false
            }),
            router: Object.assign({}, state.router, {
                isAccordionOpen: false,
            }),
            internet: Object.assign({}, state.internet, {
                isSubAccordionOpen: false
            })
        })

    case 'UPDATE_ALL_M2MPLANS_EXPANDED':
        let prodAllMobileExpand = state.internet.mobileViewInternetTileExpander

        Object.keys(prodAllMobileExpand).forEach(key=>{
            prodAllMobileExpand[key] = true;
        })

        let allM2MInternet = Object.assign({}, state.internet, {
            mobileViewInternetTileExpander : prodAllMobileExpand
        })

        return Object.assign({}, state, {
            internet: allM2MInternet
        })
    case "SET_GIG_BADGE_MESSAGE":
        return Object.assign({}, state, {
            internet : Object.assign({}, state.internet,{
                gigTileMessage : action.value
            })
        })
    case "EC_MNH_RESPONSE":
        return Object.assign({}, state, {
            mnhResponse: action.value
        })
    case "SET_2Gig_NOT_ALLOWED_MESSAGE":
        return Object.assign({}, state, {
            TwoGigNotAllowedMessage: action.value
        })
    case "PREMIUMOFFERQUALIFIED":
        return Object.assign({}, state, {
            tv: Object.assign({}, state.tv, {
                premiumQualified: action.value
            })
        })
    case "INTERNATIONAL_CALLING_ENABLE":
        return Object.assign({}, state, {
            internationalCallingEnable: action.value
        })
    case "UPDATE_MNH_DETAILS":
        return Object.assign({}, state, {
            mnhMobileNumber : action.value.mtn,
            mnhZip : action.value.zip
        })
    case "UPDATE_MNH_TOKEN_GENERATION_RESPONSE":
        return Object.assign({}, state, {
            mnhTokenGenerationResponse : action.value
        })
    case 'MNH_IG_VERIFICATION_START':
        return Object.assign({}, state, {
            igVerificationInitialed : action.value
        })
    case 'ENABLE_MNH_VERIFY_BUTTON':
        return Object.assign({}, state, {
            verifyButtonMnhStatus : action.value
        })
    case 'UPDATE_MNH_VERIFICATION_CODE':
        return Object.assign({}, state, {
            mhVerificationCode : action.value
        })
    case 'SET_MNH_STATUS':
        return Object.assign({}, state, {
            mnhStatus : action.value
        })
    case "SET_MNH_BANNER_STATUS":
        return Object.assign({}, state, {
            mnhBannerStatus: action.value,
        });
    case 'UPDATECHANNELSTATUS':
        return Object.assign({}, state, {
            channel: Object.assign({}, state.channel, {
                accordionStatus: action.value
            })
        })
    case 'UPDATE_OFFER_INDICATOR':
        return Object.assign({}, state, {
            offerIndicator : action.value
        })
    case 'NFL_ACTIVE_ON_PROFILE' :
        return Object.assign({}, state, {
            internet : Object.assign({}, state.internet,{
                nflActiveOnProfile : action.value
            })
        })
    case 'UPDATE_PROMO_KEYWORD_FLOW':
        return Object.assign({}, state, {
            isPromoKeywordFlow : action.value
        })
    case 'FCC_LABEL_INFO':
        return Object.assign({}, state, {
            fccLabelInfo: action.value
        })
    case 'FCC_GRAND_FATHERED_LABEL_INFO':
        return Object.assign({}, state, {
            fccGrandFatheredLabelInfo: action.value
        })
    case 'SET_ACP_STATUS':
        return Object.assign({}, state, {
            isACPFlag : action.value
        })
    case 'UPDATE_MNH_BANNER_FLAG':
        return Object.assign({}, state, {
            mnhBannerFlag : action.value
        })
    case 'UPDATE_RESKIN_CART_FLAG':
        return Object.assign({}, state, {
            reskinCartFlag : action.value
        })
    case 'SET_TWS_STATUS':
        return Object.assign({}, state, {
            isTWSFlag : action.value
        })
    case 'SET_TWS_INELIGIBLE_FLOW':
           return Object.assign({}, state, {
            isTWSIneligibleFlow: action.value
        })
        
    // case 'ENABLE_ORDERSUM_THROTTLE':
    //     return Object.assign({}, state, {
    //         enableOrderSumThrottle : action.value
    //     })
    case 'ENABLE_STICKYHEADER_THROTTLE':
        return Object.assign({}, state, {
            stickyheaderfooter : action.value
        })
    case 'ENABLE_MOVES_STICKYHEADER_THROTTLE':
        return Object.assign({}, state, {
            movesstickyheaderfooter : action.value
        })
    case 'ENABLE_MOVES_UPSELL_PERKSOVERLAY':
        return Object.assign({}, state, {
            enableMovePerksOverlay : action.value
        })
    case 'ENABLE_ROOMMATE_SCENERIO_OSI':
        return Object.assign({}, state, {
              enableRoommateScenerioOnOSI: action.value
        })
    case 'ROOMMATE_OPTION_SELECTED':
         return Object.assign({}, state, {
            roommateOptionSelected: action.value
        })
    case 'ROOMMATE_ERROR_CASE':
          return Object.assign({}, state, {
            roommateErrorCase: action.value
       })
        

    // case 'ENABLE_MOVES_ORDERSUMMARY_THROTTLE':
    //         return Object.assign({}, state, {
    //             movesordersummary: action.value
    //     })

    // case 'ENABLE_MOVES_MINICART_THROTTLE':
    //         return Object.assign({}, state, {
    //             movesminicart: action.value
    //     })

    case 'ENABLE_AUTOPAY_THROTTLE':
        return Object.assign({}, state, {
            enableAuotpayThrottle : action.value
        })

    case 'ENABLE_AUTOPAY_OPTTHROTTLE':
        return Object.assign({}, state, {
            enableAutopayOptThrottle : action.value
        })
    case 'NSA_THROTTLELIST_RESPONSE':
           return Object.assign({}, state, {
            nsaThrottleResponse: action.value
       })

    case 'ENABLE_STICKYPROGRESSBAR_THROTTLE':
        return Object.assign({}, state, {
            stickyProgressbar : action.value
        })
    case 'ENABLE_SAVECART_STICKY_MOBILE':
        return Object.assign({}, state, {
             enableSaveCartStickyMobile : action.value
        })
    case 'DEFAULT_CEAPPS_RESPONSE':
        return Object.assign({}, state, {
            defaultCeApps: action.value.ceApps
        })
    case 'UPDATE_TILES_ORDER_FLAG':
        return Object.assign({}, state, {
            tilesOrderDesignFlag : action.value,
    })
    case 'ON_CLICK_CONTINUE_BUTTON':
        return Object.assign({}, state, {
            orderSumFlag : action.value,
    })

    case 'ON_CLICK_MINICART_ORDER_BUTTON':
        return Object.assign({}, state, {
            miniCartOrderSumFlag : action.value,
    })

    case 'FCC_PEGA_DATA':
        return Object.assign({}, state, {
            fccDataPega : action.value,
    })
    case 'UPDATE_ACCORDION_FLAG':
        return Object.assign({}, state, {
            internetAccordionFlag : action.value,
            internet: action.value === 'A' || action.value === 'B' ? { ...state.internet, isSubAccordionOpen: action.value === 'A' ? true : false ,  isAccordionOpen: action.value === "" ? state.internet.isAccordionOpen : true  } : {...state.internet},
            techsure: action.value === 'A' || action.value === 'B' ? { ...state.techsure, isAccordionOpen: true } : {...state.techsure},
            router: action.value === 'A' || action.value === 'B'  ? { ...state.router, isAccordionOpen: false } : {...state.router},
            fne: action.value === 'A' || action.value === 'B'  ? { ...state.fne, isAccordionOpen: false } : {...state.fne},
            techsurecloud: action.value === 'A' || action.value === 'B'  ? { ...state.techsurecloud, isAccordionOpen: false } : {...state.techsurecloud},
    })
    case 'FCC-LEARN_ADD_VALUE':
        return Object.assign({}, state, {
            fccLearnData : action.value,
    })
    case 'IDLE_MODAL_BANNER':
        return Object.assign({}, state, {
            //idleModalBanner: action.value
            saveTheSale:Object.assign({}, state.saveTheSale, {
                idleModalBanner: action.value
            }),
    })
    case 'OFFER_APPLIED':
        return Object.assign({}, state, {
            //offerApplied : action.value
            saveTheSale:Object.assign({}, state.saveTheSale, {
                offerApplied: action.value
            }),
    })
    case 'IDLE_TIMEOUT':
        return Object.assign({}, state, {
            //idleTimeOut : action.value
            saveTheSale:Object.assign({}, state.saveTheSale, {
                idleTimeOut: action.value
            }),
    })
    case 'MODAL_OPEN_COUNT':
        return Object.assign({}, state, {
            //modalOpenCounter : action.value,
            saveTheSale:Object.assign({}, state.saveTheSale, {
                modalOpenCounter: action?.value
            }),
    })
    case 'SAVE_THE_SALE_MODAL':
        return Object.assign({}, state, {
            //modalOpenCounter : action.value,
            saveTheSale:Object.assign({}, state.saveTheSale, {
                modalOpen: action.value
            }),
    })
    case 'SET_VZF_STATUS':
        return Object.assign({}, state, {
            isVZFwdFlag : action.value
    })
    case 'SET_RC_STREAMLINE':
        return Object.assign({}, state, {
            isStreamlineRC : action.value
    })
    case 'SET_VZFWD_ID':
        return Object.assign({}, state, {
            vzFwdId : action.value
    })
    case 'SET_VZF_CREDIT_STATUS':
        return Object.assign({}, state, {
            isVZFCreditFlag : action.value
    })
    case 'SET_VZF_NY_DISCOUNT':
        return Object.assign({}, state, {
            isVzfNYDiscount : action.value
    })
    case 'UPDATE_MN_API':
        return Object.assign({}, state,{
            mnFromApi : action.value
    })
    case 'CLASSIC_MODAL_OPEN':
        return Object.assign({}, state, {
            openclassicmodal : action?.value?.modal,
            ClassicHOOverlayCount: action?.value?.ClassicHOOverlayCount ,
            buttonName : action.value.buttonName
    })
    case 'UPDATE_BPP_SIGNIN_VALUE':
        return Object.assign({}, state, {
            bppPageSignIn : action.value
        })
    case 'ENABLE_MONARCH_VIEW':
        return Object.assign({}, state, {
          isMonarchView: action.value
        })
    case 'UPDATE_SAVETHESALE_OFFER':
    return Object.assign({}, state, {
        saveTheSale: action.value
    })
    case 'UPDATE_TVACCORDION_TEST_FLAG':
        return Object.assign({}, state, {
            tv : (action.value === 'TestA' || action.value === 'TestB') ? Object.assign({}, state.tv, { isAccordionOpen: true, isSubAccordionOpen: true }) : {...state.tv},
            isExpandAccordion : action.value
        })
    case 'UPDATE_PERKS_ADDL_INFO':
        return Object.assign({}, state, {
            perksAddlInfo: action.value
        })
    case 'SCROLL_TO_PERKS_SECTION':
        return Object.assign({}, state, {
            togglePerkEc: action.value
        })
    case 'SCROLL_TO_PERKS_SECTION_DEEPLINK':
        return Object.assign({}, state, {
            perkSectionAutoScroll: action.value
        })
    case 'NEW_REVIEW_ORDER_SECTION':
        return Object.assign({}, state, {
            newReviewOrderView: action.value
        })
    case 'ENABLE_NEW_MINI_CART':
        return Object.assign({}, state, {
            enableNewMiniCart: action.value
    })
    case "TOGGLE_INTERNET_ORDERPERKS_YOUTUBE_PREMIUM":
        return Object.assign({}, state, {
            internetToggleYoutubePremium: action.value,
        });
    case 'TOGGLE_INTERNET_ORDERPERKS_ACCOR':
    return Object.assign({}, state,{
        internetTooglePerks : action.value,
        internet: Object.assign({}, state.internet, {
            isAccordionOpen: action.value,
            isSubAccordionOpen: false
        }),
        tv: Object.assign({}, state.tv, {
            isAccordionOpen: false
        }),
        voice: Object.assign({}, state.voice, {
            isAccordionOpen: false
        }),
        perks: Object.assign({}, state.perks, {
            isAccordionOpen: action.value,
            isAddPerksOSI : action.value
        }),
    })
    case 'TOGGLE_INTERNET_MOVES_ACCOR':
    return Object.assign({}, state,{
        internetToogleMoves : action.value,
        internet: Object.assign({}, state.internet, {
            isAccordionOpen: false,
            isSubAccordionOpen: false
        }),
        tv: Object.assign({}, state.tv, {
            isAccordionOpen: false
        }),
        voice: Object.assign({}, state.voice, {
            isAccordionOpen: false
        }),
        perks: Object.assign({}, state.perks, {
            isAccordionOpen: false,
            isAddPerksOSI : false
        }),
    })
    case 'TOGGLE_INTERNET_ORDERPERKS_UPDATESTATE':
        return Object.assign({}, state,{
            internetTooglePerks : action.value,
        })

    case 'DISNEY_PROMO_PRESENT' :
        return Object.assign({}, state, {
            isDisneyPromoPresent: action.value
        })
    case 'NETMAX_PROMO_PRESENT' :
        return Object.assign({}, state, {
            isNetmaxPromoEligible: action.value
        })
    case 'UPDATE_PROMO_PRESENT' :
        return { ...state, 
            isDisneyPromoPresent: action.value.isDisneyPromoPresent,
            isNetmaxPromoEligible: action.value.isNetmaxPromoEligible
         };
    case 'SET_CLOUD_STEP_DOWN':
        return Object.assign({}, state, {
            isCloudStepDownEnabled: action.value
        });
    case 'UPDATE_PERK_OVERLAY_VALUE':
        return Object.assign({}, state, {
            isCheckoutPerksModal : action.value
        });
    case 'SET_VOICE_ACCOR':
        return Object.assign({}, state, {
            voice: Object.assign({}, state.voice, {
                isAccordionOpen: action.value === true ? true : false,
            }),
        });
    case "SET_IWM_ELIGIBLE":
        return Object.assign({}, state, {
            isIwmEligible: action.value,
        });
    case "SET_MNTILE_STYLES":
        return Object.assign({}, state, {
            mnTileStyles: action.value,
        });
    case 'SET_SPL_PROMO_OFFERS_LIST': {
        return Object.assign({}, state, {
            splPromoOffersList: replaceSpecialOffers(action.value, state.internet.selectedProduct)
        })
    }
    case 'SET_POPULAR_REDIRECT_FLAG': {
        return Object.assign({}, state, {
            isRedirectionFromPopular: action.value
        })
    }
    case 'SET_POPULAR_REDIRECT_PROGRESSBAR_FLAG': {
        return Object.assign({}, state, {
            isRedirectionToPopular: action.value
        })
    }
    case 'SET_EMBER_INFO':{
        let emberInfoObj = Object.assign({}, state.emberInfo, {
            isMF4MRKF15: action.value && action.value.isMF4MRKF15 ? action.value.isMF4MRKF15 : state.emberInfo.isMF4MRKF15,
            isMF4DISC15: action.value && action.value.isMF4DISC15 ? action.value.isMF4DISC15 : state.emberInfo.isMF4DISC15,
            isEmberFlow: action.value && action.value.isEmberFlow ? action.value.isEmberFlow : state.emberInfo.isEmberFlow,
        })
        return Object.assign({}, state, {
            emberInfo: emberInfoObj
        })
    }
    case "HIDE_EMBER": {
        let emberInfoObj = Object.assign({}, state.emberInfo, {
            hideEmber: action.value,
        });
        return Object.assign({}, state, {
            emberInfo: emberInfoObj
        });
    }
    case 'SET_DISNEY_TRIO': {
        return Object.assign({}, state, {
            isDisneyTrioPerkPresent: action.value
        })
    }
    case 'SET_UPSELL_TAG_LIMIT_FLAG': {
        return Object.assign({}, state, {
            upsellTagLimitFlag: action.value
        })
    }
    case 'SET_RESUME_CART_FLOW': {
        return Object.assign({}, state, {
            isResumecartFlow: action.value
        })
    }
    case 'SHOW_NOTIFICATION_CEAPPS': {
        return Object.assign({}, state, {
            showRedCapForCeApp: action.value
        })
    }
    case 'SET_FOOTER_MESSAGE':{
        return Object.assign({}, state, {
            footerMessage: action.value
        })
    }
    // case "REPLACE_M2M_SPLOFFER": {
    //     const actionId = action?.value?.id;
    //     const actionOfferText = action?.value?.OfferText;
    //     const m2mPlansNew = state.internet.m2mPlans.map(plan => {
    //         if (Array.isArray(plan?.specialOffers)) {
    //             const actionSpecialOffer = plan?.specialOffers?.find(o => o?.id === actionId && o?.OfferText !== actionOfferText);
    //             if (actionSpecialOffer) {
    //                 return {
    //                     ...plan,
    //                     OfferText: actionOfferText,
    //                 };
    //             }
    //         }
    //         return plan;
    //     });
    //     return Object.assign({}, state, {
    //         internet: Object.assign({}, state.internet, {
    //             m2mPlans: m2mPlansNew,
    //         }),
    //     });
    // }
    case "SET_MANUAL_ACCORDION_OPEN":
        return Object.assign({}, state, {
            manualAccordionOpen: action.value,
        })
    case "SET_STREAMLINE_PERK_REDESIGN":
            return Object.assign({}, state, {
              enablePerkRedesign: action.value,
            })
    case "PERK_SECTION_ENABLED":
        return Object.assign({}, state, {
            isPerksSectionEnabled: action.value,
        })
    case "UPDATE_REC_PROFILE_FLAG":
        return Object.assign({}, state, {
            recorProfileFlag: action.value,
        })
    case "UPDATE_WIRELESS_LOGGEDIN_STATUS":
        return Object.assign({}, state, {
            wirelessLoggedInStatus: action.value,
        })
    case "Update_PerkRecommendationTestFlag":
        return Object.assign({}, state, {
            perkRecommendationTestFlag: action.value, 
        })
    case "Update_PerkRecommendNotification":
        return Object.assign({}, state, {
            perkRecommendNotification: action.value, 
        })
    default:
        return state
    }
}


export default buildProduct
